import moment from 'moment';
import { ClientAPI } from '../API/client';
import { FundAPI } from '../API/fund';
import { InflationRateAPI } from '../API/inflation_rate';
import { LegislationArticleAPI } from '../API/legislation_article';
import { TransactionAPI } from '../API/transaction';
import {
    applyMaskAccount,
    applyMaskAmount,
    applyMaskAmountComdinheiro,
    applyMaskAmountComdinheiroFreeDecimals,
    applyMaskAmountFreeDecimals,
    applyMaskHideCpf,
    calcRentInSegregation,
    formatAnbimaDateToPt,
    formatPtStringDateToAnbimaDate,
    formatStringToDisplay,
    formatTargetsAndRentsToShow,
    formatTargetsToShow,
    formatTextForValidDisplay,
    getDayMonthYearByDate,
    getDayMonthYearByPtDate,
    getDayMonthYearByStringDate,
    getFirstDayMonth,
    getFirstDayYear,
    getHistoricRentFundInPortfolio,
    getInMonthRentFundInPortfolio,
    getLastDayInMonthByMonthAndYear,
    getLastPtDayOfYear,
    getMonthAgo,
    getMonthAndYearBefore,
    getMonthFundRentInMoney,
    getMonthName,
    getOperationLabel,
    getPeriodBefore,
    getPeriodRentFundInPortfolio,
    getTitleCod,
    getYearPeriod,
    getYearRentFundInPortfolio,
    groupArticlePolicys,
    groupByDistributionOptions,
    makeChartCompare,
    makeChartEvolutionPL,
    markArticlesInPortfolio,
    parseBrlCurrencyToFloat,
    parseFloatByPtCurrency,
    parsePercentage,
    portfolioClosedToDate,
    pureConsoleLog,
    sortArrayOrderBy,
    splitIn2Lines,
    stringPtDateToJsDate,
    stringPtDateToMoment,
    timeStampToPtDate,
    truncateDecimals,
    var5
} from '../components/utils/utils';
import { ACCOUNT_REGIME, getRegimeOptions, REGIME_LABELS, REGIME_UPPER_LABELS } from '../components/utils/accountRegimes';
import { formatBalancesAssetsValidationToShow, getAssetInfos, getSegmentIdsByKeys, getSegmentKeyByValue, getSimpleNormalizedAssets, organizeAssetsAndTransactions, SEGMENT_CODS_AND_IDS, SEGMENT_CODS_AND_LABELS } from './AssetsController';
import { doGetBalancesAssetsByPeriod, formatBalancesRentsByRange, loadClientDiaryByRange, loadClientDiaryPlsByLimit, loadClientRentsBySegment, loadClientRentsBySegregation } from './ClientController';
import { doGetFundsClientByPeriodRent, formatMyFundsToShow, getFundsDemonstrative } from './FundController';

import _ from 'lodash';
import {
    BalancesValidationsAPI
} from '../API/balances_validations';
import { REQ_COMDINHEIRO_TYPE } from '../API/reqs_comdinheiro';
import { disponibilizationDicionary } from '../components/utils/dicionarys';
import { checkFinalLabelDistribuitionTable, distributionOptionClassification, isOptionValidToJustTwoWords, order } from '../components/utils/distribution';
import { MARKING_MARKET, getWeightedMarkingAverage } from '../components/utils/paramsToTitles';
import { doGetDisponibilityAccountsByPeriod, doGetDisponilityByMonthAndYear, formatBalancesAccountsValidationToShow } from './AccountController';
import { doGetCDI, doGetIGPM, doGetIPCAdp, doGetPU_med, doSelicMeta, getCotasByListCnpjs } from './ComdinheiroController';
import { fillLocalInfosByMonthAndYear, getClientJsonQuotas } from './FundLocalQuotasController';
import { GENERIC_ASSETS, GENERIC_ASSET_CONSIG, GENERIC_ASSET_TITLES_TYPE, PRIVATE_TITLES, PUBLIC_TITLES, formatInfosToShow, getAnaliticTitlesByPeriod, getDueDateTitle, getRentInMoneyMonthTitle, isConsigTitle, isGenericTitle, isPrivateCdiTitle, isPrivateIpcaTitle, isPrivatePreFixedTitle } from './TitleController';

//Import excel
import XLSX from 'xlsx';
import { AccountAPI } from '../API/account';
import { FundLocalQuotasAPI } from '../API/fund_local_quotas';
import { TitleAPI } from '../API/title';
import { downloadBlob, s2ab } from "../controllers/ExcelController";

//Zip
import JSZip from 'jszip';
import { SuitabilitiesAPI } from '../API/suitabilities';
import { unoTheme } from '../assets/styles/unoTheme';

const { device } = distributionOptionClassification;

//Valor exibido quando não há dado de rentabilidade para o período
export const NO_DATA_LABEL = '-';

/**
 * Aplica a máscara somente quando o valor é um número válido.
 * Evita que applyMaskAmount transforme '-'/undefined/NaN no literal "NaN".
 */
export const maskAmountOrDash = (value, withCifra, suffix = '') => {
    return Number.isFinite(value) ? applyMaskAmount(value, withCifra) + suffix : NO_DATA_LABEL;
}

/**
 * Converte uma string já mascarada que contenha "NaN" em "-"
 */
export const formatNaN = (probablyNan) => {
    if (typeof probablyNan !== 'string') return NO_DATA_LABEL;
    if (probablyNan.includes("NaN")) {
        return NO_DATA_LABEL;
    }
    return probablyNan;
}

//======================= DEBUG DE RENTABILIDADE (temporário) =======================
//Investigação da divergência entre o % (motor de cota) e o R$ (motor de saldo) nas colunas
//de ano dos retornos por ativo e na Carteira de período (anual/trimestral/semestral).
//Desligado por padrão: só imprime quando o alvo é escolhido no console com
//window.__RENT_DEBUG = 'nome do fundo' | 'cnpj' | fund_id (null volta a desligar).
const RENT_DEBUG_DEFAULT_FILTER = 'IT NOW';

const getRentDebugFilter = () => {
    if (typeof window === 'undefined') return null;
    return window.__RENT_DEBUG === undefined ? RENT_DEBUG_DEFAULT_FILTER : window.__RENT_DEBUG;
}

export const matchRentDebug = (asset) => {

    const filter = getRentDebugFilter();
    if (!filter || !asset) return false;

    const needle = String(filter).toUpperCase();

    return [asset.fund_name, asset.cnpj, asset.fund_id, asset.id]
        .some(value => value != null && String(value).toUpperCase().includes(needle));
}

export const rentDebugReset = () => {
    if (typeof window === 'undefined' || !getRentDebugFilter()) return;
    window.__rentDebug = { blocks: [], monthEngine: [], rows: [], transactions: [] };
}

const rentDebugPush = (bucket, payload) => {

    if (typeof window === 'undefined') return payload;

    if (!window.__rentDebug) rentDebugReset();
    if (!window.__rentDebug) return payload;

    if (!window.__rentDebug[bucket]) window.__rentDebug[bucket] = [];
    window.__rentDebug[bucket].push(payload);

    return payload;
}

const lastOf = (array) => Array.isArray(array) && array.length ? array[array.length - 1] : null;

/**
 * Uma linha por período do integralFundsBalancesMap, com as duas pontas do cálculo lado a lado:
 * rentMoney (saldo) e rent (cota), mais os insumos de cada uma.
 */
const rentDebugPeriodRows = (periodsFund) => Object.entries(periodsFund ?? {})
    .filter(([key]) => key.includes("__"))
    .map(([key, periodRent]) => {

        const avgQuota = lastOf(periodRent.average_quota_now)?.averageQuotaInMonth;
        const ultimaCota = lastOf(periodRent.quotas_anbima)?.valor_cota;
        const nAverageQuotas = periodRent.average_quota_now?.length;

        //Espelha helper.controller.js:1099. NaN aqui é o suspeito principal: por ser falsy, o
        //ternário de helper.controller.js:1115 cai no ramo SEM compensação de amortização, e a
        //queda de cota causada pela amortização é contabilizada como perda cheia no %.
        const amortizationByQuota = periodRent.totalAmortizationAmount
            ? periodRent.totalAmortizationAmount / periodRent.qtdQuotasOnAmortization
            : undefined;

        //Recálculo local do % do mês nas duas versões, para provar numericamente se o que falta
        //é o crédito da amortização
        const rentDeCota = (numerador) => Number.isFinite(numerador) && Number.isFinite(avgQuota) && avgQuota != 0
            ? ((numerador / avgQuota) - 1) * 100
            : null;

        return {
            period: periodRent.period ?? key.split("__")[1],
            balance_before: periodRent.balance_before,
            balance_now: periodRent.balance_now,
            aplicacoes: periodRent.totalApplicationsAmount,
            resgates: periodRent.totalRescuesAmount,
            amortizacoes: periodRent.totalAmortizationAmount,
            rentMoney: periodRent.rentMoney,
            rent: periodRent.rent,
            //Espelha o filtro do produtório do backend (client.controller.js, rentsByPeriod):
            //mês fora dele soma no R$ e não soma no %
            entrouNoAcum: Number.isFinite(periodRent.rent) && periodRent.rent != 0,
            temCotaMedia: !!periodRent.average_quota_now,
            avgQuota: avgQuota,
            ultimaCota: ultimaCota,
            qtdQuotasOnAmortization: periodRent.qtdQuotasOnAmortization,
            is_poupanca: periodRent.is_poupanca,

            //--- Qual ramo do motor de cota rodou (helper.controller.js:1084 vs :1129):
            //'single' aplica a compensação de amortização, 'capAverageQuota' NÃO aplica nenhuma
            nAverageQuotas: nAverageQuotas,
            ramoDoMotor: nAverageQuotas == null ? 'sem cota média'
                : nAverageQuotas === 1 ? 'single' : 'capAverageQuota',

            //--- Compensação de amortização
            amortizationByQuota: amortizationByQuota,
            amortizationByQuotaFinita: amortizationByQuota === undefined
                ? null : Number.isFinite(amortizationByQuota),
            rentSemAmortizacao: rentDeCota(ultimaCota),
            rentComAmortizacao: rentDeCota(Number.isFinite(amortizationByQuota)
                ? ultimaCota + amortizationByQuota : NaN),

            //--- Divisor placeholder: rent_funds é snapshot (só regravado no relançamento do mês)
            //e as cotas são lidas vivas. avgQuota = 1 com ultimaCota != 1 = % do mês fabricado.
            //Marcado pelo backend em client.controller.js (Helper.isPlaceholderAverageQuota)
            staleAverageQuota: periodRent.stale_average_quota === true,

            //--- Sanidade da série de cotas (divisor null/zero e getRealLastValueQuotaMonth)
            qtdCotasAnbima: periodRent.quotas_anbima?.length,
            primeiraCota: periodRent.quotas_anbima?.[0]?.valor_cota,
            ultimaCotaZerada: ultimaCota === 0,
            avgQuotaNula: avgQuota == null,

            //Teste de sanidade do SPLIT_RENTABILIDADE.md: se bate com rent, os saldos estão
            //certos e o erro está na movimentação
            balanceCheck: periodRent.balance_before
                ? ((periodRent.balance_now / periodRent.balance_before) - 1) * 100 : null,
        }
    });

/**
 * Motor do ano: abre mês a mês o que compôs rentMoneyAcum (R$) e rentAcum (%) e recalcula os dois
 * acumulados, para apontar qual mês (e qual dos dois motores) produziu o número inconsistente.
 */
const rentDebugAssetBlock = (asset, periodsFund, { clientId, startDate, endDate, periodReport,
    accountRegimeId, rentAcum, rentMoneyAcum, resultFundsEntry }) => {

    const rows = rentDebugPeriodRows(periodsFund);

    const somaRentMoney = rows.reduce((acc, row) => acc + (Number.isFinite(row.rentMoney) ? row.rentMoney : 0), 0);
    const produtorioRent = rows.reduce((acc, row) => row.entrouNoAcum ? acc * (1 + (row.rent / 100)) : acc, 1);

    //Produtório alternativo usando o % recalculado COM crédito de amortização: se este bater com
    //a realidade e o do mapa não, a compensação de amortização é a causa
    const produtorioComAmortizacao = rows.reduce((acc, row) => {
        const rentAlternativo = Number.isFinite(row.rentComAmortizacao) ? row.rentComAmortizacao : row.rent;
        return Number.isFinite(rentAlternativo) && rentAlternativo != 0
            ? acc * (1 + (rentAlternativo / 100)) : acc;
    }, 1);

    //Array cru de cota média por mês, fora da tabela para não poluir o console.table
    const averageQuotasRaw = {};
    Object.entries(periodsFund ?? {})
        .filter(([key]) => key.includes("__"))
        .forEach(([key, periodRent]) => {
            averageQuotasRaw[periodRent.period ?? key.split("__")[1]] = periodRent.average_quota_now;
        });

    const block = {
        clientId,
        fund_id: asset.fund_id,
        fund_name: asset.fund_name,
        cnpj: asset.cnpj,
        periodReport,
        startDate,
        endDate,
        accountRegimeId,
        balanceNowDoAtivo: asset.balance_now,
        rentAcumDoMapa: rentAcum,
        rentMoneyAcumDoMapa: rentMoneyAcum,
        rentAcumRecalculado: (produtorioRent - 1) * 100,
        rentAcumSeAmortizacaoFosseCreditada: (produtorioComAmortizacao - 1) * 100,
        somaRentMoneyDasLinhas: somaRentMoney,
        mesesNoRentMoney: rows.length,
        mesesNoRentAcum: rows.filter(row => row.entrouNoAcum).length,
        mesesComAmortizacao: rows.filter(row => row.amortizacoes).length,
        mesesNoRamoCapAverageQuota: rows.filter(row => row.ramoDoMotor === 'capAverageQuota').length,
        mesesComAmortizacaoSemQtdQuotas: rows.filter(row => row.amortizacoes
            && !Number.isFinite(row.amortizationByQuota)).length,
        mesesComDivisorPlaceholder: rows.filter(row => row.staleAverageQuota).length,
        rows,
        averageQuotasRaw,
    };

    console.log(`[RENT-DEBUG] motor do ano | ${asset.fund_name} | ${startDate} a ${endDate}`, block);
    console.table(rows);

    //Payload CRU do /client/rentsByPeriod em bucket separado: substitui o log de servidor
    //(average_quota_now, quotas_anbima e somas por mês chegam todos aqui), mas é grande —
    //manter fora de 'blocks' deixa copy(JSON.stringify(window.__rentDebug.blocks)) leve
    rentDebugPush('raw', {
        fund_id: asset.fund_id,
        fund_name: asset.fund_name,
        startDate,
        endDate,
        //integralFundsBalancesMap[fund_id]: origem do rentAcum (%) e rentMoneyAcum (R$) da linha
        integralPeriodsFund: periodsFund,
        //resultFunds[fund_id]: mapa não-integral, para comparar os dois acumulados do backend
        resultFunds: resultFundsEntry,
    });

    return rentDebugPush('blocks', block);
}

/**
 * Motor do mês (o que alimenta a coluna "Mês"), para comparar com o do ano.
 * totalSplitAmount != 0 aqui significa que o mês passou pela correção de split que o ano não tem.
 */
const rentDebugMonthEngine = (asset, { startDate, endDate }) => {

    const dump = {
        fund_id: asset.fund_id,
        fund_name: asset.fund_name,
        cnpj: asset.cnpj,
        startDate,
        endDate,
        rentPercentInMonth: asset.rentPercentInMonth,
        rentMoneyInMonth: asset.rentMoneyInMonth,
        balance_before: asset.balance_before,
        balance_now: asset.balance_now,
        totalSplitAmount: asset.totalSplitAmount,
        totalApplication: asset.totalApplication,
        totalRescue: asset.totalRescue,
        totalAmortization: asset.totalAmortization,
        qtd_quota: asset.qtd_quota,
        qtd_quotas_sensibilized_final: asset.qtd_quotas_sensibilized_final,
        isNegativeAsset: asset.isNegativeAsset,
        isEndedAsset: asset.isEndedAsset,
    };

    console.log(`[RENT-DEBUG] motor do mês | ${asset.fund_name} | ${startDate} a ${endDate}`, dump);

    return rentDebugPush('monthEngine', dump);
}

/**
 * Linha já montada para a tabela: confirma que os pares %/R$ de cada coluna vieram do mesmo período.
 */
const rentDebugRow = (row) => {

    const pair = (period) => ({
        percent: period?.rentPercent,
        money: period?.rentMoney,
        balance: period?.balance,
    });

    const dump = {
        id: row.id,
        fund_name: row.fund_name,
        article: row.article,
        multipleArticles: row.multipleArticles,
        mes: pair(row.month),
        year1: pair(row.year1),
        year2: pair(row.year2),
        year3: pair(row.year3),
    };

    console.log(`[RENT-DEBUG] linha montada da tabela | ${row.fund_name}`, dump);

    return rentDebugPush('rows', dump);
}

/**
 * Transações cruas do ativo alvo: as somas agregadas (sumTransactionsInMonthByPeriod) escondem
 * is_split/is_transfer e não revelam mês de abertura de posição sem aplicação lançada.
 */
const rentDebugTransactions = async (clientId, fundId, fundName, { fromMonth, fromYear, toYear, toMonth }) => {

    //O endpoint filtra por fd.id: chaves de título (fund_name) não se aplicam
    if (!/^\d+$/.test(String(fundId))) {
        console.log(`[RENT-DEBUG] "${fundName}" não é um fundo (chave "${fundId}"): sem transações a listar`);
        return null;
    }

    const periods = [];
    for (let theYear = Number(fromYear); theYear <= Number(toYear); theYear++) {
        const firstMonth = theYear === Number(fromYear) ? Number(fromMonth ?? 1) : 1;
        const lastMonth = theYear === Number(toYear) ? Number(toMonth) : 12;
        for (let theMonth = firstMonth; theMonth <= lastMonth; theMonth++) {
            periods.push(theMonth + '/' + theYear);
        }
    }

    const response = await TransactionAPI.getMapTransactionsByFundIdsAndPeriods(clientId, { [fundId]: periods });

    if (!response?.success) {
        console.log(`[RENT-DEBUG] falha ao obter transações de ${fundName}: `, response);
        return null;
    }

    const periodsMap = response.data?.[fundId] ?? {};
    const rows = Object.entries(periodsMap)
        .flatMap(([period, transactions]) => (transactions ?? []).map(el => ({
            period,
            transaction_date: el.transaction_date,
            operacao: getOperationLabel(el),
            operation_id: el.operation_id,
            amount: parseFloat(el.amount),
            is_split: el.is_split,
            is_transfer: el.is_transfer,
            quota_value: el.quota_value,
        })));

    console.log(`[RENT-DEBUG] transações cruas | ${fundName} (fund_id ${fundId}) | ${periods[0]} a ${periods[periods.length - 1]}`, rows);
    console.table(rows);

    return rentDebugPush('transactions', { fund_id: fundId, fund_name: fundName, periods, rows });
}
//===================== FIM DEBUG DE RENTABILIDADE (temporário) =====================

export const acumRentsTitlesBySums = (titleType, balancesNowSums, balancesBeforeSums, trasactionsSums) => {

    return {
        //rentabildiade financeira
        rt1: getSimpleRentMoneyTitle2(
            balancesNowSums.titles[titleType] ?? 0,
            trasactionsSums.mapTitles[titleType]?.applications ?? 0,
            trasactionsSums.mapTitles[titleType]?.rescues ?? 0,
            trasactionsSums.mapTitles[titleType]?.amortizations ?? 0,
            balancesBeforeSums.titles[titleType] ?? 0
        ),

        //rentabildiade %
        rt2: getSimpleRentTitle2(
            balancesNowSums.titles[titleType] ?? 0,
            trasactionsSums.mapTitles[titleType]?.applications ?? 0,
            trasactionsSums.mapTitles[titleType]?.rescues ?? 0,
            trasactionsSums.mapTitles[titleType]?.amortizations ?? 0,
            balancesBeforeSums.titles[titleType] ?? 0
        )
    }

}

/**
 * Retorna os dados a serem utilizados na montsgem do relatório de carteira
 */
export async function getDataToPortfolioReport(clientId, startDate, endDate,
    accountRegimeId,
    periodReport,
    extraPortfolioReportParams, keepSubassetsInfos) {
    const { month, year } = getDayMonthYearByStringDate(endDate);

    //includeCnpj: usado apenas pela exportação em Excel da Carteira. O PDF de Carteira não
    //exibe CNPJ (só o de Ativos e Contas), então a flag anexa o campo sem alterar o relatório.
    const { isAssetAndAccountsReport, isAccumulatedTrasactionsReport, includeCnpj } = extraPortfolioReportParams;

    console.log('startDate, endDate: ', startDate, endDate);

    const isSpecificPeriodReport = periodReport && periodReport != 'mensal'; //Checando se é um report trimestal ou semestral

    //Obtendo informações dos ativos
    const keepWholeRescuesAssets = isAccumulatedTrasactionsReport || isSpecificPeriodReport;
    const responseInfosAssets = await getAssetInfos(clientId, month, year, accountRegimeId, false, null, keepWholeRescuesAssets, keepWholeRescuesAssets ? startDate : null);

    pureConsoleLog('responseInfosAssets: ', responseInfosAssets);

    const allSubAssets = {
        funds: [],
        titles: [],
    };

    //console.log('periodReport in portfolioReport: ', periodReport);
    const lastDiaryMonth = await loadClientDiaryByRange(clientId,
        month,
        year, isSpecificPeriodReport // removendo no caso de 12 pois se refere ao relatório mensal
        ? periodReport : 1);

    const totalPortfolioPeriodRent = applyMaskAmount(lastDiaryMonth.arrayRents && lastDiaryMonth.arrayRents.length === 1 ?
        lastDiaryMonth.arrayRents[0].rent
        :
        (lastDiaryMonth.arrayRents && lastDiaryMonth.arrayRents.length > 1
            ?
            lastDiaryMonth.arrayRents[lastDiaryMonth.arrayRents.length - 1].rentAcum
            :
            0
        ))

    //Caso seja um relatório por segregação precisamos obter a soma total para ffazer a ponderação
    let totalPortfolioPeriodRentInSgregation = null;
    console.log("accountRegimeId getDataToPortfolioReport: ", accountRegimeId);
    if (accountRegimeId) {

        const responseClient = await ClientAPI.getClientById(clientId);
        const client = responseClient.body;
        const responseSegregation = client.is_cotization_segregation ?
            await loadClientRentsBySegregation(client.id, month, year, isSpecificPeriodReport ? periodReport : 1)
            : null;
        totalPortfolioPeriodRentInSgregation = responseSegregation ? applyMaskAmount(responseSegregation.mapRentsBySegregation[accountRegimeId]) : "0,00";

    }

    const getPortfolioAssetAccountLine = (asset) => {
        const fund_name = `CC: ${applyMaskAccount(asset.number_account)} ${asset.agency ? '/ Ag: ' + asset.agency : ''}`;

        return {
            fund_name,
            balanceToDisplay: applyMaskAmount(asset.balance_now ?? "0", true),
            participation: asset.participation + "%",
            dados_cadastrais: {
                disponibilization: '-'
            },
            article_to_show: '-',
            rt1: '-',
            rt2: '-',
            isSubAsset: true
        }
    }

    const getFundSubAssetFormatted = (subAsset, rentPercentInMonth) => {
        return {
            fundName: subAsset.fund_name,
            numberAccount: subAsset.number_account,
            agency: subAsset.agency,
            cnpj: subAsset.cnpj,
            qtdQuotas: subAsset.qtd_quotas_sensibilized_final,
            balanceNow: subAsset.balance_now,
            accountRegimeId: subAsset.account_regime_id,
            participation: subAsset.participation,
            totalApplication: subAsset.totalApplication,
            totalRescue: subAsset.totalRescue,
            totalAmortization: subAsset.totalAmortization,
            rt2: rentPercentInMonth,
        }

    }

    const getTitleSubAssetFormatted = (subAsset) => {
        return {
            fund_name: getTitleCod(subAsset),
            balanceNow: subAsset.balance_now,
            numberAccount: subAsset.number_account,
            agency: subAsset.agency,
            accountRegimeId: subAsset.account_regime_id,
            rt1: subAsset.rentMoneyInMonth,
            rt2: subAsset.rentPercentInMonth,
            asset_title_id: subAsset.id,
            participation: subAsset.participation,
        }

    }

    if (responseInfosAssets.success) {

        let finalResultFunds = null
        let finalResultTitles = null
        let finalFundsBalancesByPeriod = null
        let finalTitlesRentMoneyAcum = null
        let finalIntegralFundsBalancesMap = null;
        if (isSpecificPeriodReport || isAccumulatedTrasactionsReport) {

            const { resultFunds,
                resultTitles,
                fundsBalancesByPeriod,
                titlesRentMoneyAcum,
                integralFundsBalancesMap }
                = await ClientAPI.getRentsByPeriod(clientId, startDate, endDate, null, null, accountRegimeId != null && accountRegimeId != 0 ? accountRegimeId : null);
            finalResultFunds = resultFunds;
            finalResultTitles = resultTitles;
            finalFundsBalancesByPeriod = fundsBalancesByPeriod;
            finalTitlesRentMoneyAcum = titlesRentMoneyAcum;
            finalIntegralFundsBalancesMap = integralFundsBalancesMap;

        }

        console.log("finalIntegralFundsBalancesMap: ", finalIntegralFundsBalancesMap);

        //DEBUG: ativo casado com window.__RENT_DEBUG, usado para listar as transações cruas no fim
        let rentDebugTargetAsset = null;

        let dataToReport = [];
        let totalBalance = 0.0;
        let totalRentMoney = 0.0;
        let totalRentPercent = 1;


        const { monthBefore, yearBefore } = getMonthAndYearBefore(startDate);

        const promisesSums = [];

        promisesSums.push(new Promise(async (resolve, reject) => {

            //Saldos e movimentações por fundo recortados pelo regime, como os ativos de getAssetInfos
            const response = await TransactionAPI.sumTransactionsInPeriodByFundAndOperation(clientId, startDate, endDate, accountRegimeId);
            response.success ? resolve(response.data) : resolve(false);

        }))

        promisesSums.push(new Promise(async (resolve, reject) => {

            const response = await BalancesValidationsAPI.getSumBalancesByMonthAndYear(clientId, month, year, accountRegimeId);
            response.success ? resolve(response.data) : resolve(false);

        }))

        promisesSums.push(new Promise(async (resolve, reject) => {

            const response = await BalancesValidationsAPI.getSumBalancesByMonthAndYear(clientId, monthBefore, yearBefore, accountRegimeId);
            response.success ? resolve(response.data) : resolve(false);

        }))

        //Retorno do empréstimo consignado no período: é o registred_rent (o saldo validado do
        //consignado carrega só o principal, então diferença de saldo zeraria o retorno).
        //O endpoint já filtra consignado + regime e devolve uma linha por mês (titlesConsigRent).
        if (isAccumulatedTrasactionsReport) {
            promisesSums.push(new Promise(async (resolve, reject) => {

                const { month: monthStart, year: yearStart } = getDayMonthYearByStringDate(startDate);
                const response = await ClientAPI.getBalancesPortfolioMonthByPeriodAndRegime(clientId,
                    accountRegimeId ? accountRegimeId : null,
                    //date_validation é o 1º dia do mês: normalizando para não perder o mês inicial
                    getFirstDayMonth(monthStart, yearStart),
                    endDate);
                response.success ? resolve(response.body) : resolve(false);

            }))
        }

        const reponsePromises = await Promise.all(promisesSums);

        // const trasactionsSums = await sumTransactionsInPeriodByFundAndOperation(clientId, startDate, endDate);
        // const balancesBeforeSums = await BalancesValidationsAPI.getSumBalancesByMonthAndYear(clientId, monthBefore, yearBefore);

        const trasactionsSums = reponsePromises[0];
        const balancesNowSums = reponsePromises[1];
        const balancesBeforeSums = reponsePromises[2];
        //Só existe no relatório de movimentações acumuladas (ver push condicional acima)
        const balancesConsigRent = reponsePromises[3];

        //Soma dos registred_rent do consignado no período (0 quando o cliente não tem consignado)
        const consigRentPeriod = (balancesConsigRent?.titlesConsigRent ?? [])
            .reduce((acc, current) => acc + (parseFloat(current.rent) || 0), 0);

        const { rt1: rt1Public, rt2: rt2Public } = acumRentsTitlesBySums("PUBLICO", balancesNowSums, balancesBeforeSums, trasactionsSums)
        const { rt1: rt1Private, rt2: rt2Private } = acumRentsTitlesBySums("PRIVADO", balancesNowSums, balancesBeforeSums, trasactionsSums)

        //Chave de agregação das linhas de título, espelhando Helper.getTitleBucketKey do backend
        //(getSumBalancesByMonthAndYear e sumTransactionsInPeriodByFundAndOperation).
        //A precedência é a mesma de groupAssetTitles: consignado antes de genérico.
        const getTitleLineBucketKey = (asset) => {
            if (asset.fund_name == PUBLIC_TITLES) return 'PUBLICO';
            if (asset.fund_name == PRIVATE_TITLES) return 'PRIVADO';
            if (isConsigTitle(asset)) return GENERIC_ASSET_CONSIG;
            if (asset.fund_name == GENERIC_ASSETS) return GENERIC_ASSET_TITLES_TYPE;
            return null;
        };

        // console.log("isSpecificPeriodReport: ", isSpecificPeriodReport);
        // console.log("isAccumulatedTrasactionsReport: ", isAccumulatedTrasactionsReport);

        if (isAccumulatedTrasactionsReport) {

            if (trasactionsSums) {

                const { mapFunds, mapTitles, total } = trasactionsSums;

                let totalBalanceNow = 0.0;
                let totalBalanceBefore = 0.0;
                let totalAmortization = 0.0;
                responseInfosAssets.assetsFormatted.forEach(asset => {

                    const assetPortfolioLine = {}
                    assetPortfolioLine.balanceNowToDisplay = applyMaskAmount(asset.balance_now ?? "0", true);
                    assetPortfolioLine.balanceNowNumeric = parseFloat(asset.balance_now ?? "0");
                    assetPortfolioLine.totalApplications = applyMaskAmount(0, true);
                    assetPortfolioLine.totalApplicationsNumeric = 0;
                    assetPortfolioLine.totalRescues = applyMaskAmount(0, true);
                    assetPortfolioLine.totalRescuesNumeric = 0;
                    assetPortfolioLine.resolutionName = responseInfosAssets.resolutionName;
                    assetPortfolioLine.article_to_show = asset.device_abbreviation ? asset.device_abbreviation : asset.device ?? '-';
                    assetPortfolioLine.fund_id = asset?.fund_id;
                    assetPortfolioLine.totalAmortizations = applyMaskAmount(0, true);
                    assetPortfolioLine.totalAmortizationsNumeric = 0;

                    let rentMoney = asset.rentMoneyInMonth;

                    //Normalizando nome do título para fundo
                    if (asset.title_id) {
                        assetPortfolioLine.fund_name = getTitleCod(asset);
                    }

                    if (asset.fund_name) {
                        assetPortfolioLine.fund_name = asset.fund_name;
                    }

                    // Inicializar saldo anterior com valor padrão (será atualizado abaixo)
                    assetPortfolioLine.balanceBeforeToDisplay = applyMaskAmount(0, true);
                    assetPortfolioLine.balanceBeforeNumeric = 0;
                    //FUNDOS
                    if (asset.fund_id) {
                        rentMoney = finalResultFunds[asset.fund_id].rentMoneyAcum;
                        assetPortfolioLine.rt2 = applyMaskAmount(finalResultFunds[asset.fund_id].rentAcum) + '%';
                    } else {
                        //LINHAS DE TÍTULOS: saldo anterior e movimentações do período vêm dos mapas
                        //agregados do backend, que são chaveados pelo bucket do título
                        //(PUBLICO | PRIVADO | EMPRÉSTIMO CONSIGNADO | ATIVO GENÉRICO)
                        const bucketKey = getTitleLineBucketKey(asset);
                        let rt2 = 0;

                        if (bucketKey) {

                            const balanceBeforeBucket = balancesBeforeSums?.titles?.[bucketKey];
                            if (balanceBeforeBucket) {
                                assetPortfolioLine.balanceBeforeToDisplay = applyMaskAmount(balanceBeforeBucket, true);
                                assetPortfolioLine.balanceBeforeNumeric = balanceBeforeBucket;
                                totalBalanceBefore += balanceBeforeBucket;
                            }

                            const movementsBucket = mapTitles[bucketKey];
                            if (movementsBucket) {
                                assetPortfolioLine.totalApplications = applyMaskAmount(movementsBucket.applications, true);
                                assetPortfolioLine.totalApplicationsNumeric = movementsBucket.applications;
                                assetPortfolioLine.totalRescues = applyMaskAmount(movementsBucket.rescues, true);
                                assetPortfolioLine.totalRescuesNumeric = movementsBucket.rescues;
                                //groupAssetTitles grava totalAmortizations (plural) na linha agrupada,
                                //e o valor dela seria apenas do último mês: o do período vem do bucket
                                assetPortfolioLine.totalAmortizations = applyMaskAmount(movementsBucket.amortizations ?? 0, true);
                                assetPortfolioLine.totalAmortizationsNumeric = movementsBucket.amortizations ?? 0;
                            }
                        }

                        if (bucketKey === 'PUBLICO') {
                            rentMoney = rt1Public;
                            rt2 = rt2Public;
                        } else if (bucketKey === 'PRIVADO') {
                            rentMoney = rt1Private;
                            rt2 = rt2Private;
                        } else if (bucketKey === GENERIC_ASSET_CONSIG) {
                            //O retorno do consignado é o registred_rent acumulado do período: as
                            //movimentações não entram no cálculo (o registred_rent já embute o efeito
                            //delas). O % do período exigiria composição mês a mês, então segue '-'.
                            rentMoney = consigRentPeriod;
                            rt2 = '-';
                        } else {
                            //IMÓVEIS e qualquer título fora dos buckets conhecidos não têm rentabilidade
                            rentMoney = '-';
                            rt2 = '-';
                        }

                        assetPortfolioLine.rt2 = rt2 === '-' ? '-' : applyMaskAmount(rt2) + '%';
                    }

                    assetPortfolioLine.rt1 = rentMoney === '-' ? '-' : applyMaskAmount(rentMoney, true)

                    //Linhas sem rentabilidade ('-') não podem contaminar o acumulado
                    if (typeof rentMoney === 'number' && Number.isFinite(rentMoney)) {
                        totalRentMoney += rentMoney;
                    }
                    totalBalanceNow += parseFloat(asset.balance_now ?? "0");
                    totalAmortization += parseFloat(asset?.totalAmortization ?? "0");

                    if (mapFunds[asset.fund_id]) {

                        const { applications, rescues, amortizations } = mapFunds[asset.fund_id];

                        assetPortfolioLine.totalApplications = applyMaskAmount(applications, true);
                        assetPortfolioLine.totalApplicationsNumeric = applications;
                        assetPortfolioLine.totalRescues = applyMaskAmount(rescues, true);
                        assetPortfolioLine.totalRescuesNumeric = rescues;
                        assetPortfolioLine.totalAmortizations = applyMaskAmount(amortizations ?? 0, true);
                        assetPortfolioLine.totalAmortizationsNumeric = amortizations ?? 0;

                    }

                    //Títulos já tiveram o saldo anterior preenchido acima, pelo bucket
                    if (asset.fund_id) {
                        if (balancesBeforeSums.funds[asset.fund_id]) {
                            assetPortfolioLine.balanceBeforeToDisplay = applyMaskAmount(balancesBeforeSums.funds[asset.fund_id], true);
                            assetPortfolioLine.balanceBeforeNumeric = balancesBeforeSums.funds[asset.fund_id];
                            totalBalanceBefore += balancesBeforeSums.funds[asset.fund_id];
                        }
                    }

                    if (asset?.dados_cadastrais?.administration_tax) {
                        assetPortfolioLine.administration_tax = applyMaskAmount(asset.dados_cadastrais.administration_tax) + '%';
                    } else {
                        assetPortfolioLine.administration_tax = '-';
                    }

                    dataToReport.push(assetPortfolioLine)
                })

                dataToReport = removingNoDataAcumAssetsTrasactionsReport(dataToReport);

                const totalPortfolioPeriodRent = applyMaskAmount(lastDiaryMonth.arrayRents && lastDiaryMonth.arrayRents.length === 1 ?
                    lastDiaryMonth.arrayRents[0].rent
                    :
                    (lastDiaryMonth.arrayRents && lastDiaryMonth.arrayRents.length > 1
                        ?
                        lastDiaryMonth.arrayRents[lastDiaryMonth.arrayRents.length - 1].rentAcum
                        :
                        0
                    ))

                //RETORNO R$ do total: o bucket ATIVO GENÉRICO de finalTitlesRentMoneyAcum é calculado
                //por diferença de saldo, o que não vale para o consignado (o saldo validado é só o
                //principal) nem para imóveis (que exibem '-'). Descontamos essa parcela e somamos o
                //registred_rent do consignado, mantendo o total igual à soma das linhas exibidas.
                const genericTitlesRentMoneyAcum = parseFloat(finalResultTitles?.[GENERIC_ASSET_TITLES_TYPE]?.rentMoneyAcum ?? 0) || 0;
                const totalRentMoneyAcum = finalFundsBalancesByPeriod.rentMoneyAcum
                    + finalTitlesRentMoneyAcum
                    - genericTitlesRentMoneyAcum
                    + consigRentPeriod;

                dataToReport.push({
                    fund_name: 'Total investimentos',
                    balanceBeforeToDisplay: applyMaskAmount(totalBalanceBefore, true),
                    balanceBeforeNumeric: totalBalanceBefore,
                    balanceNowToDisplay: applyMaskAmount(totalBalanceNow, true),
                    balanceNowNumeric: totalBalanceNow,
                    totalAmortization: applyMaskAmount(totalAmortization, true),
                    totalApplications: applyMaskAmount(total.applications, true),
                    totalApplicationsNumeric: total.applications,
                    totalRescues: applyMaskAmount(total.rescues, true),
                    totalRescuesNumeric: total.rescues,
                    totalAmortizations: applyMaskAmount(total.amortizations ?? 0, true),
                    totalAmortizationsNumeric: total.amortizations ?? 0,
                    //Amortizações DO PERÍODO (títulos + fundos), vindas do mesmo agregado que
                    //alimenta aplicações e resgates. Não confundir com totalAmortization acima,
                    //que soma asset.totalAmortization e é escopado só ao mês corrente.
                    totalAmortizationsPeriod: applyMaskAmount(total.amortizations ?? 0, true),
                    totalAmortizationsPeriodNumeric: total.amortizations ?? 0,
                    rt1: applyMaskAmount(totalRentMoneyAcum, true),
                    rt2: accountRegimeId ? '-' : (totalPortfolioPeriodRent + '%'),
                });

                // ========== CÁLCULO DE DESTAQUE DE EVENTOS RELEVANTES ==========
                const limiar5Porcento = totalBalanceBefore * 0.05;
                let ativosDestacados = [];

                // Processa todos os ativos (excluindo "Total investimentos")
                dataToReport.forEach((asset, index) => {
                    if (asset.fund_name === "Total investimentos") {
                        asset.shouldHighlight = false;
                        return;
                    }

                    const appValue = parseFloat(asset.totalApplicationsNumeric || 0);
                    const rescValue = parseFloat(asset.totalRescuesNumeric || 0);
                    const balanceFinal = parseFloat(asset.balanceNowNumeric || 0);

                    let criteriosAcionados = [];

                    // Critério 1: Aplicações >= 5%
                    if (appValue >= limiar5Porcento) {
                        const percApp = totalBalanceBefore > 0 ? ((appValue / totalBalanceBefore) * 100).toFixed(2) : 0;
                        criteriosAcionados.push(`Aplicação ${percApp}%`);
                    }

                    // Critério 2: Resgates >= 5%
                    if (rescValue >= limiar5Porcento) {
                        const percResc = totalBalanceBefore > 0 ? ((rescValue / totalBalanceBefore) * 100).toFixed(2) : 0;
                        criteriosAcionados.push(`Resgate ${percResc}%`);
                    }

                    // Critério 3: Encerramento de posição
                    if (Math.abs(balanceFinal) < 0.01) {
                        criteriosAcionados.push('Posição encerrada');
                    }

                    // Define se deve ser destacado
                    asset.shouldHighlight = criteriosAcionados.length > 0;


                    if (asset.shouldHighlight) {
                        ativosDestacados.push({
                            ativo: asset.fund_name,
                            criterios: criteriosAcionados.join(' | ')
                        });
                    }
                });

                // LOG: Saída de console com os ativos destacados
                console.log('\n========== RELATÓRIO DE EVENTOS RELEVANTES ==========');
                console.log(`Período: ${startDate} a ${endDate}`);
                console.log(`Patrimônio total no início do período: R$ ${totalBalanceBefore.toFixed(2)}`);
                console.log(`Limiar 5% do patrimônio: R$ ${limiar5Porcento.toFixed(2)}`);
                console.log(`\nAtivos com eventos relevantes: ${ativosDestacados.length}`);
                console.log('---------------------------------------------------');
                ativosDestacados.forEach((item, idx) => {
                    console.log(`${idx + 1}. ${item.ativo}`);
                    console.log(`   → ${item.criterios}`);
                });
                console.log('===================================================\n');

                // LOG DEBUG: Verificar se shouldHighlight foi setado
                console.log('DEBUG - Verificando shouldHighlight em dataToReport:');
                dataToReport.forEach((asset, idx) => {
                    console.log(`${idx}. ${asset.fund_name}: shouldHighlight = ${asset.shouldHighlight}`);
                });
            }


        } else {
            //Adiconando filtro para remover fundos que já foram liquidados completamente

            if (keepSubassetsInfos && responseInfosAssets.titleAssets?.length > 0) {
                allSubAssets.titles.push.apply(allSubAssets.titles, responseInfosAssets.titleAssets.map(el => getTitleSubAssetFormatted(el)));
            }
            responseInfosAssets.assetsFormatted.forEach(asset => {

                //garantindo consistência de relatório de períodos com fundos liquidados
                if (asset.isEndedAsset) asset.balance_now = 0;
                const assetPortfolioLine = {
                    dados_cadastrais: {

                    }
                }

                assetPortfolioLine.balanceToDisplay = applyMaskAmount(asset.balance_now, true);
                assetPortfolioLine.accountRegimeId = asset.account_regime_id;

                //const rentFundMonth = getInMonthRentFundInPortfolio(asset);
                const rentFundMonth = asset.rentPercentInMonth;

                let rentMoney = asset.rentMoneyInMonth;
                let theRt2 = null;

                if (isSpecificPeriodReport) {

                    //FUNDOS
                    if (asset.fund_id && finalIntegralFundsBalancesMap[asset.fund_id]) {
                        //console.log("Lendo fundo: ", asset);

                        rentMoney = finalIntegralFundsBalancesMap[asset.fund_id].rentMoneyAcum;

                        //assetPortfolioLine.rt2 = applyMaskAmount(finalResultFunds[asset.fund_id].rentAcum) + '%';
                        const rentAcumFund = finalIntegralFundsBalancesMap[asset.fund_id].rentAcum;
                        assetPortfolioLine.rt2 = maskAmountOrDash(rentAcumFund, false, '%');
                        theRt2 = Number.isFinite(rentAcumFund) ? rentAcumFund : null;

                        if (matchRentDebug(asset)) {
                            rentDebugTargetAsset = asset;
                            rentDebugAssetBlock(asset, finalIntegralFundsBalancesMap[asset.fund_id], {
                                clientId,
                                startDate,
                                endDate,
                                periodReport,
                                accountRegimeId,
                                rentAcum: rentAcumFund,
                                rentMoneyAcum: rentMoney,
                                resultFundsEntry: finalResultFunds?.[asset.fund_id],
                            });
                        }
                    } else {
                        //console.log("Lendo titulos: ", asset);
                        let rt2 = 0;
                        if (asset.fund_name == PUBLIC_TITLES) {

                            rentMoney = rt1Public;
                            rt2 = rt2Public;
                        } else if (asset.fund_name == PRIVATE_TITLES) {

                            rentMoney = rt1Private;
                            rt2 = rt2Private;
                        } else {

                            // rentMoney = rt1Generic;
                            // rt2 = rt2Generic;
                            //Sem dado de rentabilidade acumulada no período (consignado, genéricos/imóveis
                            //e fundos sem registro): mantém "-" ao invés de mascarar e virar "NaN"
                            rentMoney = NO_DATA_LABEL;
                            rt2 = NO_DATA_LABEL;
                        }

                        assetPortfolioLine.rt2 = maskAmountOrDash(rt2, false, '%');
                        theRt2 = Number.isFinite(rt2) ? rt2 : null;

                    }


                } else {

                    //RENT %
                    assetPortfolioLine.rt2 = maskAmountOrDash(rentFundMonth, false, '%');
                    theRt2 = Number.isFinite(rentFundMonth) ? rentFundMonth : null;

                    if (matchRentDebug(asset)) {
                        rentDebugTargetAsset = asset;
                        rentDebugMonthEngine(asset, { startDate, endDate });
                    }

                }


                //Povoando subassets para relatórios de retornos
                if (keepSubassetsInfos) {

                    if (!asset.title_id) {
                        if (asset.subAssets?.length) {
                            allSubAssets.funds.push.apply(allSubAssets.funds, asset.subAssets.map(el => getFundSubAssetFormatted(el, theRt2)));
                        } else {
                            //Evitando a entrada dos títulos agrupados
                            if (asset.cnpj) {
                                allSubAssets.funds.push(getFundSubAssetFormatted(asset, theRt2));
                            }
                        }
                    }
                }

                if (keepSubassetsInfos && asset.subAssetsTitles?.length > 0) {

                    assetPortfolioLine.subAssetsTitles = asset.subAssetsTitles.map((el) => (
                        {
                            fund_name: "TITLE_ASSET_" + el.id,
                            balanceToDisplay: applyMaskAmount(el.balance_now, true),
                            accountRegimeId: el.account_regime_id,
                            rt1: maskAmountOrDash(el.rentMoneyInMonth, true),
                            rt2: maskAmountOrDash(el.rentPercentInMonth, false, "%"),
                            article: el.device_abbreviation,
                            isTitlesLine: true,
                            asset_title_id: el.id,
                            participation: applyMaskAmount(el.participation) + "%",
                        }
                    ))

                }

                if (asset.subAssetsTitles?.length) {
                    delete asset.subAssetsTitles;
                }

                //RENT R$
                assetPortfolioLine.rt1 = maskAmountOrDash(rentMoney, true);

                //Somente valores numéricos entram no acumulado; '-' faria coerção para string
                totalRentMoney += Number.isFinite(rentMoney) ? rentMoney : 0;

                //Evitando problema de saldo nulo em caso de gerar relatório em período após liquidity do fundo
                if (asset.balance_now === null) {
                    if (asset.lack_liquidity_date && moment.utc(asset.lack_liquidity_date).isSameOrAfter(stringPtDateToJsDate(endDate))) {
                        totalBalance += 0;
                    } else {
                        totalBalance += null;
                    }
                } else {
                    totalBalance += parseFloat(asset.balance_now);
                }

                assetPortfolioLine.participation = applyMaskAmount(asset.participation) + "%";

                //Caso o fundo seja especial ele não possui dados cadatrais, então inicializa-se a disponibilização com vazio pois é um campo utilizado 
                //no portfolio_report e daria null pointer caso dados_cadastrais não existissem e se tentasse acessar o atributo "disponibilization"

                if (asset.local_liquidity) {
                    assetPortfolioLine.dados_cadastrais.disponibilization = disponibilizationDicionary(asset.local_liquidity).label;
                } else if (asset.dados_cadastrais && asset.dados_cadastrais.disponibilization) {

                    assetPortfolioLine.dados_cadastrais.disponibilization = disponibilizationDicionary(asset.dados_cadastrais.disponibilization).label;

                } else {

                    if (asset?.dados_cadastrais?.dados_cadastrais?.disponibilization) {
                        assetPortfolioLine.dados_cadastrais = {
                            disponibilization: disponibilizationDicionary(asset.dados_cadastrais.dados_cadastrais.disponibilization).label,
                        }
                    } else {
                        assetPortfolioLine.dados_cadastrais = {
                            disponibilization: "-",
                        }
                    }
                }

                assetPortfolioLine.resolutionName = responseInfosAssets.resolutionName;
                assetPortfolioLine.article_to_show = asset.device_abbreviation ? asset.device_abbreviation : '-';
                assetPortfolioLine.lack_liquidity_to_show = asset.title_id || !asset.lack_liquidity_date ? '-' : moment.utc(asset.lack_liquidity_date).format("DD/MM/YY");

                if (asset?.dados_cadastrais?.administration_tax != null) {

                    assetPortfolioLine.administration_tax = applyMaskAmount(asset.dados_cadastrais.administration_tax) + '%';
                } else {
                    if (asset?.dados_cadastrais?.dados_cadastrais?.administration_tax != null) {
                        assetPortfolioLine.administration_tax = applyMaskAmount(asset.dados_cadastrais.dados_cadastrais.administration_tax) + '%';
                    } else {
                        assetPortfolioLine.administration_tax = '-';
                    }
                }

                //Normalizando nome do título para fundo
                if (asset.title_id) {
                    assetPortfolioLine.fund_name = getTitleCod(asset);
                }

                if (asset.fund_name == PUBLIC_TITLES || asset.fund_name == PRIVATE_TITLES) {
                    assetPortfolioLine.isTitlesLine = true;
                    assetPortfolioLine.balanceNow = asset.balance_now;
                }

                // Grupos de consignado/genérico também precisam do recálculo de participação,
                // mas SEM marcar isTitlesLine (esse flag é consumido por getDataToReturnsByAssetsReport)
                if (isConsigTitle(asset) || asset.fund_name == GENERIC_ASSETS) {
                    assetPortfolioLine.needsParticipationFix = true;
                    assetPortfolioLine.balanceNow = asset.balance_now;
                }

                if (asset.fund_name) {
                    //assetPortfolioLine.fund_name = formatStringToDisplay(asset.fund_name, 6, '...');
                    assetPortfolioLine.fund_name = asset.fund_name;
                    assetPortfolioLine.fund_id = asset.fund_id;
                }

                //calculando possível rentabilidade negativa
                if (!assetPortfolioLine.isTitlesLine && asset.quota_amount_now != null && asset.quotas_anbima && asset.quotas_anbima.length > 0) {
                    assetPortfolioLine.negativeBalance = asset.quota_amount_now * asset.quotas_anbima[asset.quotas_anbima.length - 1].valor_cota;
                }

                dataToReport.push(assetPortfolioLine);

                if (asset.fund_id && (isAssetAndAccountsReport || includeCnpj)) {
                    assetPortfolioLine.cnpj = asset.cnpj;
                }

                //Relatório de ativos e contas
                if (isAssetAndAccountsReport && asset.fund_id) {

                    if (asset.subAssets?.length) {
                        asset.subAssets.map((subAsset) => {
                            dataToReport.push(getPortfolioAssetAccountLine(subAsset))
                        });
                    } else {
                        dataToReport.push(getPortfolioAssetAccountLine(asset));
                    }
                }

            });



            dataToReport = removingNoDataAcumAssets(dataToReport);

            //corrigindo participação de linhas de título
            dataToReport.filter(el => el.isTitlesLine || el.needsParticipationFix).forEach((titleLine) => {
                titleLine.participation = applyMaskAmount((titleLine.balanceNow / totalBalance) * 100) + "%";
            });



            dataToReport.push({
                fund_name: 'Total investimentos',
                balanceBeforeToDisplay: applyMaskAmount(0, true),
                balanceBeforeNumeric: 0,
                balanceToDisplay: applyMaskAmount(totalBalance, true),
                balanceNowNumeric: totalBalance,
                participation: '100.00%',
                rt1: isSpecificPeriodReport ?
                    (
                        accountRegimeId ?
                            //Somando os retornos das linhas anteriores da tabela
                            applyMaskAmount(dataToReport.reduce((acc, c) => acc + parseBrlCurrencyToFloat(c.rt1 || 0), 0), true)
                            :
                            applyMaskAmount(finalFundsBalancesByPeriod.rentMoneyAcum + finalTitlesRentMoneyAcum, true)
                    )

                    :
                    applyMaskAmount(totalRentMoney, true),
                //retornando '-' para quando for filtro de segregação
                rt2: accountRegimeId ? (
                    totalPortfolioPeriodRentInSgregation ? totalPortfolioPeriodRentInSgregation + "%" : "-"
                    // "-"
                ) : (totalPortfolioPeriodRent + '%'),
                dados_cadastrais: {
                    disponibilization: "",
                }
            });

            dataToReport.push({
                fund_name: 'Disponibilidade',
                balanceToDisplay: applyMaskAmount(responseInfosAssets.totalDisponibilityInAccounts != null
                    ? responseInfosAssets.totalDisponibilityInAccounts.now : 0, true),
                participation: '-',
                rt1: '-',
                rt2: '-',
                dados_cadastrais: {
                    disponibilization: "",
                }
            });

            dataToReport.push({
                fund_name: 'Total patrimônio',
                balanceToDisplay: applyMaskAmount(totalBalance + (responseInfosAssets.totalDisponibilityInAccounts != null
                    ? responseInfosAssets.totalDisponibilityInAccounts.now : 0), true),
                balanceNowNumeric: totalBalance + (responseInfosAssets.totalDisponibilityInAccounts != null
                    ? responseInfosAssets.totalDisponibilityInAccounts.now : 0),
                participation: '100.00%',
                rt1: '-',
                rt2: '-',
                dados_cadastrais: {
                    disponibilization: "",
                }
            });

            //clean object to stream, retirando subassets e subAssetTitles
            dataToReport.forEach(element => {
                if (element.subAssetsTitles) {
                    if (!keepSubassetsInfos) {
                        delete element.subAssetsTitles
                    }
                }

                if (element.subAssets) {

                    delete element.subAssets
                }
                delete element.quotas_anbima
                delete element.quotas_anbima_before

                if (element.fund_name === GENERIC_ASSETS) {
                    element.rt1 = '-';
                    element.rt2 = '-';
                }
            });
        }

        //DEBUG: transações cruas do fundo alvo + linha de total, uma única vez por relatório.
        //As somas agregadas do rentsByPeriod escondem operation_id (2 resgate x 3 amortização),
        //is_split e is_transfer — que é justamente o que separa erro de cadastro de erro de cálculo.
        //keepSubassetsInfos identifica as chamadas vindas de getDataToReturnsByAssetsReport, que
        //já lista as transações por conta própria (4 chamadas em paralelo aqui).
        if (rentDebugTargetAsset && !keepSubassetsInfos) {

            const { month: startMonthDebug, year: startYearDebug } = getDayMonthYearByStringDate(startDate);

            await rentDebugTransactions(clientId,
                rentDebugTargetAsset.fund_id,
                rentDebugTargetAsset.fund_name,
                {
                    fromMonth: startMonthDebug,
                    fromYear: startYearDebug,
                    toYear: year,
                    toMonth: month,
                });

            const totais = {
                totalInvestimentos: dataToReport.find(el => el.fund_name === 'Total investimentos'),
                totalPatrimonio: dataToReport.find(el => el.fund_name === 'Total patrimônio'),
                //% do total vem da cota do cliente (loadClientDiaryByRange), não do produtório
                totalPortfolioPeriodRent,
                linhaDoAtivo: dataToReport.find(el => el.fund_name === rentDebugTargetAsset.fund_name),
            };

            console.log(`[RENT-DEBUG] totais da carteira | ${startDate} a ${endDate}`, totais);
            rentDebugPush('totals', totais);

            console.log('[RENT-DEBUG] dump completo — copie com: copy(JSON.stringify(window.__rentDebug))',
                window.__rentDebug);
        }

        console.log("dataToPortfolioReport: ", dataToReport);
        console.log("allSubAssets: ", allSubAssets);

        let executiveSummary = null;
        if (isAccumulatedTrasactionsReport) {
            const calculateExecutiveSummary = (reportData) => {
                let totalApplications = 0;
                let totalRescues = 0;
                let totalReturnMoney = 0;

                reportData.forEach(asset => {
                    if (asset.fund_name !== 'Total investimentos'
                        && asset.fund_name !== 'Disponibilidade'
                        && asset.fund_name !== 'Total patrimônio') {

                        const appValue = parseFloat(
                            String(asset.totalApplications).replace(/[^\d,-]/g, '').replace('.', '').replace(',', '.')
                        ) || 0;
                        const rescValue = parseFloat(
                            String(asset.totalRescues).replace(/[^\d,-]/g, '').replace('.', '').replace(',', '.')
                        ) || 0;
                        const rentValue = parseFloat(
                            String(asset.rt1).replace(/[^\d,-]/g, '').replace('.', '').replace(',', '.')
                        ) || 0;

                        totalApplications += appValue;
                        totalRescues += rescValue;
                        totalReturnMoney += rentValue;
                    }
                });

                return {
                    totalApplications: applyMaskAmount(totalApplications, true),
                    totalRescues: applyMaskAmount(totalRescues, true),
                    liquidMovement: applyMaskAmount(totalApplications - totalRescues, true),
                    totalReturnMoney: applyMaskAmount(totalReturnMoney, true)
                };
            };

            executiveSummary = calculateExecutiveSummary(dataToReport);
        }

        return {
            success: true,
            dataToPortfolioReport: dataToReport,
            executiveSummary: executiveSummary,
            subAssets: allSubAssets,
            accountRegimeId: accountRegimeId ?? 0,
        }

    } else {
        return {
            success: false,
        }
    }

};

export async function getDataToReturnsByAssetsReport(client,
    startDate,
    endDate,
    keepSubassetsInfos,
    setInnerLoad, isSegregationTab, accountRegimeId = null) {

    const clientId = client.id;

    //DEBUG: zera o acumulador a cada carregamento, para o dump refletir só a leitura atual
    rentDebugReset();

    const { month, year: currentYear } = getDayMonthYearByPtDate(startDate);

    const yearBefore1 = currentYear;
    const yearBefore2 = yearBefore1 - 1;
    const yearBefore3 = yearBefore2 - 1;

    const startDateBefore1 = '01/01/' + yearBefore1
    const endDateBefore1 = endDate

    const startDateBefore2 = '01/01/' + yearBefore2
    const endDateBefore2 = '31/12/' + yearBefore2

    const startDateBefore3 = '01/01/' + yearBefore3
    const endDateBefore3 = '31/12/' + yearBefore3

    try {

        const optionsSegregation = isSegregationTab
            ? getRegimeOptions({ client: client })
            : [{
                name: REGIME_LABELS[ACCOUNT_REGIME.PREVIDENCIARIO],
                value: ACCOUNT_REGIME.PREVIDENCIARIO,
            }];

        console.log("optionsSegregation: ", optionsSegregation)



        setInnerLoad((prev) => ({ ...prev, loadMessage: "Obtendo dados mensais... (1/4)" }));

        //A primeira posição de cada bloco é a carteira exibida: consolidada (null) ou a do regime
        //filtrado na tela. Na aba de segregação os demais regimes entram logo depois.
        const promisesMonth = [
            getDataToPortfolioReport(clientId, startDate, endDate, accountRegimeId, "mensal", {
                isAssetAndAccountsReport: false,
                isAccumulatedTrasactionsReport: false
            }, keepSubassetsInfos)
        ];

        if (isSegregationTab) {
            promisesMonth.push(
                ...optionsSegregation.map(({ value }) =>
                    getDataToPortfolioReport(clientId, startDate, endDate, value, "mensal", {
                        isAssetAndAccountsReport: false,
                        isAccumulatedTrasactionsReport: false
                    }, keepSubassetsInfos)
                )
            );
        }

        const responseSegregationMonth = await Promise.all(promisesMonth);
        const dataMonth = responseSegregationMonth[0];

        console.log("responseSegregationMonth: ", responseSegregationMonth);

        setInnerLoad((prev) => ({ ...prev, loadMessage: `Obtendo dados de ${yearBefore1}...(2/4)` }));

        const promisesYear1 = [
            getDataToPortfolioReport(clientId, startDateBefore1, endDateBefore1, accountRegimeId, "ano", {
                isAssetAndAccountsReport: false,
                isAccumulatedTrasactionsReport: false
            }, keepSubassetsInfos)
        ];

        if (isSegregationTab) {
            promisesYear1.push(
                ...optionsSegregation.map(({ value }) =>
                    getDataToPortfolioReport(clientId, startDateBefore1, endDateBefore1, value, "ano", {
                        isAssetAndAccountsReport: false,
                        isAccumulatedTrasactionsReport: false
                    }, keepSubassetsInfos)
                )
            );
        }
        const responseSegregationYear1 = await Promise.all(promisesYear1);
        const dataYearBefore1 = responseSegregationYear1[0];
        console.log("responseSegregationYear1: ", responseSegregationYear1);

        setInnerLoad((prev) => ({ ...prev, loadMessage: `Obtendo dados de ${yearBefore2}...(3/4)` }));

        const promisesYear2 = [
            getDataToPortfolioReport(clientId, startDateBefore2, endDateBefore2, accountRegimeId, "ano", {
                isAssetAndAccountsReport: false,
                isAccumulatedTrasactionsReport: false
            }, keepSubassetsInfos)
        ];

        if (isSegregationTab) {
            promisesYear2.push(
                ...optionsSegregation.map(({ value }) =>
                    getDataToPortfolioReport(clientId, startDateBefore2, endDateBefore2, value, "ano", {
                        isAssetAndAccountsReport: false,
                        isAccumulatedTrasactionsReport: false
                    }, keepSubassetsInfos)
                )
            );
        }
        const responseSegregationYear2 = await Promise.all(promisesYear2);
        const dataYearBefore2 = responseSegregationYear2[0];

        setInnerLoad((prev) => ({ ...prev, loadMessage: `Obtendo dados de ${yearBefore3}...(4/4)` }));

        const promisesYear3 = [
            getDataToPortfolioReport(clientId, startDateBefore3, endDateBefore3, accountRegimeId, "ano", {
                isAssetAndAccountsReport: false,
                isAccumulatedTrasactionsReport: false
            }, keepSubassetsInfos)
        ];

        if (isSegregationTab) {
            promisesYear3.push(
                ...optionsSegregation.map(({ value }) =>
                    getDataToPortfolioReport(clientId, startDateBefore3, endDateBefore3, value, "ano", {
                        isAssetAndAccountsReport: false,
                        isAccumulatedTrasactionsReport: false
                    }, keepSubassetsInfos)
                )
            );
        }
        const responseSegregationYear3 = await Promise.all(promisesYear3);
        const dataYearBefore3 = responseSegregationYear3[0];

        const checkIsAssetLine = (cod) => {
            return !["Total investimentos", "Disponibilidade", "Total patrimônio"].includes(cod);
        }

        // Função utilitária para evitar repetição
        const formatBlock = (block) =>
            (block?.dataToPortfolioReport || [])
                .filter((el) => checkIsAssetLine(el.fund_name))
                .map((el) => ({
                    balanceToDisplay: el.balanceToDisplay,
                    accountRegimeId: el.accountRegimeId,
                    rt2: el.rt2,
                    rt1: el.rt1,
                    article: el.article_to_show,
                    fund_id: el.fund_id,
                    fund_name: el.fund_name,
                    isTitlesLine: el.isTitlesLine,
                    participation: el.participation,
                    subAssetsTitles: el.isTitlesLine && el.subAssetsTitles ? [...el.subAssetsTitles] : null
                }));

        // Aplicando a mesma função em cada dataset
        const formattedDataMonth = formatBlock(dataMonth);
        const formattedYearBefore1 = formatBlock(dataYearBefore1);
        const formattedYearBefore2 = formatBlock(dataYearBefore2);
        const formattedYearBefore3 = formatBlock(dataYearBefore3);
        // console.log("formattedDataMonth: ", formattedDataMonth);
        // console.log("formattedYearBefore1: ", formattedYearBefore1);
        // console.log("formattedYearBefore2: ", formattedYearBefore2);
        // console.log("formattedYearBefore3: ", formattedYearBefore3);

        //Ajustando linhas de títulos
        const getTitlesAssetsLines = (array) => {

            const lines = [];
            array.forEach(element => {
                lines.push.apply(lines, element.subAssetsTitles);
            });

            return lines;
        }

        if (keepSubassetsInfos) {

            formattedDataMonth.push.apply(formattedDataMonth, getTitlesAssetsLines(formattedDataMonth).filter(el => el.isTitlesLine));
            formattedYearBefore1.push.apply(formattedYearBefore1, getTitlesAssetsLines(formattedYearBefore1).filter(el => el.isTitlesLine));
            formattedYearBefore2.push.apply(formattedYearBefore2, getTitlesAssetsLines(formattedYearBefore2).filter(el => el.isTitlesLine));
            formattedYearBefore3.push.apply(formattedYearBefore3, getTitlesAssetsLines(formattedYearBefore3).filter(el => el.isTitlesLine));
            // console.log("After adding titles lines:");
            // console.log("formattedDataMonth: ", formattedDataMonth);
            // console.log("formattedYearBefore1: ", formattedYearBefore1);
            // console.log("formattedYearBefore2: ", formattedYearBefore2);
            // console.log("formattedYearBefore3: ", formattedYearBefore3);

        }

        const allData = [
            ...formattedDataMonth,
            ...formattedYearBefore1,
            ...formattedYearBefore2,
            ...formattedYearBefore3
        ];


        const articles = [...new Set(allData.map(e => e.article))];

        //Identidade da linha: fund_id para fundos; fund_name para títulos e para os grupos
        //sem fund_id (consignado, genéricos/imóveis), que senão colidiriam todos na chave "undefined"
        const getAssetKey = (el) => (el.isTitlesLine || el.fund_id == null) ? el.fund_name : el.fund_id;

        const mapNameById = {};
        allData.forEach(el => {

            const id = getAssetKey(el);
            if (!mapNameById[id]) mapNameById[id] = el.fund_name;
        })

        const formatted = [];

        const segregationBalanceMap = {
            month: {},
            year1: {},
            year2: {},
            year3: {},
        };

        Object.entries(mapNameById).map(([fundId, fundName]) => {

            const getFundLine = (array) => {
                //Object.entries transforma a chave em string, por isso a comparação frouxa com fund_id
                return array.find(el => getAssetKey(el) == fundId);
            }

            const fundInMonth = getFundLine(formattedDataMonth);
            const fundInYearBefore1 = getFundLine(formattedYearBefore1);
            const fundInYearBefore2 = getFundLine(formattedYearBefore2);
            const fundInYearBefore3 = getFundLine(formattedYearBefore3);

            //Do período mais recente para o mais antigo: o mês corrente tem precedência
            const periodLines = [fundInMonth, fundInYearBefore1, fundInYearBefore2, fundInYearBefore3]
                .filter(el => el);

            const multipleArticles = [];
            periodLines.forEach(el => {
                if (el.article && !multipleArticles.includes(el.article)) multipleArticles.push(el.article);
            });

            const mostRecentLine = periodLines[0];
            const article = mostRecentLine?.article ?? null;
            const accountRegimeId = mostRecentLine?.accountRegimeId ?? null;
            const isTitlesLine = mostRecentLine?.isTitlesLine ?? null;

            const formattedRow = {
                id: fundId,
                fund_name: fundName,
                article: article,
                multipleArticles: multipleArticles,
                accountRegimeId: accountRegimeId,
                isTitlesLine: isTitlesLine,

                month: {
                    rentMoney: fundInMonth ? fundInMonth.rt1 : "-",
                    rentPercent: fundInMonth ? fundInMonth.rt2 : "-",
                    participation: fundInMonth ? parsePercentage(fundInMonth.participation) : null,
                    balance: fundInMonth ? parseBrlCurrencyToFloat(fundInMonth.balanceToDisplay) : null,
                },

                year1: {
                    rentMoney: fundInYearBefore1 ? fundInYearBefore1.rt1 : "-",
                    rentPercent: fundInYearBefore1 ? fundInYearBefore1.rt2 : "-",
                    participation: fundInYearBefore1 ? parsePercentage(fundInYearBefore1.participation) : null,
                    balance: fundInYearBefore1 ? parseBrlCurrencyToFloat(fundInYearBefore1.balanceToDisplay) : null,
                },

                year2: {
                    rentMoney: fundInYearBefore2 ? fundInYearBefore2.rt1 : "-",
                    rentPercent: fundInYearBefore2 ? fundInYearBefore2.rt2 : "-",
                    participation: fundInYearBefore2 ? parsePercentage(fundInYearBefore2.participation) : null,
                    balance: fundInYearBefore2 ? parseBrlCurrencyToFloat(fundInYearBefore2.balanceToDisplay) : null,
                },

                year3: {
                    rentMoney: fundInYearBefore3 ? fundInYearBefore3.rt1 : "-",
                    rentPercent: fundInYearBefore3 ? fundInYearBefore3.rt2 : "-",
                    participation: fundInYearBefore3 ? parsePercentage(fundInYearBefore3.participation) : null,
                    balance: fundInYearBefore3 ? parseBrlCurrencyToFloat(fundInYearBefore3.balanceToDisplay) : null,
                },

            };

            formatted.push(formattedRow);

            if (matchRentDebug({ fund_name: fundName, id: fundId })) {
                rentDebugRow(formattedRow);
            }
        });

        //DEBUG: transações cruas do ativo alvo (roda uma única vez, depois dos quatro blocos)
        const rentDebugTargetId = Object.entries(mapNameById)
            .find(([id, name]) => matchRentDebug({ fund_name: name, id }))?.[0];

        if (rentDebugTargetId) {

            await rentDebugTransactions(clientId, rentDebugTargetId, mapNameById[rentDebugTargetId], {
                fromYear: yearBefore3,
                toYear: yearBefore1,
                toMonth: month,
            });

            console.log('[RENT-DEBUG] dump completo — copie com: copy(JSON.stringify(window.__rentDebug))',
                window.__rentDebug);
        }

        const totalInvestmentsMonth = dataMonth.dataToPortfolioReport.find(el => el.fund_name === "Total investimentos")?.balanceToDisplay;
        const totalInvestmentsYearBefore1 = dataYearBefore1.dataToPortfolioReport.find(el => el.fund_name === "Total investimentos")?.balanceToDisplay
        const totalInvestmentsYearBefore2 = dataYearBefore2.dataToPortfolioReport.find(el => el.fund_name === "Total investimentos")?.balanceToDisplay
        const totalInvestmentsYearBefore3 = dataYearBefore3.dataToPortfolioReport.find(el => el.fund_name === "Total investimentos")?.balanceToDisplay

        //Obtendo saldo por segregação
        // Helper function to build balance map from subAssets
        const buildBalanceMap = (subAssets) => {
            const map = {};
            ['funds', 'titles'].forEach(type => {
                subAssets[type].forEach(subAsset => {
                    if (!map[subAsset.accountRegimeId]) {
                        map[subAsset.accountRegimeId] = 0;
                    }

                    map[subAsset.accountRegimeId] += subAsset.balanceNow;
                });
            });
            return map;
        };

        const mapBalancesSegregationMonth = buildBalanceMap(dataMonth.subAssets);
        const mapBalancesSegregationYearBefore1 = buildBalanceMap(dataYearBefore1.subAssets);
        const mapBalancesSegregationYearBefore2 = buildBalanceMap(dataYearBefore2.subAssets);
        const mapBalancesSegregationYearBefore3 = buildBalanceMap(dataYearBefore3.subAssets);

        segregationBalanceMap.month = mapBalancesSegregationMonth;
        segregationBalanceMap.year1 = mapBalancesSegregationYearBefore1;
        segregationBalanceMap.year2 = mapBalancesSegregationYearBefore2;
        segregationBalanceMap.year3 = mapBalancesSegregationYearBefore3;

        const segregationRentMap = {
            month: {},
            year1: {},
            year2: {},
            year3: {},
        };

        //Calculando a participação em segregação de cada asset
        const calculateParticipation = (key, subAssets, balanceMap) => {
            ['funds', 'titles'].forEach(type => {
                subAssets[type].forEach(subAsset => {
                    subAsset.participationInSegregation = subAsset.balanceNow / balanceMap[subAsset.accountRegimeId];
                    if (segregationRentMap[key][subAsset.accountRegimeId] === undefined) {
                        segregationRentMap[key][subAsset.accountRegimeId] = 0;
                    }
                    segregationRentMap[key][subAsset.accountRegimeId] += subAsset.participationInSegregation * (subAsset.rt2 / 100);
                });
            });
        };

        calculateParticipation("month", dataMonth.subAssets, mapBalancesSegregationMonth);
        calculateParticipation("year1", dataYearBefore1.subAssets, mapBalancesSegregationYearBefore1);
        calculateParticipation("year2", dataYearBefore2.subAssets, mapBalancesSegregationYearBefore2);
        calculateParticipation("year3", dataYearBefore3.subAssets, mapBalancesSegregationYearBefore3);

        console.log("mapBalancesSegregationMonth: ", mapBalancesSegregationMonth);
        console.log("segregationRentMap: ", segregationRentMap);

        const monthSegregationRents = {};
        responseSegregationMonth.forEach(response => {
            //obtendo a linha Total Investimentos do relatório
            monthSegregationRents[response.accountRegimeId] = formatNaN(response.dataToPortfolioReport.at(-3)?.rt2);
        });
        const year1SegregationRents = {};
        responseSegregationYear1.forEach(response => {
            //obtendo a linha Total Investimentos do relatório
            year1SegregationRents[response.accountRegimeId] = formatNaN(response.dataToPortfolioReport.at(-3)?.rt2);
        });
        const year2SegregationRents = {};
        responseSegregationYear2.forEach(response => {
            //obtendo a linha Total Investimentos do relatório
            year2SegregationRents[response.accountRegimeId] = formatNaN(response.dataToPortfolioReport.at(-3)?.rt2);
        });
        const year3SegregationRents = {};
        responseSegregationYear3.forEach(response => {
            //obtendo a linha Total Investimentos do relatório
            year3SegregationRents[response.accountRegimeId] = formatNaN(response.dataToPortfolioReport.at(-3)?.rt2);
        });

        const data = {
            success: true,
            data: {
                month: formattedDataMonth,
                yearBefore1: formattedYearBefore1,
                yearBefore2: formattedYearBefore2,
                yearBefore3: formattedYearBefore3,
                monthSegregationRents: monthSegregationRents,
                year1SegregationRents: year1SegregationRents,
                year2SegregationRents: year2SegregationRents,
                year3SegregationRents: year3SegregationRents,
                monthSubAssets: dataMonth.subAssets,
                yearBefore1SubAssets: dataYearBefore1.subAssets,
                yearBefore2SubAssets: dataYearBefore2.subAssets,
                yearBefore3SubAssets: dataYearBefore3.subAssets,
                years: [yearBefore1, yearBefore2, yearBefore3],
                articles: articles,
                formatted: formatted,
                totalsInvestments: {
                    month: parseBrlCurrencyToFloat(totalInvestmentsMonth ?? 0),
                    year1: parseBrlCurrencyToFloat(totalInvestmentsYearBefore1 ?? 0),
                    year2: parseBrlCurrencyToFloat(totalInvestmentsYearBefore2 ?? 0),
                    year3: parseBrlCurrencyToFloat(totalInvestmentsYearBefore3 ?? 0)
                },
                // optionsSegregation: [{
                //     name: "Consolidada",
                //     value: 0,
                // }, ...optionsSegregation],
                optionsSegregation: [...optionsSegregation],
                segregationBalanceMap,
                segregationRentMap
            }
        }

        return data;
    } catch (error) {
        console.error("Error: ", error);
        return {
            success: false,

        }
    }

}

// Acumula, por ativo de Empréstimo Consignado, o retorno do ano até o mês informado.
// Como o acumulado anual correto p/ consignado não existe pronto (o relatório de
// portfólio fixa '-' para ativos genéricos), iteramos os meses e somamos/compomos os
// valores mensais já calculados corretamente por getAssetInfos.
//  - moneyYear: soma dos rentMoneyInMonth mensais
//  - percentYear: composição dos percentuais mensais ((∏(1 + r/100)) - 1) * 100
async function accumulateConsigYearByFund(clientId, year, untilMonth, setInnerLoad, accountRegimeId = null) {
    const acc = new Map();
    const lastMonth = parseInt(untilMonth, 10) || 0;
    for (let m = 1; m <= lastMonth; m++) {
        if (setInnerLoad) {
            setInnerLoad((prev) => ({ ...prev, loadMessage: `Acumulando empréstimo consignado (${m}/${lastMonth})` }));
        }
        let responseInfos;
        try {
            responseInfos = await getAssetInfos(clientId, m, year, accountRegimeId, false, null, false, null);
        } catch (e) {
            console.warn(`accumulateConsigYearByFund: falha no mês ${m}/${year}`, e);
            continue;
        }
        const assets = responseInfos?.assetsFormatted ?? [];
        for (const a of assets) {
            if (!isConsigTitle(a)) continue;
            const rawFid = a.fund_id ?? a.fund_name;
            if (!rawFid) continue;
            const fid = String(rawFid);

            const money = parseFloat(a.rentMoneyInMonth ?? a.registred_rent_now ?? 0) || 0;
            const pct = parseFloat(a.rentPercentInMonth ?? 0) || 0;

            const prev = acc.get(fid) ?? { moneyYear: 0, factor: 1 };
            prev.moneyYear += money;
            prev.factor *= (1 + pct / 100);
            acc.set(fid, prev);
        }
    }

    const result = new Map();
    for (const [fid, v] of acc.entries()) {
        result.set(fid, { moneyYear: v.moneyYear, percentYear: (v.factor - 1) * 100 });
    }
    return result;
}

export async function getDataToReturnsByArticlesReport(clientOn, startDate, endDate, setInnerLoad, accountRegimeId = null) {
    const { month, year } = getDayMonthYearByStringDate(endDate);

    // ---- helpers -------------------------------------------------------------
    const brToNumber = (raw) => {
        if (raw == null) return 0;
        if (typeof raw === "number") return Number.isFinite(raw) ? raw : 0;
        let s = String(raw).trim();
        s = s.replace(/R\$\s?/gi, "");
        const isPercent = /%$/.test(s);
        s = s.replace(/%/g, "");
        if (/,/.test(s) && /\.\d{3}/.test(s)) {
            s = s.replace(/\./g, "").replace(/,/g, ".");
        } else if (/,/.test(s) && !/\.\d{3}/.test(s)) {
            s = s.replace(/,/g, ".");
        } else {
            s = s.replace(/[^0-9.\-]/g, "");
        }

        const n = parseFloat(s);
        if (!Number.isFinite(n)) return 0;
        return isPercent ? n : n;
    };

    const getFirst = (obj, keys, fallback = undefined) => {
        for (const k of keys) {
            if (obj && obj[k] !== undefined && obj[k] !== null) return obj[k];
        }
        return fallback;
    };

    try {
        setInnerLoad((prev) => ({ ...prev, loadMessage: `Obtendo dados` }));

        const responseDataPortfolio = await getDataToPortfolioReport(
            clientOn.id,
            startDate,
            endDate,
            accountRegimeId,
            "ano",
            {
                isAssetAndAccountsReport: false,
                isAccumulatedTrasactionsReport: true
            });

        const responseInflationRates = await InflationRateAPI.getClientInflationRates(clientOn.id);

        const diarys = await loadClientDiaryByRange(
            clientOn.id,
            clientOn.selectedPortfolioMonth,
            clientOn.selectedPortfolioYear,
            'ano');


        const formattedTargets = formatTargetsToShow(responseInflationRates.body.rows, diarys.rentMonths);
        formattedTargets.reverse();

        const target = formattedTargets.find(
            item => item.month == clientOn.selectedPortfolioMonth
                &&
                item.year == clientOn.selectedPortfolioYear);

        const dataYear = (responseDataPortfolio?.dataToPortfolioReport
            ?? []).filter(
                (item) =>
                    ![
                        "Disponibilidade",
                        "Total patrimônio",
                        "Total investimentos",
                    ].includes(String(item?.fund_name).trim())
            );

        const responseInfosAssets = await getAssetInfos(clientOn.id, month, year, accountRegimeId, false, null, false, null);

        const infosAssets = responseInfosAssets?.assetsFormatted ?? []

        const validFundIds = new Set(
            dataYear
                .map((x) => getFirst(x, ["fund_id", "fund_name"]))
                .filter((v) => v !== null && v !== undefined)
                .map((v) => String(v))
        );

        const filteredInfosAssets = infosAssets.filter((asset) => {
            const key = getFirst(asset, ["fund_id", "fund_name"]);
            return key && validFundIds.has(String(key).trim());
        });

        const monthByFundId = new Map();
        const monthByFundIdPercent = new Map();
        const participationByFundId = new Map();
        console.log("filteredInfosAssets: ", filteredInfosAssets);
        for (const a of filteredInfosAssets) {
            const rawFid = getFirst(a, ["fund_id", "fund_name"]);
            if (!rawFid) continue;
            const fid = String(rawFid);

            // Linhas agrupadas de título (TÍTULOS PÚBLICOS/PRIVADOS, IMÓVEIS) guardam os totais
            // como totalAmortizations (plural, TitleController.js:2456), nome que
            // getSimpleRentMoneyTitle não conhece — a amortização cairia em 0 e o R$ do mês sairia
            // com sinal oposto ao %. getRentInMoneyMonthTitle (MODE 1) é o par exato do
            // getRentMonthTitle que produz esse %: mesma totalsGroupedTitle, mesma fórmula.
            // A ordem das condições espelha getRentMonthTitle, que também testa consignado antes.
            const returnMonth = (!isConsigTitle(a) && a.subAssetsTitles?.length)
                ? getRentInMoneyMonthTitle(a)
                : getSimpleRentMoneyTitle(a);
            const returnMonthPercent = getSimpleRentMoneyPercentTitle(a);
            const participation = getFirst(a, ["participation"]) ?? 0;

            monthByFundId.set(fid, returnMonth);
            monthByFundIdPercent.set(fid, returnMonthPercent);
            participationByFundId.set(fid, brToNumber(participation));
        }

        // Acumulado anual do consignado (rt1/rt2 vêm como '-' do relatório de portfólio).
        const hasConsig = filteredInfosAssets.some((a) => isConsigTitle(a));
        const consigYearByFid = hasConsig
            ? await accumulateConsigYearByFund(clientOn.id, year, month, setInnerLoad, accountRegimeId)
            : new Map();

        const rows = [];

        for (const y of dataYear) {
            const fid = String(getFirst(y, ["fund_id", "fund_name"]));
            const consigYear = consigYearByFid.get(fid);
            const row = {
                fund_id: getFirst(y, ["fund_id"]) ?? 0,
                fund_name: getFirst(y, ["fund_name"]) ?? 0,
                article_to_show: getFirst(y, ["article_to_show"]) ?? 0,
                balanceBefore: getFirst(y, ["balanceBeforeToDisplay"]) ?? 0,
                balanceNow: getFirst(y, ["balanceNowToDisplay"]) ?? 0,
                applications: getFirst(y, ["totalApplications"]) ?? 0,
                rescues: getFirst(y, ["totalRescues"]) ?? 0,
                amortization: applyMaskAmount(getFirst(y, ["amortization"]), true) ?? 0,
                returnYear: consigYear
                    ? applyMaskAmount(consigYear.moneyYear, true)
                    : (getFirst(y, ["rt1"]) ?? 0),
                returnYearPercent: consigYear
                    ? (applyMaskAmount(consigYear.percentYear) + '%')
                    : (getFirst(y, ["rt2"]) ?? 0),
                returnMonth: applyMaskAmount(monthByFundId.get(fid) ?? 0, true),
                returnMonthPercent: applyMaskAmount(monthByFundIdPercent.get(fid) ?? 0) + '%',
                participation: (participationByFundId.get(fid) ?? 0) / 100,
            };

            rows.push(row);
        }

        const groupedMap = rows.reduce((acc, item) => {
            const key = item.article_to_show || "SEM_ARTIGO";
            if (!acc[key]) {
                acc[key] = {
                    article_to_show: key,
                    funds: [],
                    totalBalanceBefore: 0,
                    totalBalanceNow: 0,
                    totalApplications: 0,
                    totalRescues: 0,
                    totalAmortization: 0,
                    totalReturnYear: 0,
                    totalReturnYearPercent: 0,
                    totalReturnMonth: 0,
                    totalReturnMonthPercent: 0,
                    actuarialTargetMonth: 0,
                    actuarialTargetYear: 0,
                };
            }

            acc[key].funds.push(item);

            // somatórios do grupo (desmascarando valores)
            acc[key].totalBalanceBefore += brToNumber(item.balanceBefore);
            acc[key].totalBalanceNow += brToNumber(item.balanceNow);
            acc[key].totalApplications += brToNumber(item.applications);
            acc[key].totalRescues += brToNumber(item.rescues);
            acc[key].totalAmortization += brToNumber(item.amortization);
            acc[key].totalReturnYear += brToNumber(item.returnYear);
            acc[key].totalReturnMonth += brToNumber(item.returnMonth);

            return acc;
        }, {});

        Object.values(groupedMap).forEach((group) => {

            let weightedYearPct = 0;
            let weightedMonthPct = 0;
            let totalParticipation = 0;

            for (const fund of group.funds) {

                const fundYearPct = brToNumber(fund.returnYearPercent);
                const fundMonthPct = brToNumber(fund.returnMonthPercent);

                // participation é a fatia do ativo no patrimônio TOTAL, não no artigo: sem
                // normalizar pela soma do grupo o número vira a contribuição do artigo ao retorno
                // da carteira, e não a rentabilidade do artigo (era o que fazia "8, I" sair 0,04%).
                const participation = brToNumber(fund.participation);

                weightedYearPct += fundYearPct * participation;
                weightedMonthPct += fundMonthPct * participation;
                totalParticipation += participation;
            }

            if (totalParticipation !== 0) {
                weightedYearPct /= totalParticipation;
                weightedMonthPct /= totalParticipation;
            }

            group.totalReturnYearPercent = applyMaskAmount(weightedYearPct) + "%";
            group.totalReturnMonthPercent = applyMaskAmount(weightedMonthPct) + "%";

            group.totalBalanceBefore = applyMaskAmount(group.totalBalanceBefore, true);
            group.totalBalanceNow = applyMaskAmount(group.totalBalanceNow, true);
            group.totalApplications = applyMaskAmount(group.totalApplications, true);
            group.totalRescues = applyMaskAmount(group.totalRescues, true);
            group.totalAmortization = applyMaskAmount(group.totalAmortization, true);
            group.totalReturnMonth = applyMaskAmount(group.totalReturnMonth, true);
            group.totalReturnYear = applyMaskAmount(group.totalReturnYear, true);
            group.actuarialTargetMonth = target ? (target.use_ipca ? applyMaskAmount(target.taxMonthIpca) + "%" : applyMaskAmount(target.taxMonthInpc) + "%") : "Não informada";
            group.actuarialTargetYear = target ? (target.use_ipca ? applyMaskAmount(target.taxAcumIpca) + "%" : applyMaskAmount(target.taxAcumInpc) + "%") : "Não informada";
        });

        const groupedRows = Object.values(groupedMap);

        setInnerLoad(null);

        return { data: groupedRows };

    } catch (error) {
        setInnerLoad(null);
        console.error("getDataToReturnsByArticlesReport Error: ", error);
    }

}

/**
 * Monta os dados do relatório de ranking de fundos.
 * Quando a tela já carregou e filtrou o ranking, reaproveita-se o que está exibido para que o PDF
 * mostre exatamente o mesmo recorte. O clone é obrigatório: a formatação abaixo escreve nos objetos
 * e corromperia as linhas da tabela na tela.
 * @param {number} consultingId usado só no fallback, quando não vem dado carregado
 * @param {object} loadedData { rows, totalClientsNumber } vindos da tela
 */
export async function getDataToFundsRankingReport(consultingId, loadedData) {

    let rows = null;
    let totalClientsNumber = null;

    if (loadedData && loadedData.rows) {
        rows = JSON.parse(JSON.stringify(loadedData.rows));
        totalClientsNumber = loadedData.totalClientsNumber;
    }

    if (!rows) {
        const fundsRankingResponse = await FundAPI.getRankingFundsPerClient(consultingId)
        if (!fundsRankingResponse.success) {
            return { isSuccessful: false }
        }
        rows = fundsRankingResponse.body.rows
    }

    if (!totalClientsNumber) {
        const allClientsResponse = await ClientAPI.listAllClients()
        if (!allClientsResponse.success) {
            return { isSuccessful: false }
        }
        totalClientsNumber = allClientsResponse.body.rowCount
    }

    rows.forEach(row => {
        row.percentage = applyMaskAmount((row.number_of_clients / totalClientsNumber) * 100) + '%'
        row.benchmark = row.benchmark || '-'
        row.device_abbreviation = row.device_abbreviation || '-'
    })

    return {
        isSuccessful: true,
        dataToFundsRankingReport: rows
    }
};

export async function getDataToDemonstrativeReport(client, month, year, loadedFunds) {

    //Quando a tela do demonstrativo já carregou os fundos, reaproveita-se o resultado para não
    //repetir a consulta à Comdinheiro. A formatação abaixo altera os objetos no lugar, então
    //clona-se o que veio da tela para não corromper o que está sendo exibido.
    const response = loadedFunds
        ? { success: true, funds: JSON.parse(JSON.stringify(loadedFunds)) }
        : await getFundsDemonstrative(client.id, month, year)
    // const response = {}
    // response.success = true
    // response.funds = fundsTest;

    if (response.success) {

        //formatando
        response.funds.forEach(element => {

            element.totalApplication = applyMaskAmount(element.totalApplication);
            element.totalRescue = applyMaskAmount(element.totalRescue);
            element.participation = applyMaskAmount(element.participation) + '%';
            element.rentMoneyInMonth = applyMaskAmount(element.rentMoneyInMonth, true) + " (" + applyMaskAmount(element.rentPercentInMonth, null, true) + '%)';
            element.balance_now = applyMaskAmount(element.balance_now);
            element.quota_amount_now = applyMaskAmount(element.quota_amount_now);


            if (element.risco_retorno) {

                element.risco_retorno.cota = applyMaskAmountComdinheiroFreeDecimals(element.risco_retorno.cota);
                element.risco_retorno.volatilidade = applyMaskAmountComdinheiro(element.risco_retorno.volatilidade)
                element.risco_retorno.perda_maxima = applyMaskAmountComdinheiro(element.risco_retorno.perda_maxima)
                element.risco_retorno.var = applyMaskAmountComdinheiro(element.risco_retorno.var)
                element.risco_retorno.indice_sharpe = applyMaskAmountComdinheiro(element.risco_retorno.indice_sharpe)
                element.risco_retorno.retorno_maximo = applyMaskAmountComdinheiro(element.risco_retorno.retorno_maximo)
                element.risco_retorno.retorno_minimo = applyMaskAmountComdinheiro(element.risco_retorno.retorno_minimo)
                element.risco_retorno.retorno_medio = applyMaskAmountComdinheiro(element.risco_retorno.retorno_medio)
            }

            if (element.dados_cadastrais) {

                element.dados_cadastrais.num_cotistas = applyMaskAmountComdinheiro(element.dados_cadastrais.num_cotistas)
                element.dados_cadastrais.pl_anbima = applyMaskAmountComdinheiro(element.dados_cadastrais.pl_anbima)
            }


            element.benchmark = element.benchmark ? element.benchmark : "-";

            if (element.risco_retorno_benchmark) {
                element.risco_retorno_benchmark.volatilidade = element.risco_retorno_benchmark && element.risco_retorno_benchmark.volatilidade ? applyMaskAmountComdinheiro(element.risco_retorno_benchmark.volatilidade) : '-'
                element.risco_retorno_benchmark.perda_maxima = element.risco_retorno_benchmark && element.risco_retorno_benchmark.perda_maxima ? applyMaskAmountComdinheiro(element.risco_retorno_benchmark.perda_maxima) : '-'
                element.risco_retorno_benchmark.var = element.risco_retorno_benchmark && element.risco_retorno_benchmark.var ? applyMaskAmountComdinheiro(element.risco_retorno_benchmark.var) : '-'
                element.risco_retorno_benchmark.indice_sharpe = element.risco_retorno_benchmark && element.risco_retorno_benchmark.indice_sharpe ? applyMaskAmountComdinheiro(element.risco_retorno_benchmark.indice_sharpe) : '-'
                element.risco_retorno_benchmark.retorno_maximo = element.risco_retorno_benchmark && element.risco_retorno_benchmark.retorno_maximo ? applyMaskAmountComdinheiro(element.risco_retorno_benchmark.retorno_maximo) : '-'
                element.risco_retorno_benchmark.retorno_minimo = element.risco_retorno_benchmark && element.risco_retorno_benchmark.retorno_minimo ? applyMaskAmountComdinheiro(element.risco_retorno_benchmark.retorno_minimo) : '-'
                element.risco_retorno_benchmark.retorno_medio = element.risco_retorno_benchmark && element.risco_retorno_benchmark.retorno_medio ? applyMaskAmountComdinheiro(element.risco_retorno_benchmark.retorno_medio) : '-'
            } else {

                element.risco_retorno_benchmark = {};
                element.risco_retorno_benchmark.volatilidade = '-'
                element.risco_retorno_benchmark.perda_maxima = '-'
                element.risco_retorno_benchmark.var = '-'
                element.risco_retorno_benchmark.indice_sharpe = '-'
                element.risco_retorno_benchmark.retorno_maximo = '-'
                element.risco_retorno_benchmark.retorno_minimo = '-'
                element.risco_retorno_benchmark.retorno_medio = '-'
            }


        });

        return {
            success: true,
            dataToReport: response.funds,
        }

    } else {
        return {
            success: false,
        }
    }
};

function removingNoDataAcumAssetsTrasactionsReport(assets) {

    const newAssets = [];
    const zeroString = "R$ 0,00";

    assets.forEach(element => {
        const {
            balanceNowToDisplay,
            balanceBeforeToDisplay,
            totalApplications,
            totalRescues,
            totalAmortizations,
            rt1
        } = element;

        if (balanceNowToDisplay === zeroString
            && balanceBeforeToDisplay === zeroString
            && totalApplications === zeroString
            && totalRescues === zeroString
            && totalAmortizations === zeroString
            && rt1 === zeroString
        ) {
            return;
        } else {
            newAssets.push(element)
        }
    });

    return newAssets;

}

function removingNoDataAcumAssets(assets) {

    const newAssets = [];
    const zeroAmountString = "R$ 0,00";
    const zeroPercentString = "0,00%";


    assets.forEach(element => {

        const {
            balanceToDisplay,
            rt1,
            rt2,
            participation,
            negativeBalance
        } = element;

        if (balanceToDisplay === zeroAmountString
            && participation === zeroPercentString
            && rt1 === zeroAmountString
            && rt2 === zeroPercentString
            //Adicionando condição para manter assets com saldo negativo
            && negativeBalance >= 0
        ) {
            return;
        } else {
            newAssets.push(element)
        }
    });

    return newAssets;

}

function compareSortByPercent(a, b) {
    if (a.percent < b.percent)
        return 1;
    if (a.percent > b.percent)
        return -1;
    return 0;
}

//export async function getDataToDistribuitionReport(clientId, month, year) {
/**
 *
 * @param {number} clientId
 * @param {string} startDate
 * @param {string} endDate
 * @typedef {{
*  dataToTable: {
    *  c1: string;
    *  c2: string;
    *  c3: string;
    *  c4: string;
    *  percent: number;
    * }[];
    *  dataToChart: {
    *  datasets: import('chart.js').ChartDataSets[];
    *  labels: string[];
    *  }
    * }} DataToReport
    * @returns {Promise<{
       success: boolean;
       dataToDistributionReport?: DataToReport[];
     }}
    */
export async function getDataToDistribuitionReport(
    clientId,
    startDate,
    endDate, regimeId
) {

    const { month, year } = getDayMonthYearByStringDate(endDate);

    let responseInfosAssets = await getSimpleNormalizedAssets(clientId,
        month,
        year,
        regimeId)

    if (responseInfosAssets.success) {

        let dataToDistributionReport = [];
        console.log("distributionOptionClassification: ", distributionOptionClassification);
        Object.entries(distributionOptionClassification).forEach(optionArray => {
            let selectedDistributionOptionLabel = optionArray[1];

            let JUST_TWO_WORDS = isOptionValidToJustTwoWords(selectedDistributionOptionLabel);

            //Acrescentando para não quebrar relatório
            if (selectedDistributionOptionLabel == distributionOptionClassification.manager_anbima
                || selectedDistributionOptionLabel == distributionOptionClassification.administrator_anbima) {
                JUST_TWO_WORDS = true;
            }

            //splitTitles: no PDF a linha TÍTULOS sai direto como TÍTULOS PÚBLICOS e TÍTULOS PRIVADOS
            let distributionData = groupByDistributionOptions(responseInfosAssets.assets, selectedDistributionOptionLabel, JUST_TWO_WORDS, null, stringPtDateToJsDate(endDate), true);

            //Carteira sem títulos não gera página de Vencimentos. É a última distribuição, então os índices
            //dos gráficos (chartDistribution{i+1}) das anteriores não mudam
            if (selectedDistributionOptionLabel == distributionOptionClassification.maturity
                && Object.keys(distributionData.dataToFormat.assetClasses).length === 0) {
                return;
            }

            let getFormatedDistributionDataToReport = () => {
                let generateTableRows = () => {
                    Object.entries(assetClasses).map(([label, row]) => {
                        let formatedLabel = JUST_TWO_WORDS ? formatTextForValidDisplay(label, 2) : label;

                        //Linha com subRows (TÍTULOS) não tem fatia própria: entram só as subRows.
                        //chartIndex é a posição da fatia no gráfico, para a cor da legenda casar
                        const rowsToReport = row.subRows ?
                            row.subRows.map(subRow => ({ ...subRow, formatedLabel: subRow.label }))
                            : [{ ...row, formatedLabel }];

                        rowsToReport.forEach(rowToReport => {
                            dataToTable.push({
                                c1: checkFinalLabelDistribuitionTable(rowToReport.formatedLabel),
                                percent: rowToReport.percent,
                                c2: applyMaskAmount(rowToReport.percent),
                                c3: applyMaskAmount(rowToReport.amount, true),
                                c4: 'legColor chartColor' + rowToReport.chartIndex, //Ao alterar as cores no unoTheme também deve-se alterar as classes no header lá do servidor de relatórios
                            });
                        });
                    });
                };

                let addTotalRow = () => {
                    dataToTable.push({
                        c1: 'totalLine',
                        c2: '100,00',
                        c3: applyMaskAmount(totalAmount, true),
                    });
                };

                let setDefaultSortToTable = () => {
                    let isSelectedDistributionOptionDevice = selectedDistributionOptionLabel == device;

                    if (isSelectedDistributionOptionDevice) {
                        dataToTable = sortArrayOrderBy(dataToTable, 'label', order.DESC);
                    } else {
                        dataToTable = sortArrayOrderBy(dataToTable, 'valuePercent', order.ASC);
                    }
                };

                let updateDistributionDataObjectFormat = () => {
                    distributionData.dataToTable.data = dataToTable;
                    delete distributionData.dataToFormat;
                }

                let { assetClasses, totalAmount } = distributionData.dataToFormat;
                let dataToTable = [];

                generateTableRows();

                //Ordenar dataToTale por percentual 
                dataToTable.sort(compareSortByPercent)

                addTotalRow();
                setDefaultSortToTable();
                updateDistributionDataObjectFormat();

                return distributionData;
            };

            let dataToReport = getFormatedDistributionDataToReport();

            dataToDistributionReport.push(dataToReport);
        });

        return {
            success: true,
            dataToDistributionReport,
        }

    } else {
        return {
            success: false,
        }
    }

};

/**
 * Retorna os dados a serem utilizados na montagem do relatório de metas
 */
//export async function getDataToTargetsReport(clientId, month, year) {
export async function getDataToTargetsReport(client, startDate, endDate, periodReport, segregationCode) {

    const clientId = client.id

    console.log("segregationCode: ", segregationCode);

    const { month, year } = getDayMonthYearByStringDate(endDate);
    const response = await InflationRateAPI.getClientInflationRates(clientId);
    if (response.success) {

        //Novo método balance
        const diarys =
            segregationCode != 0 ?
                await loadClientRentsBySegregation(clientId, month, year, periodReport == 'mensal' ? null : periodReport)
                :
                await loadClientDiaryByRange(clientId, month, year, periodReport == 'mensal' ? null : periodReport);

        console.log("DIARIOS: ", diarys);

        const responseClientTransactions = await TransactionAPI.getClientAllTransactionByDateRangeAndRegime(
            clientId,
            timeStampToPtDate(client.portfolio_init),
            timeStampToPtDate(portfolioClosedToDate(client.portfolio_closed)),
            segregationCode != 0 ? segregationCode : null
        );
        let clientTransactions = null;
        if (responseClientTransactions.success) {
            clientTransactions = responseClientTransactions.body.rows.filter(el => !el.is_split);
        }

        const oficialDiaries = segregationCode != 0 ? diarys.mapRentsMonthsBySegregation[segregationCode] : diarys;

        let dataToReport = formatTargetsAndRentsToShow(response.body.rows,
            oficialDiaries.rentMonths, oficialDiaries.mapAccountsBalances, oficialDiaries.mapAssetsBalances, clientTransactions,
            oficialDiaries.mapConsigRentByPeriod);

        //formatando para relatório
        let arrayToReport = [];
        dataToReport.forEach(yearTarget => {

            if (yearTarget.finalTargetsToShow && yearTarget.finalTargetsToShow.length > 0) {

                //Linha do ano
                arrayToReport.push({
                    period: yearTarget.year,
                    balance_before: "year_line",
                    balance_now: "",
                    target: yearTarget.use_ipca ? 'IPCA + ' + yearTarget.tax + "% a.a." : 'INPC + ' + yearTarget.tax + "% a.a.",
                    rent: "",
                    gap: "",
                })


                //Linhas dos meses
                yearTarget.finalTargetsToShow.forEach(monthTarget => {
                    arrayToReport.push({
                        period: getMonthName(monthTarget.month),
                        balance_before: applyMaskAmount(monthTarget.balance_before, true),
                        balance_now: applyMaskAmount(monthTarget.balance_now, true),
                        target: monthTarget.use_ipca ? applyMaskAmount(monthTarget.taxMonthIpca) + "%" : applyMaskAmount(monthTarget.taxMonthInpc) + "%",
                        rent_money: applyMaskAmount(monthTarget.rentMonthMoney, true),
                        rent_percent: applyMaskAmount(monthTarget.rentPercent) + "%",
                        gap: monthTarget.use_ipca ?
                            applyMaskAmount(monthTarget.rentPercent - monthTarget.taxMonthIpca) + "p.p."
                            :
                            applyMaskAmount(monthTarget.rentPercent - monthTarget.taxMonthInpc) + "p.p.",
                    })
                });

                //Linha total dos meses do ano
                arrayToReport.push({
                    period: 'Total',
                    balance_before: applyMaskAmount(yearTarget.finalTargetsToShow[yearTarget.finalTargetsToShow.length - 1].balance_before, true),
                    balance_now: applyMaskAmount(yearTarget.finalTargetsToShow[yearTarget.finalTargetsToShow.length - 1].balance_now, true),
                    target: yearTarget.use_ipca ? applyMaskAmount(yearTarget.finalTargetsToShow[yearTarget.finalTargetsToShow.length - 1].taxAcumIpcaYear) + "%" : applyMaskAmount(yearTarget.finalTargetsToShow[yearTarget.finalTargetsToShow.length - 1].taxAcumInpcYear) + "%",
                    //rent_acum: applyMaskAmount(yearTarget.finalTargetsToShow[yearTarget.finalTargetsToShow.length - 1].rentAcum) + "%",
                    rent_money: applyMaskAmount(yearTarget.finalTargetsToShow[yearTarget.finalTargetsToShow.length - 1].rentMoneyAcumYear, true),
                    rent_percent: applyMaskAmount(yearTarget.finalTargetsToShow[yearTarget.finalTargetsToShow.length - 1].rentAcumYear) + "%",
                    //gap: yearTarget.use_ipca ? applyMaskAmount(yearTarget.finalTargetsToShow[yearTarget.finalTargetsToShow.length - 1].rentAcum - yearTarget.finalTargetsToShow[yearTarget.finalTargetsToShow.length - 1].taxAcumIpca) + "%" : applyMaskAmount(yearTarget.finalTargetsToShow[yearTarget.finalTargetsToShow.length - 1].rentAcum - yearTarget.finalTargetsToShow[yearTarget.finalTargetsToShow.length - 1].taxAcumIpca) + "%",
                    //gap: yearTarget.use_ipca ? applyMaskAmount(yearTarget.finalTargetsToShow[yearTarget.finalTargetsToShow.length - 1].taxAcumIpcaYear - yearTarget.finalTargetsToShow[yearTarget.finalTargetsToShow.length - 1].rentAcumYear) + "%" : applyMaskAmount(yearTarget.finalTargetsToShow[yearTarget.finalTargetsToShow.length - 1].taxAcumInpcYear - yearTarget.finalTargetsToShow[yearTarget.finalTargetsToShow.length - 1].rentAcumYear) + "%",
                    gap: yearTarget.use_ipca ?
                        applyMaskAmount(yearTarget.finalTargetsToShow[yearTarget.finalTargetsToShow.length - 1].rentAcumYear - yearTarget.finalTargetsToShow[yearTarget.finalTargetsToShow.length - 1].taxAcumIpcaYear) + "p.p."
                        :
                        applyMaskAmount(yearTarget.finalTargetsToShow[yearTarget.finalTargetsToShow.length - 1].rentAcumYear - yearTarget.finalTargetsToShow[yearTarget.finalTargetsToShow.length - 1].taxAcumInpcYear) + "p.p.",
                })
            }



        });
        console.log("DATA TO REPORT TARGETS: ", arrayToReport);

        return {
            success: true,
            dataToReport: arrayToReport,
        }

    } else {
        console.log("RESPONSE ERROR AO GERAR RELATÓRIO DE METAS: ", response.error)
        return {
            success: false,
        }
    }

};

export async function getRawDataToTargetsReport(client, segregationCode, yearLimit) {

    const clientId = client.id

    const response = await InflationRateAPI.getClientInflationRates(clientId, yearLimit);
    if (response.success) {

        const isClientOnPortfolioClosed = client.portfolio_closed;

        if (isClientOnPortfolioClosed) {

            const splittedPortfolioClosed = isClientOnPortfolioClosed.toString().trim().split('/');
            const monthClosed = parseInt(splittedPortfolioClosed[0]);
            const yearClosed = parseInt(splittedPortfolioClosed[1]);

            const diarys =
                segregationCode != 0 ?
                    await loadClientRentsBySegregation(clientId, monthClosed, yearClosed, null)
                    :
                    await loadClientDiaryByRange(clientId, monthClosed, yearClosed, null)


            const responseClientTransactions = await TransactionAPI.getClientAllTransactionByDateRangeAndRegime(
                clientId,
                timeStampToPtDate(client.portfolio_init),
                timeStampToPtDate(portfolioClosedToDate(client.portfolio_closed)),
                segregationCode != 0 ? segregationCode : null
            );

            let clientTransactions = null;
            if (responseClientTransactions.success) {
                clientTransactions = responseClientTransactions.body.rows.filter(el => !el.is_split); //removendo splits e inplits
            }

            console.log("MEGA DIARYS: ", diarys);
            console.log("segregationCode: ", segregationCode);

            const oficialDiaries = segregationCode != 0 ? diarys.mapRentsMonthsBySegregation[segregationCode] : diarys;

            const rentMonths = oficialDiaries.rentMonths;
            const clientInflationRates = response.body.rows;

            //const formatedClientInflationRates = formatInflationRatesToShow(clientInflationRates, rentMonths);
            const formatedClientInflationRates = formatTargetsAndRentsToShow(clientInflationRates, rentMonths,
                oficialDiaries.mapAccountsBalances,
                oficialDiaries.mapAssetsBalances,
                clientTransactions,
                oficialDiaries.mapConsigRentByPeriod);


            //forçamndo 12 posições no array            

            return {
                success: true,
                data: formatedClientInflationRates
            };



        } else {
            return {
                success: true,
                data: [],
            }

        }




    } else {
        return {
            success: false,
        }
    }

};

/**
 * Retorna os dados a serem utilizados na montagem do relatório de meus fundos
 */
//export async function getDataToDashboardReport(clientId, month, year, periodReport) {
export async function getDataToDashboardReport(clientId, startDate, endDate, periodReport, portfolioInit) {

    console.log('periodReportxxx: ', periodReport);

    const { month, year } = getDayMonthYearByStringDate(endDate);

    let oficialPeriodReport = null;
    if (periodReport == 24 || periodReport == 36) {
        oficialPeriodReport = 12;
    } else if (periodReport == 'mensal') {
        oficialPeriodReport = 'ano';
    } else {
        oficialPeriodReport = periodReport; //ano
    }

    let diarys = await loadClientDiaryByRange(clientId,
        month,
        year, oficialPeriodReport);

    const rentsToVar = await loadClientDiaryPlsByLimit(clientId, month, year, 252); //LimitToVar

    const dataToChartEvolution = makeChartEvolutionPL(diarys.mapAssetsBalances, diarys.mapAccountsBalances, diarys.periodToRemove, portfolioInit);

    //Obtendo o valor máximo para utilizar nos ticks do gráfico
    let maxValue = 0;
    if (dataToChartEvolution && dataToChartEvolution.datasets && dataToChartEvolution.datasets.length == 1) {
        dataToChartEvolution.datasets[0].data.forEach(element => {

            if (element.y > maxValue) {
                maxValue = element.y;
            }

        });
    }


    const rentMonthActual = diarys.rentMonths[month + "/" + year];
    console.log('rentMonthActual: ', rentMonthActual);

    const responseInflates = await InflationRateAPI.getClientInflationRates(clientId);

    let formattedTargets = formatTargetsToShow(responseInflates.body.rows, diarys.rentMonths);
    formattedTargets.reverse();

    //setRentsPeriod(diarys.arrayRents);
    //setTargetsPeriod(formattedTargets);

    const dataToChartCompare = makeChartCompare(diarys.arrayRents, formattedTargets, 0); //terceiro parametros o type do gráfico 0 para mensal e 1 para acumulado        

    let targetActualMonth = null;
    for (let i = 0; i < formattedTargets.length; i++) {
        let target = formattedTargets[i];
        if (target.month == month && target.year == year) {
            targetActualMonth = target;
            break;
        }
    }


    let keyActualMonth = month + "/" + year;
    // console.log('diarys.mapAccountsBalances: ', diarys.mapAccountsBalances);
    // console.log('keyActualMonth: ', keyActualMonth);
    // console.log('diarys.mapAccountsBalances[keyActualMonth]: ', diarys.mapAccountsBalances[keyActualMonth]);
    // console.log('NEW PL: ', diarys.rentMonths[keyActualMonth].diarys[diarys.rentMonths[keyActualMonth].diarys.length - 1].new_pl);

    const { mapAssetsBalances } = diarys;
    //informações inciais
    let topData = {
        //plMonth: applyMaskAmount(parseFloat(diarys.rentMonths[keyActualMonth].diarys[diarys.rentMonths[keyActualMonth].diarys.length - 1].new_pl) + (diarys.mapAccountsBalances[keyActualMonth] ? diarys.mapAccountsBalances[keyActualMonth] : 0), true),
        plMonth: applyMaskAmount(mapAssetsBalances[keyActualMonth]
            + (diarys.mapAccountsBalances[keyActualMonth] ? diarys.mapAccountsBalances[keyActualMonth] : 0), true),
        rentMonth: rentMonthActual.rent,
        rentPorcentMonth: rentMonthActual.rent,
        rentPorcentAcum: rentMonthActual.rentAcum,

        targetMonth: targetActualMonth ? (targetActualMonth.use_ipca ? targetActualMonth.taxMonthIpca : targetActualMonth.taxMonthInpc) : null,
        targetAccumulated: targetActualMonth ? (targetActualMonth.use_ipca ? targetActualMonth.taxAcumIpca : targetActualMonth.taxAcumInpc) : null,
    }

    topData = {
        ...topData,
        rentPorcentMonth: applyMaskAmount(topData.rentPorcentMonth) + "%",
        rentPorcentAcum: applyMaskAmount(topData.rentPorcentAcum) + "%",
        targetMonth: topData.targetMonth ? applyMaskAmount(topData.targetMonth) + "%" : '-',
        targetAccumulated: topData.targetAccumulated ? applyMaskAmount(topData.targetAccumulated) + "%" : '-',
        gapMonth: applyMaskAmount(topData.rentMonth - topData.targetMonth) + "p.p.",
        gapAccumulated: applyMaskAmount(topData.rentPorcentAcum - topData.targetAccumulated) + "p.p.",
        var: rentsToVar ? applyMaskAmount(var5(rentsToVar)) + '%' : '-',

        subIndicatorValue1: (topData.rentMonth >= 0 ? "+ " : '') + applyMaskAmount(topData.rentMonth) + "%",
        subIndicatorValue2: '-',

        //labelLast12months: oficialPeriodReport == 12, //Caso o periodo seja de 12 meses colocar o label ao lado dos títulos dos gráficos na dashboard
        labelLast12months: false, //removido pós mudança na forma de gerar o report mensal
    }

    console.log("TOP DATA: ", topData);

    return {
        success: true,
        maxValue: maxValue, //utilizado para aumentar o range dos ticks, evitar que o valor da barra seja cortado
        dataToReport: topData,
        dataToChartEvolution: dataToChartEvolution,
        dataToChartCompare: dataToChartCompare,
    }

};

/**
 * Retorna os dados a serem utilizados na montagem do relatório de meus fundos
 */
//export async function getDataToMyFundsReport(client, month, year, segmentId) {
export async function getDataToMyFundsReport(client, startDate, endDate, segmentId, periodReport, accountRegimeId, includeRescuedFunds = false) {

    const { month, year } = getDayMonthYearByStringDate(endDate);
    //const responseFunds = await getAllClientFunds(clientId);

    //const responseFunds = await doGetFullFundsClientByPeriodRent(client, month, year, segmentId, '')
    const monthYearStartDate = getDayMonthYearByStringDate(startDate)
    const monthYearEndDate = getDayMonthYearByStringDate(endDate)

    const theYear = monthYearStartDate.year;

    //Mensal, default
    if (periodReport == 'mensal') {

        startDate = moment.utc(client.portfolio_init).format('DD/MM/YYYY');

    }

    const currentPeriod = month + '/' + year;
    const { month: initMonth, year: initYear } = getDayMonthYearByDate(moment.utc(client.portfolio_init));
    const responseRents = await ClientAPI.getRentsByPeriod(client.id, startDate, endDate, null, segmentId ? segmentId : 0, accountRegimeId);

    console.log("RESPONSE RENTS MY FUNDS: ", responseRents);
    if (responseRents.integralFundsBalancesMap) {

        const responseFundsInfos = await FundAPI.getFundsInfosByFundIds(Object.keys(responseRents.integralFundsBalancesMap));

        if (responseFundsInfos.success) {

            const mapFundsInfos = {};
            responseFundsInfos.body.rows.forEach(el => {
                mapFundsInfos[el.id] = el;
            })

            //Mesmos filtros da tela Meus fundos: fundos encerrados nunca entram e os totalmente
            //resgatados no mês final só entram quando solicitado (toggle da tela)
            let settledFundsIds = [];
            const fundsIds = Object.keys(responseRents.integralFundsBalancesMap);
            if (fundsIds.length) {
                const responseSettledFundsIds = await FundAPI.getSettledFundsIdsByFundsIdsAndReferenceDate(fundsIds, getFirstDayMonth(month, year));
                if (responseSettledFundsIds && responseSettledFundsIds.success) {
                    settledFundsIds = responseSettledFundsIds.body.rows.map(el => el.id + "");
                }
            }

            const fundsToShow = formatMyFundsToShow(responseRents.integralFundsBalancesMap, currentPeriod, mapFundsInfos, periodReport)
                .filter(fund => !settledFundsIds.includes(fund.fundId)
                    && (includeRescuedFunds || !fund.isFullyRescued));

            let arrayToReport = [];

            //if (periodReport == 12) {
            if (periodReport == 'mensal') {

                fundsToShow.forEach(fund => {
                    arrayToReport.push({
                        fund_name: fund.fund_name ? formatStringToDisplay(fund.fund_name, 6, '...') : '-',
                        cnpj: fund.cnpj,
                        rent_month: fund.rentMonth ? applyMaskAmount(fund.rentMonth, null, true) + "%" : '-',
                        rent_year: fund.rentYear ? applyMaskAmount(fund.rentYear, null, true) + "%" : '-',
                        rent_12m: fund.rent12m ? applyMaskAmount(fund.rent12m, null, true) + "%" : '-',
                        rent_24m: fund.rent24m ? applyMaskAmount(fund.rent24m, null, true) + "%" : '-',
                        rent_since_init: fund.rentHistoric ? applyMaskAmount(fund.rentHistoric, null, true) + "%" : '-',
                    })
                });
            } else if (periodReport == 3) {

                console.log('fundsToShow: ', fundsToShow)

                fundsToShow.forEach(fund => {

                    arrayToReport.push({
                        fund_name: fund.fund_name ? formatStringToDisplay(fund.fund_name, 6, '...') : '-',
                        cnpj: fund.cnpj,
                        rent_m1: fund.rentM1 ? applyMaskAmount(fund.rentM1, null, true) + "%" : '-',
                        rent_m2: fund.rentM2 ? applyMaskAmount(fund.rentM2, null, true) + "%" : '-',
                        rent_m3: fund.rentM3 ? applyMaskAmount(fund.rentM3, null, true) + "%" : '-',
                        rent_tri: fund.rentHistoric ? applyMaskAmount(fund.rentHistoric, null, true) + "%" : '-',
                    })

                });

            } else if (periodReport == 6) {


                fundsToShow.forEach(fund => {

                    arrayToReport.push({
                        fund_name: fund.fund_name ? formatStringToDisplay(fund.fund_name, 6, '...') : '-',
                        cnpj: fund.cnpj,
                        rent_tri1: fund.rentTri1 ? applyMaskAmount(fund.rentTri1, null, true) + "%" : '-',
                        rent_tri2: fund.rentTri2 ? applyMaskAmount(fund.rentTri2, null, true) + "%" : '-',
                        rent_semester: fund.rentHistoric ? applyMaskAmount(fund.rentHistoric, null, true) + "%" : '-',
                    })

                });
            } else if (periodReport == 'ano') {

                fundsToShow.forEach(fund => {

                    arrayToReport.push({
                        fund_name: fund.fund_name ? formatStringToDisplay(fund.fund_name, 6, '...') : '-',
                        cnpj: fund.cnpj,
                        rent_sem1: fund.rentSem1 ? applyMaskAmount(fund.rentSem1, null, true) + "%" : '-',
                        rent_sem2: fund.rentSem2 ? applyMaskAmount(fund.rentSem2, null, true) + "%" : '-',
                        rent_year: fund.rentHistoric ? applyMaskAmount(fund.rentHistoric, null, true) + "%" : '-',
                    })

                });
            }

            return {
                success: true,
                dataToReport: arrayToReport,
            }

        }

        return {
            success: false,
        }


    } else {

        console.log("RESPONSE ERROR AO GERAR RELATÓRIO DE FUNDOS")
        return {
            success: false,
        }
    }

};

/**
 * Retorna os dados a serem utilizados na montagem do relatório de meus fundos
 */
//export async function getDataToMyFundsReport(client, month, year, segmentId) {
export async function getDataToMyFundsReportOld(client, startDate, endDate, segmentId, periodReport) {

    const { month, year } = getDayMonthYearByStringDate(endDate);
    //const responseFunds = await getAllClientFunds(clientId);

    //const responseFunds = await doGetFullFundsClientByPeriodRent(client, month, year, segmentId, '')
    const monthYearStartDate = getDayMonthYearByStringDate(startDate)
    const monthYearEndDate = getDayMonthYearByStringDate(endDate)

    //Mensal, default
    if (periodReport == 'mensal') {

        startDate = moment.utc(client.portfolio_init).format('DD/MM/YYYY');

    }

    const responseFunds = await doGetFundsClientByPeriodRent(client, startDate, endDate, '')
    if (responseFunds.success) {

        console.log("FUNDS: ", responseFunds.data);
        let arrayToReport = [];
        console.log("DATA TO REPORT: ", arrayToReport);

        //const responseFundsData = responseFunds.body.rows;
        const responseFundsData = responseFunds.data;

        //await formatBalancesRentsByRange(funds, clientId, 24);
        //await formatRentsFundsByRange(responseFundsData, clientId);

        //if (periodReport == 12) {
        if (periodReport == 'mensal') {
            responseFundsData.forEach(fund => {

                const rentMonth = getInMonthRentFundInPortfolio(fund);
                const rentYear = getYearRentFundInPortfolio(fund.rentsFunds, year);
                const rent12m = getPeriodRentFundInPortfolio(fund.rentsFunds, 12);
                const rent24m = getPeriodRentFundInPortfolio(fund.rentsFunds, 24);
                const rentSinceInit = getHistoricRentFundInPortfolio(fund);

                arrayToReport.push({
                    fund_name: fund.fund_name ? formatStringToDisplay(fund.fund_name, 6, '...') : '-',
                    cnpj: fund.cnpj,
                    rent_month: rentMonth ? applyMaskAmount(rentMonth, null, true) + "%" : '-',
                    rent_year: rentYear ? applyMaskAmount(rentYear, null, true) + "%" : '-',
                    rent_12m: rent12m ? applyMaskAmount(rent12m, null, true) + "%" : '-',
                    rent_24m: rent24m ? applyMaskAmount(rent24m, null, true) + "%" : '-',
                    rent_since_init: rentSinceInit ? applyMaskAmount(rentSinceInit, null, true) + "%" : '-',
                })

            });
        } else if (periodReport == 3) {

            const m1 = monthYearStartDate.month;
            const m2 = m1 + 1;
            const m3 = m2 + 1;
            responseFundsData.forEach(fund => {

                const mapMonthRentFund = {};
                fund.rentsFunds.forEach(element => {
                    //console.log("ELEMENT: ", element);
                    mapMonthRentFund[element.month] = element;
                });
                //console.log('mapMonthRentFund: ', mapMonthRentFund);

                const rentM1 = mapMonthRentFund[m1] ? getInMonthRentFundInPortfolio(mapMonthRentFund[m1]) : null;
                const rentM2 = mapMonthRentFund[m2] ? getInMonthRentFundInPortfolio(mapMonthRentFund[m2]) : null;
                const rentM3 = mapMonthRentFund[m3] ? getInMonthRentFundInPortfolio(mapMonthRentFund[m3]) : null;
                const rentTri = getPeriodRentFundInPortfolio(fund.rentsFunds, 3, true);

                arrayToReport.push({
                    fund_name: fund.fund_name ? formatStringToDisplay(fund.fund_name, 6, '...') : '-',
                    cnpj: fund.cnpj,
                    rent_m1: rentM1 ? applyMaskAmount(rentM1, null, true) + "%" : '-',
                    rent_m2: rentM2 ? applyMaskAmount(rentM2, null, true) + "%" : '-',
                    rent_m3: rentM3 ? applyMaskAmount(rentM3, null, true) + "%" : '-',
                    rent_tri: rentTri ? applyMaskAmount(rentTri, null, true) + "%" : '-',
                })

            });
        } else if (periodReport == 6) {

            const m1 = monthYearStartDate.month;
            const m2 = m1 + 1;
            const m3 = m2 + 1;
            const m4 = m3 + 1;
            const m5 = m4 + 1;
            const m6 = m5 + 1;

            responseFundsData.forEach(fund => {

                const mapMonthRentFund = {};
                fund.rentsFunds.forEach(element => {
                    //console.log("ELEMENT: ", element);
                    mapMonthRentFund[element.month] = element;
                });


                const tri1RentsFund = [mapMonthRentFund[m1], mapMonthRentFund[m2], mapMonthRentFund[m3]];
                const tri2RentsFund = [mapMonthRentFund[m4], mapMonthRentFund[m5], mapMonthRentFund[m6]];

                const rentTri1 = getPeriodRentFundInPortfolio(tri1RentsFund, 3, true);
                const rentTri2 = getPeriodRentFundInPortfolio(tri2RentsFund, 3, true);
                const rentSemester = getPeriodRentFundInPortfolio(fund.rentsFunds, 6, true);

                arrayToReport.push({
                    fund_name: fund.fund_name ? formatStringToDisplay(fund.fund_name, 6, '...') : '-',
                    cnpj: fund.cnpj,
                    rent_tri1: rentTri1 ? applyMaskAmount(rentTri1, null, true) + "%" : '-',
                    rent_tri2: rentTri2 ? applyMaskAmount(rentTri2, null, true) + "%" : '-',
                    rent_semester: rentSemester ? applyMaskAmount(rentSemester, null, true) + "%" : '-',
                })

            });
        } else if (periodReport == 'ano') {

            responseFundsData.forEach(fund => {

                const mapMonthRentFund = {};
                fund.rentsFunds.forEach(element => {
                    //console.log("ELEMENT: ", element);
                    mapMonthRentFund[element.month] = element;
                });


                const sem1RentsFund = [
                    mapMonthRentFund[1],
                    mapMonthRentFund[2],
                    mapMonthRentFund[3],
                    mapMonthRentFund[4],
                    mapMonthRentFund[5],
                    mapMonthRentFund[6]
                ];

                const sem2RentsFund = [
                    mapMonthRentFund[7],
                    mapMonthRentFund[8],
                    mapMonthRentFund[9],
                    mapMonthRentFund[10],
                    mapMonthRentFund[11],
                    mapMonthRentFund[12]
                ];

                const rentSem1 = sem1RentsFund.length ? getPeriodRentFundInPortfolio(sem1RentsFund, 6, true) : null;
                const rentSem2 = sem2RentsFund.length ? getPeriodRentFundInPortfolio(sem2RentsFund, 6, true) : null;
                const rentYear = getPeriodRentFundInPortfolio(fund.rentsFunds, 12, true);

                arrayToReport.push({
                    fund_name: fund.fund_name ? formatStringToDisplay(fund.fund_name, 6, '...') : '-',
                    cnpj: fund.cnpj,
                    rent_sem1: rentSem1 ? applyMaskAmount(rentSem1, null, true) + "%" : '-',
                    rent_sem2: rentSem2 ? applyMaskAmount(rentSem2, null, true) + "%" : '-',
                    rent_year: rentYear ? applyMaskAmount(rentYear, null, true) + "%" : '-',
                })

            });
        }



        return {
            success: true,
            dataToReport: arrayToReport,
        }

    } else {
        console.log("RESPONSE ERROR AO GERAR RELATÓRIO DE FUNDOS: ", responseFunds.error)
        return {
            success: false,
        }
    }

};

export async function getDataToRentsByClassReport(client, startDate, endDate, periodReport) {

    const { month, year } = getDayMonthYearByStringDate(endDate);

    const clientId = client.id;
    const isSpecificPeriodReport = periodReport && periodReport != 'mensal';
    const responseSegment = await loadClientRentsBySegment(clientId, month, year, isSpecificPeriodReport ? periodReport : 1);
    console.log("responseSegment: ", responseSegment);

    if (responseSegment.isSuccessful) {
        console.log("responseSegment: ", responseSegment);

        const lastDiaryMonth = await loadClientDiaryByRange(clientId,
            month,
            year, isSpecificPeriodReport // removendo no caso de 12 pois se refere ao relatório mensal
            ? periodReport : 1);

        const totalPortfolioPeriodRent = applyMaskAmount(lastDiaryMonth.arrayRents && lastDiaryMonth.arrayRents.length === 1 ?
            lastDiaryMonth.arrayRents[0].rent
            :
            (lastDiaryMonth.arrayRents && lastDiaryMonth.arrayRents.length > 1
                ?
                lastDiaryMonth.arrayRents[lastDiaryMonth.arrayRents.length - 1].rentAcum
                :
                0
            ))

        //Obtendo rents by class do período
        const responseRentBySegmentInPeriod = await ClientAPI.getAllMoneyRentsSegmentByPeriod(clientId, startDate, endDate);
        console.log("responseRentBySegmentInPeriod: ", responseRentBySegmentInPeriod);
        const mapRentMoneyBySegmentCod = {};
        let totalMoneyRent = 0;
        if (responseRentBySegmentInPeriod.success) {
            responseRentBySegmentInPeriod.body.forEach(el => {
                if (!mapRentMoneyBySegmentCod[el.segment_cod]) {
                    mapRentMoneyBySegmentCod[el.segment_cod] = 0;
                }
                mapRentMoneyBySegmentCod[el.segment_cod] += parseFloat(el.rent_money);
                totalMoneyRent += parseFloat(el.rent_money);
            });
        }

        console.log("mapRentMoneyBySegmentCod: ", mapRentMoneyBySegmentCod);

        const formatted = {};
        Object.entries(responseSegment.mapRentsBySegment).forEach(([key, value]) => {
            formatted[SEGMENT_CODS_AND_LABELS[key]] = value ? applyMaskAmount(value) + "%" : '-';
        });
        function sortObjectByValue(obj) {
            return Object.entries(obj)
                .map(function ([key, value]) {
                    var num = value === "-"
                        ? -Infinity
                        : parseFloat(value.replace("%", "").replace(",", ".").trim());

                    return { key: key, value: value, num: num };
                })
                .sort(function (a, b) {
                    return b.num - a.num;
                })
                .map(function (item) {
                    return { key: item.key, value: item.value };
                });
        }

        const dataToTable = [];
        sortObjectByValue(formatted).filter(el => el.value !== "-").forEach((row, index) => {
            dataToTable.push({
                c1: row.key,
                c2: row.value,
                c3: mapRentMoneyBySegmentCod[getSegmentKeyByValue(row.key)] ? applyMaskAmount(mapRentMoneyBySegmentCod[getSegmentKeyByValue(row.key)], true) : '-', //mapRentMoneyBySegmentCod[getSegmentKeyByValue(row.key)] ? applyMaskAmount(mapRentMoneyBySegmentCod[getSegmentKeyByValue(row.key)], true) : '-',
                c4: 'legColor chartColor' + index, //Ao alterar as cores no unoTheme também deve-se alterar as classes no header lá do servidor de relatórios
            });
        });

        dataToTable.push({
            c1: 'totalLine',
            c2: `${totalPortfolioPeriodRent}%`,
            c3: applyMaskAmount(totalMoneyRent, true),
        });

        function transformToChartData(arr, unoTheme) {
            var filtered = arr.filter(function (item) {
                return item.c1 !== "totalLine";
            });

            return {
                labels: filtered.map(function (item) {
                    return item.c1;
                }),
                datasets: [
                    {
                        data: filtered.map(function (item) {
                            if (!item.c2 || item.c2 === "-") return 0;

                            return parseFloat(
                                item.c2
                                    .replace("%", "")
                                    .replace(",", ".")
                                    .trim()
                            );
                        }),
                        backgroundColor: filtered.map(function (_, index) {
                            return unoTheme.chartColors[index];
                        }),
                        hoverBackgroundColor: filtered.map(function (_, index) {
                            return unoTheme.chartColors[index];
                        })
                    }
                ]
            };
        }

        //Obter rentabilidades por segmentId
        const filteredSegmentsCods = [];
        for (let i = 0; i < dataToTable.length - 1; i++) {
            const item = dataToTable[i];
            filteredSegmentsCods.push(getSegmentKeyByValue(item.c1));

        }

        const segmentsIds = getSegmentIdsByKeys(filteredSegmentsCods);
        console.log("segmentsIds: ", segmentsIds);


        return {
            success: true,
            dataToReport: {
                dataToTable: dataToTable.map(el => ({
                    ...el,
                    c2: el.c2.slice(0, -1),
                })),
                dataToChart: transformToChartData(dataToTable, unoTheme),
            }
        }
    }

    return {
        success: false,
    }

}

/**
 * Retorna os dados a serem utilizados na montagem do relatório de meus fundos
 */
//export async function getDataToMyTitlesReport(clientId, month, year) {
export async function getDataToMyTitlesReport(clientId, startDate, endDate, regimeId) {

    const { month: mStart, year: yStart } = getDayMonthYearByStringDate(startDate);
    const { month, year } = getDayMonthYearByStringDate(endDate);

    //const { allTitles, totals, finalTotalsPublic, finalTotalsPrivate } = await getAnaliticTitles(clientId, startDate, endDate, month, year);
    const { allTitles, totalsPublic, totalsPrivate, totals } = await getAnaliticTitlesByPeriod(
        clientId,
        startDate,
        endDate,
        month,
        year,
        (mStart != month) || (yStart != year), //indica que é uma consulta de período
        regimeId
    );

    if (allTitles) {
        const arrayToReport = [];

        allTitles.forEach(row => {

            const { line1, line2 } = splitIn2Lines(row.title_name, 2);

            //balance_now e quota_amount_now chegam do pg como string ("0.00"), que é truthy:
            //o parseFloat precisa vir antes da guarda, senão 0/0 vira NaN e o PDF imprime "NaN".
            const balanceNow = parseFloat(row.balance_now);
            const quotaAmountNow = parseFloat(row.quota_amount_now);

            arrayToReport.push({
                title_p1: line1,
                title_p2: line2,
                due_date: moment.utc(getDueDateTitle(row)).format('DD/MM/YY'),
                purchase_date: moment.utc(row.purchase_date).format('DD/MM/YY'),
                quantity_purchased: row.quantity_purchased,
                purchase_pu: row.price_title ? applyMaskAmount(row.price_title, null) : '-',
                now_pu: balanceNow && quotaAmountNow ?
                    applyMaskAmount(balanceNow / quotaAmountNow, null) : applyMaskAmount(0, true),
                marking1: row.marking,
                marking2: (row.pre_tax && row.marking != MARKING_MARKET ? applyMaskAmount(row.pre_tax) + "%" : ''),
                purchase_value: applyMaskAmount(row.price_title * row.quantity_purchased, true),
                now_value: applyMaskAmount(row.balance_now, true),
                rent: applyMaskAmount(row.rentMoneyPeriod, true) + " ( " + applyMaskAmount(row.rentPeriod) + "%" + " )",
                sector: row.sector
            });
        });

        console.log("arrayToReport: ", arrayToReport);

        //Média ponderada da marcação (curva) por setor e global, ponderada pelo Valor Atual.
        //O template lê o campo marking1 na coluna "Marcação" (marking é ignorado).
        const formatMarkingAvg = (avg) => (avg != null ? applyMaskAmount(avg) + "%" : "-");
        const publicMarkingAvg = getWeightedMarkingAverage(allTitles.filter(el => el.sector === 'PUBLICO'));
        const privateMarkingAvg = getWeightedMarkingAverage(allTitles.filter(el => el.sector !== 'PUBLICO'));
        const globalMarkingAvg = getWeightedMarkingAverage(allTitles);

        arrayToReport.push({
            title: 'Total Públicos',
            due_date: '',
            purchase_date: '',
            quantity_purchased: '',
            purchase_pu: '',
            now_pu: '',
            marking1: formatMarkingAvg(publicMarkingAvg),
            purchase_value: applyMaskAmount(totalsPublic.purchaseAmount, true),
            now_value: applyMaskAmount(totalsPublic.currentAmount, true),
            rent: applyMaskAmount(totalsPublic.rentMoneyPeriod, true) + " ( " + applyMaskAmount(totalsPublic.rentPeriod) + "% )",
        });

        arrayToReport.push({
            title: 'Total Privados',
            due_date: '',
            purchase_date: '',
            quantity_purchased: '',
            purchase_pu: '',
            now_pu: '',
            marking1: formatMarkingAvg(privateMarkingAvg),
            purchase_value: applyMaskAmount(totalsPrivate.purchaseAmount, true),
            now_value: applyMaskAmount(totalsPrivate.currentAmount, true),
            rent: applyMaskAmount(totalsPrivate.rentMoneyPeriod, true) + " ( " + applyMaskAmount(totalsPrivate.rentPeriod) + "% )",
        });

        arrayToReport.push({
            title: 'Total Global',
            due_date: '',
            purchase_date: '',
            quantity_purchased: '',
            purchase_pu: '',
            now_pu: '',
            marking1: formatMarkingAvg(globalMarkingAvg),
            purchase_value: applyMaskAmount(totals.purchaseAmount, true),
            now_value: applyMaskAmount(totals.currentAmount, true),
            rent: applyMaskAmount(totals.rentMoneyPeriod, true) + " ( " + applyMaskAmount(totals.rentPeriod) + "% )",
        });

        console.log('arrayToReport_titles: ', arrayToReport);

        return {
            success: true,
            dataToReport: arrayToReport,
        }

    } else {
        console.log("RESPONSE ERROR AO GERAR RELATÓRIO DE TITULOS")
        return {
            success: false,
        }
    }

};



export async function getDataToMyFundsReportOLD(clientId, month, year) {

    const responseFunds = await FundAPI.getAllClientFunds(clientId);
    if (responseFunds.success) {

        console.log("FUNDS: ", responseFunds.body.rows);
        let arrayToReport = [];
        console.log("DATA TO REPORT: ", arrayToReport);

        let funds = responseFunds.body.rows;

        await formatBalancesRentsByRange(funds, clientId, 24);

        funds.forEach(fund => {

            arrayToReport.push({
                fund_name: fund.fund_name,
                cnpj: fund.cnpj,
                rent_year: fund.rentAcumYear ? applyMaskAmount(fund.rentAcumYear) + "%" : '-',
                rent_12m: fund.rentAcum12m ? applyMaskAmount(fund.rentAcum12m) + "%" : '-',
                rent_24m: fund.rentAcum24m ? applyMaskAmount(fund.rentAcum24m) + "%" : '-',
            })

        });

        return {
            success: true,
            dataToReport: arrayToReport,
        }

    } else {
        console.log("RESPONSE ERROR AO GERAR RELATÓRIO DE METAS: ", responseFunds.error)
        return {
            success: false,
        }
    }

};

export async function getDataToMyClientReturns(clientId, month, year, accountRegimeId = null) {

    //Mesma origem da aba Diários: cotas da segregação quando há regime filtrado, senão as consolidadas
    let responseReturns = accountRegimeId
        ? await loadClientRentsBySegregation(clientId, month, year, 1)
        : await loadClientDiaryByRange(clientId, month, year, 1);

    if (responseReturns?.isSuccessful) {
        const clientReturns = [];

        let diarys = accountRegimeId
            ? [...(responseReturns.mapDiarysBySegregation[accountRegimeId] ?? [])].reverse()
            : responseReturns.arrayRents[0].diarys.reverse();

        diarys.forEach(diary => {

            clientReturns.push({
                date_quota: moment.utc(diary.date_quota).format('DD/MM/YYYY'),
                previous_pl: applyMaskAmount(diary.pl, true),
                result_app_rescues: applyMaskAmount(diary.result_app_rescues, true),
                additional_quotas: applyMaskAmount(diary.add_quotas),
                rent_day: applyMaskAmountFreeDecimals(diary.rent_day),
                new_pl: applyMaskAmount(diary.new_pl, true),
            })

        });

        return {
            isSuccessful: true,
            clientReturns,
        }

    } else {
        console.error("ERRO AO RESGATAR RETORNOS DO CLIENTE: ", responseReturns?.error)
        return {
            isSuccessful: false,
        }
    }

};

/**
 * Retorna os dados a serem utilizados na montsgem do relatório de enquadramentos
 */
//export async function getDataToArticleReport(clientId, month, year) {
export async function getDataToArticleReport(client, startDate, endDate) {

    const clientId = client.id;

    const { month, year } = getDayMonthYearByStringDate(endDate);

    //Obtendo segmentos de resolução
    //let responseLegislationSegments = await listLegislationSegments();
    const lastDayInMonth = getLastDayInMonthByMonthAndYear(month, year);
    let responseLegislationSegments = await LegislationArticleAPI.listLegislationSegmentsByDate(lastDayInMonth);
    //listLegislationSegmentsByDate
    const segments = responseLegislationSegments.body.rows;

    let desenquadrados = {};

    if (responseLegislationSegments.success) {

        //Como o filtro é feito apenas pelo ano os registros de artigo podem vir duplicados pois
        //podem existir mais de uma politica para cada artigo
        //a diferença está no mês        
        //let responseLegislationArticles = await listLegislationArticles(null, clientId, year, lastDayInMonth);
        let responseLegislationArticles = await LegislationArticleAPI.listLegislationArticlesByDate(null, clientId, year, lastDayInMonth);

        console.log("ARTICLES COM POLITICAS: ", responseLegislationArticles.body.rows);

        let formattedArticles = groupArticlePolicys(responseLegislationArticles.body.rows);

        let responseAssets = await getSimpleNormalizedAssets(clientId,
            month,
            year,
            null)

        if (responseAssets.success) {

            console.log("ASSETS: ", responseAssets.assets);
            const responseGrup = markArticlesInPortfolio(formattedArticles,
                responseAssets.assets, segments, [], client.promanagement_code);

            //Sem os desenquadrados
            let newArticles = [];
            responseGrup.articles.forEach(element => {

                if (element.asset == "Desenquadrado") {
                    desenquadrados[element.legislation_segment_id] = element;
                } else {
                    newArticles.push(element);
                }

            });

            //Realizar formatação dos dados a fim de exibir no relatório em tabela

            //Criar linhas de total abaixo da última linha
            let groupWithTotalLines = {};
            newArticles.forEach(element => {

                if (!groupWithTotalLines[element.legislation_segment_id]) {

                    groupWithTotalLines[element.legislation_segment_id] = [];

                }

                //formatando informações    

                element.asset = element.device_abbreviation && element.device_abbreviation != "" ? element.asset + " - " + element.device_abbreviation : element.asset;

                element.valuePercentInPortfolio = parseFloat(
                    element.totalArticleValue * 100
                    / responseGrup.totalPortfolioValue
                ).toFixed(2)

                element.totalArticleValue = applyMaskAmount(element.totalArticleValue, true)

                element.lower_target = element.lower_target ? applyMaskAmount(element.lower_target) + "%" : "-";
                element.target = element.target ? applyMaskAmount(element.target) + "%" : "-";
                element.top_target = element.top_target ? applyMaskAmount(element.top_target) + "%" : "-";

                groupWithTotalLines[element.legislation_segment_id].push(element);

            });


            Object.entries(responseGrup.mapSegmentArticlesTotal).map(([key, row]) => {

                //Caso exista desenquadrado ele entra na tabela, caso contrário não entra
                if (desenquadrados[key] && desenquadrados[key].isInPortfolio) {
                    groupWithTotalLines[key].push({
                        ...desenquadrados[key],
                        valuePercentInPortfolio: parseFloat(
                            desenquadrados[key].totalArticleValue * 100
                            / responseGrup.totalPortfolioValue
                        ).toFixed(2),
                        totalArticleValue: applyMaskAmount(desenquadrados[key].totalArticleValue, true),
                    });
                }

                groupWithTotalLines[key].push({
                    asset: 'Total',
                    totalArticleValue: applyMaskAmount(row, true),
                    valuePercentInPortfolio: applyMaskAmount(
                        responseGrup.mapSegmentArticlesTotal[key] * 100
                        / responseGrup.totalPortfolioValue)
                });

                let idTest = segments[segments.length - 1].id;
                if (segments.length > 3) {
                    idTest = segments[segments.length - 2].id //Em caso de V2 que possui segmento de imóveis
                }

                if (key == idTest) {

                    groupWithTotalLines[key].push({
                        asset: 'Total Geral',
                        totalArticleValue: applyMaskAmount(responseGrup.totalPortfolioValue, true),
                        valuePercentInPortfolio: applyMaskAmount(100),
                    });

                }

            })

            console.log("FINAL DATA: ", groupWithTotalLines);
            return {
                success: true,
                dataToArticlesReport: groupWithTotalLines,
            }

        }


    } else {
        return {
            success: false,
        }
    }

};

function getInfosQuotasByDay(quotas, date) {

    if (quotas) {
        for (let i = 0; i < quotas.length; i++) {

            const element = quotas[i];
            if (element.data_referencia == moment.utc(date).format('YYYY-MM-DD')) {

                return {
                    pl_in_trasaction_day: applyMaskAmount(element.patrimonio_liquido, true),
                    quota_amount_in_trasaction_day: applyMaskAmountFreeDecimals(element.valor_cota),
                    quota_qtd_in_trasaction_day: applyMaskAmountFreeDecimals(element.patrimonio_liquido / element.valor_cota),
                }

            }

        }
    }


    return {
        pl_in_trasaction_day: 0,
        quota_amount_in_trasaction_day: 0,
        quota_qtd_in_trasaction_day: 0,
    };

}

function normalizeToApr(transactions, hideCpf) {

    console.log("JSON x: ", JSON.parse(JSON.stringify(transactions)));

    transactions.forEach(apr => {

        apr.client_apr_data = {
            certification_validity: moment.utc(apr.certification_validity).format("DD/MM/YYYY"),
            certification_validity2: apr.certification_validity_2 ? moment.utc(apr.certification_validity_2).format("DD/MM/YYYY") : "-",
            certification_validity3: apr.certification_validity_3 ? moment.utc(apr.certification_validity_3).format("DD/MM/YYYY") : "-",
            name_preponent: apr.name_preponent,
            cpf_preponent: hideCpf ? applyMaskHideCpf(apr.cpf_preponent) : apr.cpf_preponent,
            name_responsable: apr.name_responsable,
            cpf_responsable: hideCpf ? applyMaskHideCpf(apr.cpf_responsable) : apr.cpf_responsable,
            name_manager: apr.name_manager,
            cpf_manager: hideCpf ? applyMaskHideCpf(apr.cpf_manager) : apr.cpf_manager,
            certification_name: apr.certification_name,
            certification_name2: apr.certification_name_2,
            certification_name3: apr.certification_name_3,
        }

        if (apr.apr_description_id != null) { //No caso de ser uma apr pré definida a descrição vem no campo apr_description2 a partir da consulta

            apr.apr_description = apr.apr_description2

        }

        apr.operation = getOperationLabel(apr);

        apr.account = applyMaskAccount(apr.account);

        let jsonQuotas = apr.json_quotas ? JSON.parse(apr.json_quotas) : null;
        let jsonInfos = apr.json_fund_infos ? JSON.parse(apr.json_fund_infos) : null;

        const objQuotas = jsonQuotas ? getInfosQuotasByDay(jsonQuotas, apr.transaction_date) : null;

        apr.asset = {
            name: apr.fund_name,
            cnpj: apr.fund_cnpj,
            administrator: jsonInfos ? jsonInfos.dados_cadastrais.administrator_name : "-",
            cnpj_administrator: jsonInfos ? jsonInfos.dados_cadastrais.administrator_cnpj : "-",
            manager: jsonInfos ? jsonInfos.dados_cadastrais.manager_name : "-",
            cnpj_manager: jsonInfos ? jsonInfos.dados_cadastrais.manager_cnpj : "-",
            disponibility: jsonInfos ? jsonInfos.dados_cadastrais.disponibilization : "-",
            date_init: jsonInfos ? jsonInfos.dados_cadastrais.fund_init : "-",
            administration_tax: jsonInfos ? applyMaskAmount(jsonInfos.dados_cadastrais.administration_tax) + "%" : "-",
            performance_tax: jsonInfos ? (jsonInfos.dados_cadastrais.performance_tax ? (jsonInfos.dados_cadastrais.performance_tax == "N" ? "Não possui" : jsonInfos.dados_cadastrais.performance_tax) : "Não possui") : "-",
            //benchmark: jsonInfos ? jsonInfos.dados_cadastrais.benchmark : "-",
            distributor_name: apr.distributor_exception_name ? apr.distributor_exception_name : apr.distributor_name,
            distributor_cnpj: apr.distributor_exception_cnpj ? apr.distributor_exception_cnpj : apr.distributor_cnpj,
            benchmark: apr.benchmark ? apr.benchmark : "-",
            pl_in_trasaction_day: objQuotas ? objQuotas.pl_in_trasaction_day : '-',
            quota_amount_in_trasaction_day: objQuotas ? objQuotas.quota_amount_in_trasaction_day : '-',
            quota_qtd_in_trasaction_day: objQuotas ? objQuotas.quota_qtd_in_trasaction_day : '-',
        }

        apr.transaction_validated = {
            number_apr: apr.number_apr,
            date: moment.utc(apr.transaction_date).format('DD/MM/YYYY'),
            value: applyMaskAmount(apr.amount, false),
            //operation:  apr.operation,
            operation: getOperationLabel(apr),
            resolution: apr.article,
            description: apr.apr_description
        }

        apr.amount = applyMaskAmount(apr.amount, false)

        apr.asset_validated = {
            fund_name: apr.asset.name,
            cnpj: apr.asset.cnpj,
            administrator: apr.asset.administrator,
            cnpj_administrator: apr.asset.cnpj_administrator,
            manager: apr.asset.manager,
            cnpj_manager: apr.asset.cnpj_manager,
            disponibility: apr.asset.disponibility,
            date_init: apr.asset.date_init,
            administration_tax: apr.asset.administration_tax,
            benchmark: apr.asset.benchmark,
            performance_tax: apr.asset.performance_tax,
            //prev_return:apr.asset.prev_return,
            pl_in_trasaction_day: apr.asset.pl_in_trasaction_day,
            quota_amount_in_trasaction_day: apr.asset.quota_amount_in_trasaction_day,
            quota_qtd_in_trasaction_day: apr.asset.quota_qtd_in_trasaction_day,
        }
        apr.preponent_validated = {
            name: apr.client_apr_data.name_preponent,
            cpf: apr.client_apr_data.cpf_preponent,
        }
        apr.manager_validated = {
            name: apr.client_apr_data.name_manager,
            cpf: apr.client_apr_data.cpf_manager,
            certification: apr.client_apr_data.certification_name != "null - null" ? apr.client_apr_data.certification_name : "-",
            validity: apr.client_apr_data.certification_name != "null - null" ? apr.client_apr_data.certification_validity : "-",
        }
        apr.operation_validated = {
            name: apr.client_apr_data.name_responsable,
            cpf: apr.client_apr_data.cpf_responsable
        }

    });

}

function normalizeToSingleApr(transactions, hideCpf) {

    transactions.forEach(apr => {

        apr.client_apr_data = {
            certification_validity: moment.utc(apr.certification_validity).format("DD/MM/YYYY"),
            name_preponent: apr.name_preponent,
            cpf_preponent: hideCpf ? applyMaskHideCpf(apr.cpf_preponent) : apr.cpf_preponent,
            name_responsable: apr.name_responsable,
            cpf_responsable: hideCpf ? applyMaskHideCpf(apr.cpf_responsable) : apr.cpf_responsable,
            name_manager: apr.name_manager,
            cpf_manager: hideCpf ? applyMaskHideCpf(apr.cpf_manager) : apr.cpf_manager,
            certification_name: apr.certification_entity + " - " + apr.certification_name,
        }

        if (apr.apr_description_id != null) { //No caso de ser uma apr pré definida a descrição vem no campo apr_description2 a partir da consulta

            apr.apr_description = apr.apr_description2

        }

        let jsonQuotas = JSON.parse(apr.json_quotas);
        let jsonInfos = JSON.parse(apr.json_fund_infos);

        let objQuotas = getInfosQuotasByDay(jsonQuotas, apr.transaction_date);

        apr.asset = {
            name: apr.fund_name,
            cnpj: apr.fund_cnpj,
            administrator: jsonInfos ? jsonInfos.dados_cadastrais.administrator_name : "-",
            cnpj_administrator: jsonInfos ? jsonInfos.dados_cadastrais.administrator_cnpj : "-",
            manager: jsonInfos ? jsonInfos.dados_cadastrais.manager_name : "-",
            cnpj_manager: jsonInfos ? jsonInfos.dados_cadastrais.manager_cnpj : "-",
            disponibility: jsonInfos ? jsonInfos.dados_cadastrais.disponibilization : "-",
            date_init: jsonInfos ? jsonInfos.dados_cadastrais.fund_init : "-",
            administration_tax: jsonInfos ? applyMaskAmount(jsonInfos.dados_cadastrais.administration_tax) + "%" : "-",
            performance_tax: jsonInfos ? (jsonInfos.dados_cadastrais.performance_tax ? (jsonInfos.dados_cadastrais.performance_tax == "N" ? "Não possui" : jsonInfos.dados_cadastrais.performance_tax) : "Não possui") : "-",
            //benchmark: jsonInfos ? jsonInfos.dados_cadastrais.benchmark : "-",
            benchmark: apr.benchmark ? apr.benchmark : "-",
            pl_in_trasaction_day: objQuotas.pl_in_trasaction_day,
            quota_amount_in_trasaction_day: objQuotas.quota_amount_in_trasaction_day,
            quota_qtd_in_trasaction_day: objQuotas.quota_qtd_in_trasaction_day,
        }

        apr.transaction_validated = {
            number_apr: apr.number_apr,
            date: moment.utc(apr.transaction_date).format('DD/MM/YYYY'),
            value: applyMaskAmount(apr.amount, false),
            operation: apr.operation,
            resolution: apr.article,
            description: apr.apr_description
        }

        apr.amount = applyMaskAmount(apr.amount, false)

        apr.asset_validated = {
            fund_name: apr.asset.name,
            cnpj: apr.asset.cnpj,
            administrator: apr.asset.administrator,
            cnpj_administrator: apr.asset.cnpj_administrator,
            manager: apr.asset.manager,
            cnpj_manager: apr.asset.cnpj_manager,
            disponibility: apr.asset.disponibility,
            date_init: apr.asset.date_init,
            administration_tax: apr.asset.administration_tax,
            benchmark: apr.asset.benchmark,
            performance_tax: apr.asset.performance_tax,
            //prev_return:apr.asset.prev_return,
            pl_in_trasaction_day: apr.asset.pl_in_trasaction_day,
            quota_amount_in_trasaction_day: apr.asset.quota_amount_in_trasaction_day,
            quota_qtd_in_trasaction_day: apr.asset.quota_qtd_in_trasaction_day,
        }
        apr.preponent_validated = {
            name: apr.client_apr_data.name_preponent,
            cpf: apr.client_apr_data.cpf_preponent,
        }
        apr.manager_validated = {
            name: apr.client_apr_data.name_manager,
            cpf: apr.client_apr_data.cpf_manager,
            certification: apr.client_apr_data.certification_name != "null - null" ? apr.client_apr_data.certification_name : "-",
            validity: apr.client_apr_data.certification_name != "null - null" ? apr.client_apr_data.certification_validity : "-",
        }
        apr.operation_validated = {
            name: apr.client_apr_data.name_responsable,
            cpf: apr.client_apr_data.cpf_responsable
        }

    });

}

/**
 * Retorna os dados a serem utilizados na montagem do relatório de lote de APRS
 */
export async function getDataToAprReport(transactionId, month, year, hideCpf) {

    let response = await TransactionAPI.getAprWithClientDataByIdTransaction(transactionId, month, year);

    console.log("RESPONSE getAprWithClientDataByIdTransaction: ", response);

    if (response.success) {

        console.log("REPORTS: ", response.body.rows);

        let transactions = response.body.rows;
        if (transactions.length == 1) {

            //Formatando informações
            normalizeToApr(transactions, hideCpf);

            return {
                success: true,
                dataToReport: transactions[0],
            };

        } else {
            return {
                success: false,
            };
        }




    }

};
/**
 * Retorna os dados a serem utilizados na montagem do relatório de single APR
 */
export async function getDataToSingleAprReport(transactionId, month, year, hideCpf) {

    let response = await TransactionAPI.getSingleAprWithClientDataByIdTransaction(transactionId, month, year);

    if (response.success) {

        console.log("REPORTS: ", response.body.rows);

        let transactions = response.body.rows;
        if (transactions.length == 1) {

            //Formatando informações
            normalizeToSingleApr(transactions, hideCpf);

            return {
                success: true,
                dataToReport: transactions[0],
            };

        } else {
            return {
                success: false,
            };
        }




    }

};

/**
 * Retorna os dados a serem utilizados na montagem do relatório de lote de APRS
 */
export async function getDataToBatchAprsReport(clientId, month, year, regimeId, order, selectedYearSingleAPRS, hideCpf) {

    let firstDay = new Date(year, parseInt(month) - 1, 1);
    var lastDay = new Date(year, parseInt(month), 0);

    //Verificando se existem contaas
    if (firstDay != null
        && lastDay != undefined) {

        let response = null;
        if (!selectedYearSingleAPRS) { //requisição convencional de aprs por período mensal

            response = await TransactionAPI.getAprsWithClientDataByDateRange(clientId,
                moment.utc(firstDay).format("DD/MM/YYYY"),
                moment.utc(lastDay).format("DD/MM/YYYY"), regimeId, order);

        } else {

            response = await TransactionAPI.getSinglesAprsWithClientDataByYear(clientId,
                selectedYearSingleAPRS,
                regimeId,
                order);

        }

        if (response.success) {

            console.log("REPORTS: ", response.body.rows);

            let transactions = response.body.rows;

            //Formatando informações
            normalizeToApr(transactions, hideCpf);

            return {
                success: true,
                dataToReport: transactions,
            };

        } else {

            return {
                success: false,
            }
        }
    }


};

export function getSimpleRentMoneyPercentTitle(obj) {
    return obj.rentPercentInMonth
}

export function getSimpleRentMoneyTitle(obj) {
    // Empréstimo consignado: o retorno do mês não segue a fórmula de saldo
    // (balance_now já vem com o retorno descontado). O valor correto é o
    // registrado em registred_rent_now (= rentMoneyInMonth).
    if (isConsigTitle(obj)) {
        return parseFloat(obj.rentMoneyInMonth ?? obj.registred_rent_now ?? 0);
    }

    const totalApplications =
        obj.totalApplicationsAmount ?? obj.totalApplications ?? 0;

    const totalRescues =
        obj.totalRescuesAmount ?? obj.totalRescues ?? 0;

    const totalAmortization =
        obj.totalAmortizationAmount ?? obj.totalAmortization ?? 0;

    const balanceNow = obj.balance_now ?? 0;
    const balanceBefore = obj.balance_before ?? 0;

    return balanceNow - totalApplications + (totalRescues + totalAmortization) - balanceBefore;
}

export function getSimpleRentMoneyTitle2(balanceNow, applications, rescues, amortizations, balanceBefore) {
    //console.log(`Calc: ${balanceNow} - ${applications} + (${rescues} + ${amortizations}) - ${balanceBefore}`);
    return balanceNow - applications
        + (rescues + amortizations) - balanceBefore
}

export function getSimpleRentTitle(obj) {
    return (((obj.balance_now + (obj.totalRescuesAmount + obj.totalAmortizationAmount))
        / (obj.balance_before + obj.totalApplicationsAmount)) - 1) * 100
}

export function getSimpleRentTitle2(balanceNow, applications, rescues, amortizations, balanceBefore) {
    return (((balanceNow + (rescues + amortizations))
        / (balanceBefore + applications)) - 1) * 100
}

export function groupTitleSumTransactions(sumTitlesTransactions, year, groupBy = 'title_id') {

    const sumTrasactionsTitlesMap = {};
    sumTitlesTransactions.forEach(element => {

        if (!sumTrasactionsTitlesMap[element[groupBy]]) {
            sumTrasactionsTitlesMap[element[groupBy]] = {};
        }

        const period = element.month + '/' + year;
        if (!sumTrasactionsTitlesMap[element[groupBy]][period]) {
            sumTrasactionsTitlesMap[element[groupBy]][period] = {
                1: 0, //aplicações
                2: 0, //resgates
                3: 0, //amortizações
            };
        }

        sumTrasactionsTitlesMap[element[groupBy]][period][element.operation_id] += element.amount;

    });

    return sumTrasactionsTitlesMap;
}

export async function rentsByPeriod(clientId, startDate, endDate, search, segmentId) {

    console.log('rentsByPeriod ' + startDate + ' a ' + endDate);

    const { month: monthStartdate, year: yearStartDate } = getDayMonthYearByStringDate(startDate);
    const { month, year } = getDayMonthYearByStringDate(endDate);

    //Obter infos das cotas médias dos fundos referentes ao mês anterior ao período

    const responseLastAverageQuotas = await FundAPI.getClientFundsRentsByPeriod(clientId,
        startDate,
        endDate, search, segmentId)




    if (responseLastAverageQuotas.success) {

        console.log("responseLastAverageQuotas: ", responseLastAverageQuotas);

        const startDateBefore = getMonthAgo(monthStartdate, yearStartDate, 2);

        const { month: monthBefore, year: yearBefore } = getDayMonthYearByPtDate(startDateBefore);
        const periodBefore = monthBefore + '/' + yearBefore;

        const responseBalances = await ClientAPI.getBalancesAndSumTransactionsPortfolioInMonthByPeriod(clientId, startDateBefore, endDate, search, segmentId);
        const responseSumTransactions = await TransactionAPI.sumTransactionsInMonthByPeriod(clientId, startDate, endDate, search, segmentId);

        console.log("responseSumTransactions xxx: ", responseSumTransactions);

        //formatando resposta de cotas médias dos fundos
        const mapAveragePeriodQuotas = {};
        responseLastAverageQuotas.body.rows.forEach(element => {
            if (!mapAveragePeriodQuotas[element.fund_id]) {
                mapAveragePeriodQuotas[element.fund_id] = {
                    averageQuotasByMonth: [],
                    is_poupanca: element.is_poupanca
                }
            }
            mapAveragePeriodQuotas[element.fund_id].averageQuotasByMonth.push({
                period: element.period,
                average_quota_now: JSON.parse(element.json_average_quotas),
                quotas_anbima: getClientJsonQuotas(JSON.parse(element.quotas_anbima), clientId),
            });
        });

        //Formatando averageQuotaByMonth
        Object.entries(mapAveragePeriodQuotas).map(([fundId, row]) => {
            if (row) {
                row.averageQuotasByMonthMap = {};
                row.averageQuotasByMonth.forEach((element, index) => {
                    row.averageQuotasByMonthMap[element.period] = element;
                });
            }
        })

        //formatando sumTransactions
        const sumTrasactionsFundsMap = {};

        // console.log("responseSumTransactions: ", responseSumTransactions);
        responseSumTransactions.body.funds.forEach(element => {
            if (!sumTrasactionsFundsMap[element.fund_id]) {
                sumTrasactionsFundsMap[element.fund_id] = {};
            }

            const period = element.month + '/' + element.year;
            if (!sumTrasactionsFundsMap[element.fund_id][period]) {
                sumTrasactionsFundsMap[element.fund_id][period] = {
                    1: 0, //aplicações
                    2: 0, //resgates
                    3: 0, //amortizações

                };
            }

            sumTrasactionsFundsMap[element.fund_id][period][element.operation_id] += element.amount;

        });

        const sumTrasactionsTitlesMap = groupTitleSumTransactions(responseSumTransactions.body.titles, year);

        //formatando saldos
        const fundBalancesMap = {};
        responseBalances.body.fundsBalances.forEach(element => {
            if (!fundBalancesMap[element.fund_id]) {
                fundBalancesMap[element.fund_id] = {};
            }

            fundBalancesMap[element.fund_id][element.period] = {
                balance_now: element.balance,
                period_before: getPeriodBefore(element.period),
            };

        });

        Object.entries(fundBalancesMap).map(([key, periods]) => {

            Object.entries(periods).map(([periodKey, period]) => {

                //console.log('periodBefore: ', periodBefore);
                if (periodKey != periodBefore && periods[period.period_before]) {
                    period.balance_before = periods[period.period_before].balance_now;
                } else {
                    period.balance_before = 0;
                }

            })

            delete periods[periodBefore];
        })

        //Organizando em perídos anuais
        const anualFundsBalancesMap = {};
        Object.entries(_.cloneDeep(fundBalancesMap)).map(([fundId, periods]) => {

            Object.entries(periods).map(([periodKey, period]) => {

                const yearPeriod = getYearPeriod(periodKey);
                if (!anualFundsBalancesMap[yearPeriod]) {
                    anualFundsBalancesMap[yearPeriod] = {};
                }

                if (!anualFundsBalancesMap[yearPeriod][fundId]) {
                    anualFundsBalancesMap[yearPeriod][fundId] = {}
                }

                anualFundsBalancesMap[yearPeriod][fundId][periodKey] = period;

            })

        })


        //Voltando para modelo integrado de período indexando os períodos de cada fundo
        const integralPeriodFundsBalancesMap = {};
        Object.entries(anualFundsBalancesMap).map(([year, fundsByYear]) => {

            Object.entries(fundsByYear).map(([fundId, periodsFundByYear]) => {

                if (!integralPeriodFundsBalancesMap[fundId]) {
                    integralPeriodFundsBalancesMap[fundId] = {
                        indexerPeriodKey: 0
                    };
                }

                Object.entries(periodsFundByYear).map(([periodString, periodRent]) => {

                    const nextIndexerPeriodKey = ++integralPeriodFundsBalancesMap[fundId].indexerPeriodKey;
                    const yearPeriod = getYearPeriod(periodString);
                    integralPeriodFundsBalancesMap[fundId][nextIndexerPeriodKey + "__" + periodString] = {
                        ...periodRent,
                        period: periodString,
                        yearPeriod: yearPeriod,
                    };

                })

            })


        })

        //Mapa com os ids de títulos agrupados por setor
        const titlesSectorsMap = {
            'PUBLICO': { balance_now: 0, balance_before: 0, totalApplicationsAmount: 0, totalRescuesAmount: 0, totalAmortizationAmount: 0, titlesIds: [] },
            'PRIVADO': { balance_now: 0, balance_before: 0, totalApplicationsAmount: 0, totalRescuesAmount: 0, totalAmortizationAmount: 0, titlesIds: [] },
            [GENERIC_ASSET_TITLES_TYPE]: { balance_now: 0, balance_before: 0, totalApplicationsAmount: 0, totalRescuesAmount: 0, totalAmortizationAmount: 0, titlesIds: [] },
        };

        const titleBalancesMap = {};
        responseBalances.body.titlesBalances.forEach(element => {
            if (!titleBalancesMap[element.title_id]) {
                titleBalancesMap[element.title_id] = {
                };
            }

            //CRIANDO MAPA DE IDS REFERENTES AOS SETORES
            if (element.description == GENERIC_ASSET_TITLES_TYPE) {
                if (!titlesSectorsMap[GENERIC_ASSET_TITLES_TYPE].titlesIds.includes(element.title_id)) {
                    titlesSectorsMap[GENERIC_ASSET_TITLES_TYPE].titlesIds.push(element.title_id);
                }
            } else {
                if (!titlesSectorsMap[element.sector].titlesIds.includes(element.title_id)) {
                    titlesSectorsMap[element.sector].titlesIds.push(element.title_id);
                }
            }

            titleBalancesMap[element.title_id][element.period] = {
                balance_now: element.balance,
                period_before: getPeriodBefore(element.period),
            };

        });
        Object.entries(titleBalancesMap).map(([key, periods]) => {

            Object.entries(periods).map(([periodKey, period]) => {

                if (periodKey != periodBefore) {
                    period.balance_before = periods[period.period_before] ? periods[period.period_before].balance_now : 0;
                }

            })

            delete periods[periodBefore];
        })

        let rentFundsMoneyAcumPortoflioPeriodMap = {
            totalPeriods: 0
        };
        let rentTitlesMoneyAcumPortoflioPeriodMap = {
            totalPeriods: 0
        };

        const fundsBalancesByPeriod = { rentMoneyAcum: 0 };

        Object.entries(fundBalancesMap).map(([fundId, periodsFund]) => {

            if (!periodsFund.rentMoneyAcum) {
                periodsFund.rentMoneyAcum = 0;
            }

            Object.entries(periodsFund).map(([period, periodRent]) => {

                if (period != 'rentMoneyAcum' && !fundsBalancesByPeriod[period]) {
                    fundsBalancesByPeriod[period] = 0;
                }

                if (period != 'rentMoneyAcum') {
                    periodRent.totalApplicationsAmount = 0;
                    periodRent.totalRescuesAmount = 0;
                    periodRent.totalAmortizationAmount = 0;

                    if (sumTrasactionsFundsMap[fundId] && sumTrasactionsFundsMap[fundId][period]) {
                        //Adicionando aplicações ao periodo 
                        periodRent.totalApplicationsAmount = sumTrasactionsFundsMap[fundId][period][1];
                        periodRent.totalRescuesAmount = sumTrasactionsFundsMap[fundId][period][2];
                        periodRent.totalAmortizationAmount = sumTrasactionsFundsMap[fundId][period][3];
                    }

                    periodRent.rentMoney = getMonthFundRentInMoney(periodRent);
                    fundsBalancesByPeriod[period] += periodRent.rentMoney;
                    fundsBalancesByPeriod.rentMoneyAcum += periodRent.rentMoney;

                    periodsFund.rentMoneyAcum += periodRent.rentMoney ? periodRent.rentMoney : 0;

                    if (!rentFundsMoneyAcumPortoflioPeriodMap[period]) {
                        rentFundsMoneyAcumPortoflioPeriodMap[period] = 0;
                    }

                    rentFundsMoneyAcumPortoflioPeriodMap[period] += periodRent.rentMoney ? periodRent.rentMoney : 0;
                    rentFundsMoneyAcumPortoflioPeriodMap.totalPeriods += periodRent.rentMoney ? periodRent.rentMoney : 0;
                }


            })

        })


        //Filtrando os periodos de fundos com balance_now zerados, pois serão necessários obter as movimentações desses meses
        const fullRescuedFundsPeriods = {};
        console.log("integralPeriodFundsBalancesMap: ", JSON.parse(JSON.stringify(integralPeriodFundsBalancesMap)));
        Object.entries(integralPeriodFundsBalancesMap).map(([fundId, periodsFund]) => {
            Object.entries(periodsFund).map(([period, periodRent]) => {
                //console.log("periodRent: ", periodRent);
                if (period.includes("__") && periodRent.balance_now <= 0) {

                    const cleanPeriod = period.split("__")[1];
                    if (sumTrasactionsFundsMap[fundId]?.[cleanPeriod]?.[2] > 0) {
                        if (!fullRescuedFundsPeriods[fundId]) fullRescuedFundsPeriods[fundId] = [];
                        fullRescuedFundsPeriods[fundId].push(cleanPeriod);
                    }
                }
            })
        });

        const responseFullRescuedPeriodsTransactions = await TransactionAPI.getMapTransactionsByFundIdsAndPeriods(clientId, fullRescuedFundsPeriods);
        let mapFundsIdsTransactions = {};
        if (responseFullRescuedPeriodsTransactions.success) {

            const { data: theMap } = responseFullRescuedPeriodsTransactions
            mapFundsIdsTransactions = theMap;

        }

        const fundsBalancesByIntegralPeriod = { rentMoneyAcum: 0 };
        Object.entries(integralPeriodFundsBalancesMap).map(([fundId, periodsFund]) => {

            if (!periodsFund.rentMoneyAcum) {
                periodsFund.rentMoneyAcum = 0;
            }

            Object.entries(periodsFund).map(([period, periodRent]) => {

                if (period != 'rentMoneyAcum' && !fundsBalancesByIntegralPeriod[period]) {
                    fundsBalancesByIntegralPeriod[period] = 0;
                }

                if (period != 'rentMoneyAcum' && period != 'indexerPeriodKey') {

                    periodRent.totalApplicationsAmount = 0;
                    periodRent.totalRescuesAmount = 0;
                    periodRent.totalAmortizationAmount = 0;

                    if (sumTrasactionsFundsMap[fundId] && sumTrasactionsFundsMap[fundId][periodRent.period]) {
                        //Adicionando aplicações ao periodo 
                        periodRent.totalApplicationsAmount = sumTrasactionsFundsMap[fundId][periodRent.period][1];
                        periodRent.totalRescuesAmount = sumTrasactionsFundsMap[fundId][periodRent.period][2];
                        periodRent.totalAmortizationAmount = sumTrasactionsFundsMap[fundId][periodRent.period][3];
                    }

                    periodRent.rentMoney = getMonthFundRentInMoney(periodRent);
                    fundsBalancesByIntegralPeriod[period] += periodRent.rentMoney;
                    fundsBalancesByIntegralPeriod.rentMoneyAcum += periodRent.rentMoney;

                    periodsFund.rentMoneyAcum += periodRent.rentMoney ? periodRent.rentMoney : 0;

                    if (!rentFundsMoneyAcumPortoflioPeriodMap[period]) {
                        rentFundsMoneyAcumPortoflioPeriodMap[period] = 0;
                    }

                    rentFundsMoneyAcumPortoflioPeriodMap[period] += periodRent.rentMoney ? periodRent.rentMoney : 0;
                    rentFundsMoneyAcumPortoflioPeriodMap.totalPeriods += periodRent.rentMoney ? periodRent.rentMoney : 0;

                    //Atualizando averaQuotas
                    // if (fundId == 454) {
                    //     console.log("PASSANDO AQUI YYY: ", JSON.parse(JSON.stringify(mapAveragePeriodQuotas[fundId])));
                    //     console.log("sumTrasactionsFundsMap: ", sumTrasactionsFundsMap);
                    // }

                    if (mapAveragePeriodQuotas[fundId] && mapAveragePeriodQuotas[fundId].averageQuotasByMonthMap) {

                        const averageQuotasObj = mapAveragePeriodQuotas[fundId].averageQuotasByMonthMap[periodRent.period];
                        if (averageQuotasObj) {

                            periodRent.average_quota_now = averageQuotasObj.average_quota_now;
                            periodRent.quotas_anbima = averageQuotasObj.quotas_anbima;
                            periodRent.is_poupanca = averageQuotasObj.is_poupanca;

                            // if (periodRent.period == '8/2023' && fundId == 454) {
                            //     console.log("periodRent CCC: ", JSON.parse(JSON.stringify(periodRent)));
                            //     console.log("sumTrasactionsFundsMap[fundId]: ", sumTrasactionsFundsMap[fundId]);
                            //     console.log("sumTrasactionsFundsMap[fundId][periodRent.period]: ", sumTrasactionsFundsMap[fundId][periodRent.period]);
                            //     console.log("sumTrasactionsFundsMap[fundId][periodRent.period][3]: ", sumTrasactionsFundsMap[fundId][periodRent.period][3]);
                            // }

                            if (sumTrasactionsFundsMap[fundId]
                                && sumTrasactionsFundsMap[fundId][periodRent.period]
                                && sumTrasactionsFundsMap[fundId][periodRent.period][3]) {

                                periodRent.totalAmortizationAmount = sumTrasactionsFundsMap[fundId][periodRent.period][3]
                                const amortizationAverageQuota = periodRent.average_quota_now[periodRent.average_quota_now.length - 1];
                                if (amortizationAverageQuota?.qtdQuotasOnAmortization)
                                    periodRent.qtdQuotasOnAmortization = amortizationAverageQuota.qtdQuotasOnAmortization;
                            }

                            if (periodRent.is_poupanca) {
                                periodRent.rent = (((periodRent.balance_now + periodRent.totalRescuesAmount) / (periodRent.balance_before + periodRent.totalApplicationsAmount)) - 1) * 100
                            } else {

                                if (mapFundsIdsTransactions[fundId]?.[periodRent.period]) {
                                    periodRent.transactions = mapFundsIdsTransactions[fundId][periodRent.period];
                                }
                                periodRent.rent = getInMonthRentFundInPortfolio(periodRent);
                            }

                            periodsFund.rentMonth = periodRent.rent;
                            periodsFund.currentPeriod = periodRent.period;

                        }
                    }

                    periodsFund.rentMonth = periodRent.rent ? periodRent.rent : 0;
                    periodsFund.currentPeriod = periodRent.period;

                }


            })

        })

        // console.log('fundsBalancesByPeriod: ', fundsBalancesByPeriod);
        console.log('fundsBalancesByIntegralPeriod: ', fundsBalancesByIntegralPeriod);
        // console.log('anualFundsBalancesMap xx: ', anualFundsBalancesMap);
        console.log('integralPeriodFundsBalancesMap: ', integralPeriodFundsBalancesMap);

        //console.log("MAP XXX: ", JSON.stringify(rentMonthByFundMap)

        Object.entries(titleBalancesMap).map(([titleId, periodsTitle]) => {

            if (!periodsTitle.rentMoneyAcum) {
                periodsTitle.rentMoneyAcum = 0;
            }

            Object.entries(periodsTitle).map(([period, periodRent]) => {

                if (period != 'rentMoneyAcum') {
                    periodRent.totalApplicationsAmount = 0;
                    periodRent.totalRescuesAmount = 0;
                    periodRent.totalAmortizationAmount = 0;

                    if (sumTrasactionsTitlesMap[titleId] && sumTrasactionsTitlesMap[titleId][period]) {
                        //Adicionando aplicações ao periodo 
                        periodRent.totalApplicationsAmount = sumTrasactionsTitlesMap[titleId][period][1];
                        periodRent.totalRescuesAmount = sumTrasactionsTitlesMap[titleId][period][2];
                        periodRent.totalAmortizationAmount = sumTrasactionsTitlesMap[titleId][period][3];
                    }

                    periodRent.rentMoney = getSimpleRentMoneyTitle(periodRent);
                    periodsTitle.rentMoneyAcum += periodRent.rentMoney ? periodRent.rentMoney : 0;

                    periodRent.rent = getSimpleRentTitle(periodRent);

                    if (!rentTitlesMoneyAcumPortoflioPeriodMap[period]) {
                        rentTitlesMoneyAcumPortoflioPeriodMap[period] = 0;
                    }

                    rentTitlesMoneyAcumPortoflioPeriodMap[period] += periodRent.rentMoney ? periodRent.rentMoney : 0;
                    rentTitlesMoneyAcumPortoflioPeriodMap.totalPeriods += periodRent.rentMoney ? periodRent.rentMoney : 0;

                    if (titlesSectorsMap['PUBLICO'].titlesIds.includes(+titleId)) {
                        titlesSectorsMap['PUBLICO'].balance_now += periodRent.balance_now;
                        titlesSectorsMap['PUBLICO'].balance_before += periodRent.balance_before;
                        titlesSectorsMap['PUBLICO'].totalApplicationsAmount += periodRent.totalApplicationsAmount;
                        titlesSectorsMap['PUBLICO'].totalRescuesAmount += periodRent.totalRescuesAmount;
                        titlesSectorsMap['PUBLICO'].totalAmortizationAmount += periodRent.totalAmortizationAmount;
                    } else if (titlesSectorsMap['PRIVADO'].titlesIds.includes(+titleId)) {
                        titlesSectorsMap['PRIVADO'].balance_now += periodRent.balance_now;
                        titlesSectorsMap['PRIVADO'].balance_before += periodRent.balance_before;
                        titlesSectorsMap['PRIVADO'].totalApplicationsAmount += periodRent.totalApplicationsAmount;
                        titlesSectorsMap['PRIVADO'].totalRescuesAmount += periodRent.totalRescuesAmount;
                        titlesSectorsMap['PRIVADO'].totalAmortizationAmount += periodRent.totalAmortizationAmount;
                    } else {
                        titlesSectorsMap[GENERIC_ASSET_TITLES_TYPE].balance_now += periodRent.balance_now;
                        titlesSectorsMap[GENERIC_ASSET_TITLES_TYPE].balance_before += periodRent.balance_before;
                        titlesSectorsMap[GENERIC_ASSET_TITLES_TYPE].totalApplicationsAmount += periodRent.totalApplicationsAmount;
                        titlesSectorsMap[GENERIC_ASSET_TITLES_TYPE].totalRescuesAmount += periodRent.totalRescuesAmount;
                        titlesSectorsMap[GENERIC_ASSET_TITLES_TYPE].totalAmortizationAmount += periodRent.totalAmortizationAmount;
                    }
                }


            })

        })


        //Rentabilizando Títulos Por Setor e Período
        let titlesRentMoneyAcum = 0;
        Object.entries(titlesSectorsMap).map(([sector, row]) => {

            row.rentMoneyAcum = getSimpleRentMoneyTitle(row);
            row.rentAcum = row.titlesIds && row.titlesIds.length ? getSimpleRentTitle(row) : 0;
            titlesRentMoneyAcum += row.rentMoneyAcum;
        })

        console.log('fundBalancesMap: ', fundBalancesMap);
        console.log('titleBalancesMap: ', titleBalancesMap);
        //console.log('rentFundsMoneyAcumPortoflioPeriodMap: ', rentFundsMoneyAcumPortoflioPeriodMap);
        //console.log('rentTitlesMoneyAcumPortoflioPeriodMap: ', rentTitlesMoneyAcumPortoflioPeriodMap);
        console.log('titlesSectorsMap: ', titlesSectorsMap);

        //******FUNDOS E SUAS RENTABILDIADES EM % POR PERIODO */
        //Obter rentabilidade de cada mês e captalizar essas rentabilidades
        Object.entries(mapAveragePeriodQuotas).map(([fundId, row]) => {

            if (row) {
                row.averageQuotasByMonth.forEach((element, index) => {

                    const objToRent = {
                        ...element,
                        ...fundBalancesMap[fundId][element.period],
                    }

                    if (element.is_poupanca) {
                        element.rent = (((objToRent.balance_now + objToRent.totalRescuesAmount) / (objToRent.balance_before + objToRent.totalApplicationsAmount)) - 1) * 100
                    } else {
                        element.rent = getInMonthRentFundInPortfolio(objToRent);
                    }

                    fundBalancesMap[fundId][element.period].rent = element.rent;
                });
            }


        })

        Object.entries(fundBalancesMap).map(([fundId, periodsFund]) => {

            if (!periodsFund.rentAcum) {
                periodsFund.rentAcum = 1;
            }

            Object.entries(periodsFund).map(([period, periodRent]) => {

                if (period != 'rentMoneyAcum' && period != 'rentAcum'
                    && periodRent.rent != 0 && periodRent.rent != undefined) {

                    periodsFund.rentAcum *= (1 + (((periodRent.rent / 100) + 1) - 1));

                }

            })

            periodsFund.rentAcum = (periodsFund.rentAcum - 1) * 100;

        })

        //Integral mode
        Object.entries(integralPeriodFundsBalancesMap).map(([fundId, periodsFund]) => {

            if (!periodsFund.rentAcum) {
                periodsFund.rentAcum = 1;
            }

            Object.entries(periodsFund).map(([period, periodRent]) => {

                if (period != 'rentMoneyAcum' && period != 'rentAcum'
                    && periodRent.rent != 0 && periodRent.rent != undefined) {

                    periodsFund.rentAcum *= (1 + (((periodRent.rent / 100) + 1) - 1));
                }

            })

            periodsFund.rentAcum = (periodsFund.rentAcum - 1) * 100;

        })

        // console.log("AFTER ALL: ", integralPeriodFundsBalancesMap);
        // console.log("resultsFunds: ", fundBalancesMap);

        const fullResult = {
            resultFunds: fundBalancesMap,
            fundsBalancesByPeriod: fundsBalancesByPeriod,
            integralFundsBalancesMap: integralPeriodFundsBalancesMap,
            resultTitles: titlesSectorsMap,
            titlesRentMoneyAcum: titlesRentMoneyAcum,
            titleBalancesMap: titleBalancesMap,
        }

        console.log("integralFundsBalancesMap local: ", JSON.stringify(fullResult.integralFundsBalancesMap));

        return fullResult;

    }
}

//Fluxos de projeção de título do relatório provisório. Cada título cai em exatamente um deles.
export const PROVISIONAL_TITLE_FLOWS = {
    CONSIG: 'CONSIGNADO',
    GENERIC: 'GENÉRICO',
    CDI: 'CDI',
    IPCA: 'IPCA',
    IGPM: 'IGPM',
    PRE: 'PRÉ-FIXADO',
    SELIC: 'SELIC',
    PUBLIC_MARKET: 'PU MÉDIO',
}

/**
 * Define por qual fluxo de indexador um título será projetado no relatório provisório.
 *
 * A classificação segue a MESMA ordem de precedência de calculateRentTitles (TitleController),
 * usando os classificadores canônicos por sector + indexer. Isso é obrigatório porque o
 * empréstimo consignado é PRIVADO e sem indexador, logo casaria em isPrivatePreFixedTitle.
 *
 * label_title_type (= title_types.description) é texto livre cadastrado pelo usuário, por isso
 * só é usado como desempate dentro dos títulos públicos, nunca como chave primária.
 *
 * @param {object} title asset de título
 * @returns {string|null} chave de PROVISIONAL_TITLE_FLOWS, ou null se não houver fluxo aplicável
 */
export function getProvisionalTitleFlow(title) {

    if (isConsigTitle(title)) return PROVISIONAL_TITLE_FLOWS.CONSIG;
    if (isGenericTitle(title)) return PROVISIONAL_TITLE_FLOWS.GENERIC;

    const labelTitleType = (title.label_title_type || '').toUpperCase().trim();

    if (title.sector === 'PRIVADO') {

        if (isPrivateCdiTitle(title)) return PROVISIONAL_TITLE_FLOWS.CDI;
        if (isPrivateIpcaTitle(title)) return PROVISIONAL_TITLE_FLOWS.IPCA;
        if (title.indexer === 'IGPM') return PROVISIONAL_TITLE_FLOWS.IGPM;
        //CVS remunera por IPCA + taxa mesmo quando o indexador não foi informado
        if (labelTitleType === 'CVS') return PROVISIONAL_TITLE_FLOWS.IPCA;
        if (isPrivatePreFixedTitle(title)) return PROVISIONAL_TITLE_FLOWS.PRE;

        return null;
    }

    //Públicos: LFT acompanha a SELIC meta independente da marcação
    if (labelTitleType === 'LFT') return PROVISIONAL_TITLE_FLOWS.SELIC;
    //Marcados a mercado são precificados pelo PU médio da ANBIMA
    if (title.marking === MARKING_MARKET) return PROVISIONAL_TITLE_FLOWS.PUBLIC_MARKET;

    //Públicos na curva: o tipo do papel define o indexador que o remunera
    if (labelTitleType === 'NTNB') return PROVISIONAL_TITLE_FLOWS.IPCA;
    if (labelTitleType === 'NTNC') return PROVISIONAL_TITLE_FLOWS.IGPM;
    if (labelTitleType === 'LTN' || labelTitleType === 'NTNF') return PROVISIONAL_TITLE_FLOWS.PRE;

    //Tipos públicos não mapeados: usa o indexador cadastrado e, na falta dele, a taxa pré
    if (title.indexer === 'IPCA') return PROVISIONAL_TITLE_FLOWS.IPCA;
    if (title.indexer === 'IGPM') return PROVISIONAL_TITLE_FLOWS.IGPM;
    if (title.indexer === 'CDI') return PROVISIONAL_TITLE_FLOWS.CDI;

    return PROVISIONAL_TITLE_FLOWS.PRE;
}

/**
 * Obtém o valor de uma série de índice na data de referência.
 *
 * As séries de índice vêm do Comdinheiro e a data de referência vem das cotas de fundos, então
 * nem sempre existe a data exata. Quando falta, usa a última data disponível ANTES da referência
 * em vez de descartar o título silenciosamente (comportamento anterior).
 *
 * @param {Array} series array de { date: 'DD/MM/YYYY', value: number }
 * @param {string} referencePtDate data de referência 'DD/MM/YYYY'
 * @param {string} label nome da série, usado apenas nos logs
 * @returns {object|null} { value, date, isExact } ou null quando a série não serve
 */
export function pickIndexValueByReferenceDate(series, referencePtDate, label) {

    if (!Array.isArray(series) || !series.length) {
        console.warn(`[RELATÓRIO PROVISÓRIO] Série ${label} indisponível`);
        return null;
    }

    const exact = series.find(el => el.date == referencePtDate);
    if (exact) {
        return { value: exact.value, date: exact.date, isExact: true };
    }

    const reference = stringPtDateToMoment(referencePtDate);
    const beforeReference = series
        .filter(el => el.date && stringPtDateToMoment(el.date).isSameOrBefore(reference, 'day'))
        .sort((a, b) => stringPtDateToMoment(a.date).valueOf() - stringPtDateToMoment(b.date).valueOf());

    if (!beforeReference.length) {
        console.warn(`[RELATÓRIO PROVISÓRIO] Série ${label} sem nenhuma data até ${referencePtDate}`);
        return null;
    }

    const fallback = beforeReference[beforeReference.length - 1];
    console.warn(`[RELATÓRIO PROVISÓRIO] Série ${label} sem a data de referência ${referencePtDate}; usando ${fallback.date}`);

    return { value: fallback.value, date: fallback.date, isExact: false };
}

//Dias úteis (seg-sex) entre duas datas pt-BR. Usado só como fallback para definir a quantidade
//de dias do período quando não há série de cotas de fundos; não considera feriados.
function countBusinessDaysBetweenPtDates(startPtDate, endPtDate) {

    const cursor = stringPtDateToMoment(startPtDate);
    const end = stringPtDateToMoment(endPtDate);

    let businessDays = 0;
    while (cursor.isSameOrBefore(end, 'day')) {
        const weekDay = cursor.day();
        if (weekDay !== 0 && weekDay !== 6) {
            businessDays++;
        }
        cursor.add(1, 'day');
    }

    return businessDays;
}

export async function getDataToProvisonalReport(clientId, startDate, endDate) {

    const { month, year } = getDayMonthYearByPtDate(startDate);
    const { monthBefore, yearBefore } = getMonthAndYearBefore(startDate);

    const simpleAssets = await getSimpleNormalizedAssets(clientId, month, year);
    console.log('simpleAssets: ', simpleAssets);

    const realFundAssets = organizeAssetsAndTransactions(simpleAssets.assets.filter(el => el.fund_id), []);
    const realAssets = await fillLocalInfosByMonthAndYear(realFundAssets, monthBefore, yearBefore);

    //console.log('realAssets: ', realAssets);
    //Os títulos são usados apenas com os campos crus da API: calculateRentTitles não é chamado
    //aqui porque nenhum resultado dela é consumido e sua normalização converte balance_before 0
    //em null, gerando NaN nas projeções abaixo.
    const realTitles = simpleAssets.assets.filter(el => el.title_id)
    //console.log('realTitles: ', realTitles);

    const responseResolutionsVersions = await LegislationArticleAPI.getResolutionVersions();
    const resolutionName = responseResolutionsVersions.success && responseResolutionsVersions.body.rows.length ? responseResolutionsVersions.body.rows[responseResolutionsVersions.body.rows.length - 1].resolution_name : "Art.";

    const responseDisponibilityBefore = await doGetDisponilityByMonthAndYear(clientId, monthBefore, yearBefore);
    //doGetDisponilityByMonthAndYear retorna null quando não encontra exatamente uma linha
    const disponibilityBefore = Number.isFinite(parseFloat(responseDisponibilityBefore)) ? parseFloat(responseDisponibilityBefore) : 0;

    const responseLastQuota = await ClientAPI.getClientLastQuota(clientId, month, year);
    //console.log('responseLastQuota: ', responseLastQuota);
    //O endpoint pode responder { message: 'HAS_COTAS' } (primeiro mês) ou falhar, sem body[0]
    const lastQuotaRow = responseLastQuota && Array.isArray(responseLastQuota.body) && responseLastQuota.body.length
        ? responseLastQuota.body[0]
        : null;
    const lastQuotaValue = lastQuotaRow ? parseFloat(lastQuotaRow.quota_value) : NaN;
    const beforeTotalQtdQuotas = lastQuotaRow ? parseFloat(lastQuotaRow.qtd_quotas) : NaN;
    if (!lastQuotaRow) {
        console.warn("[RELATÓRIO PROVISÓRIO] Última cota do cliente indisponível: a rentabilidade total do período não será calculada");
    }

    const provisonalFundQuotas = await getCotasByListCnpjs(simpleAssets.simpleFunds.filter(el => el.fund_name), startDate, endDate, true);
    //console.log('provisonalFundQuotas: ', provisonalFundQuotas);

    // const provisonalTitlesInfos = await getTitlesInfos(realTitles, startDate, endDate);
    // console.log('provisonalTitlesInfos: ', provisonalTitlesInfos);

    const responseTransactionSums = await TransactionAPI.sumTransactionsInPeriodByFundAndOperation(clientId, startDate, endDate);
    const trasactionsSums = responseTransactionSums.success ? responseTransactionSums.data : null;

    if (realAssets.length || realTitles.length) {

        const fundQuotasMap = provisonalFundQuotas && provisonalFundQuotas.cotas ? provisonalFundQuotas.cotas : {};
        const entries = Object.entries(fundQuotasMap);
        const isValidQuota = (q) => q.valor_cota !== 0 || q.patrimonio_liquido !== 0;

        let referenceQuotaList = null;
        entries.forEach(element => {
            const { serie_historica: quotas } = element[1];
            const validQuotas = (quotas || []).filter(isValidQuota);
            if (validQuotas.length) {

                if (referenceQuotaList === null) {
                    referenceQuotaList = [...validQuotas]
                } else if (validQuotas.length > referenceQuotaList.length) {
                    referenceQuotaList = [...validQuotas];
                }
            }
        });

        console.log('referenceQuotaList: ', referenceQuotaList)

        //Sem nenhuma cota de fundo válida (cliente só com títulos, ou falha do Comdinheiro) o
        //relatório segue apenas com os títulos: a data de referência passa a ser o fim do período
        //e a quantidade de dias é estimada pelos dias úteis do intervalo.
        const hasFundQuotas = referenceQuotaList !== null && referenceQuotaList.length > 0;
        const countQuotas = hasFundQuotas ? referenceQuotaList.length : countBusinessDaysBetweenPtDates(startDate, endDate);
        const referenceQuotaDate = hasFundQuotas
            ? formatAnbimaDateToPt(referenceQuotaList[referenceQuotaList.length - 1].data_referencia)
            : endDate;
        if (!hasFundQuotas) {
            console.warn(`[RELATÓRIO PROVISÓRIO] Nenhuma cota de fundo válida no período; usando ${referenceQuotaDate} como data de referência e ${countQuotas} dias úteis estimados`);
        }
        console.log('referenceQuotaDate: ', referenceQuotaDate);

        const unprojectedFunds = [];

        realAssets.forEach(fund => {

            const rawQuotas = (fundQuotasMap[fund.cnpj]?.serie_historica || []).filter(isValidQuota);
            let iterableQuotas;
            if (rawQuotas.length === 0) {
                iterableQuotas = [];
            } else if (rawQuotas.length >= countQuotas) {
                iterableQuotas = rawQuotas.slice(0, countQuotas);
            } else {
                const lastQuota = rawQuotas[rawQuotas.length - 1];
                iterableQuotas = [...rawQuotas, ...Array(countQuotas - rawQuotas.length).fill(lastQuota)];
            }

            let provisionalQuotaValue = null;
            if (iterableQuotas.length === 0) {
                //normalizando quotas anbima
                fund.quotas_anbima_before = fund.quotas_anbima_before ? getClientJsonQuotas(JSON.parse(fund.quotas_anbima_before), fund.client_id) : [];
                provisionalQuotaValue = fund.quotas_anbima_before.length
                    ? parseFloat(fund.quotas_anbima_before[fund.quotas_anbima_before.length - 1].valor_cota)
                    : NaN;
            } else {
                provisionalQuotaValue = parseFloat(iterableQuotas[iterableQuotas.length - 1].valor_cota);
            }

            const balanceBefore = parseFloat(fund.balance_before);
            const quotaAmountBefore = parseFloat(fund.quota_amount_before);
            const safeBalanceBefore = Number.isFinite(balanceBefore) ? balanceBefore : 0;
            const hasQuotaValue = Number.isFinite(provisionalQuotaValue) && provisionalQuotaValue > 0;

            //Saldo anterior/quantidade de cotas vêm de LEFT JOIN e podem não existir; sem eles (ou
            //sem cota do período) o fundo não é projetável e o saldo anterior é carregado adiante,
            //em vez de virar NaN e contaminar o total da carteira.
            const isProjectableFund = hasQuotaValue
                && Number.isFinite(balanceBefore)
                && Number.isFinite(quotaAmountBefore)
                && quotaAmountBefore !== 0;

            if (!isProjectableFund) {
                unprojectedFunds.push({
                    fund_name: fund.fund_name,
                    cnpj: fund.cnpj,
                    reason: !hasQuotaValue ? 'sem cota no período' : 'sem saldo/quantidade de cotas do mês anterior',
                });
                console.warn(`[RELATÓRIO PROVISÓRIO] Fundo sem projeção: ${fund.fund_name} (${fund.cnpj})`);
            }

            const initValue = isProjectableFund ? balanceBefore / quotaAmountBefore : null;
            const provisionalRent = isProjectableFund ? ((provisionalQuotaValue / initValue) - 1) * 100 : 0;
            // Saldo rentabilizado pelas cotas (sem movimentações)
            const provisionalBalanceFromQuotas = isProjectableFund ? quotaAmountBefore * provisionalQuotaValue : safeBalanceBefore;
            // Rent monetária = somente apreciação das cotas (exclui movimentações)
            const provisionalMoneyRent = provisionalBalanceFromQuotas - safeBalanceBefore;

            // Saldo final = apreciação de cotas + aplicações - resgates do período
            const fundTransactions = trasactionsSums && trasactionsSums.mapFunds && trasactionsSums.mapFunds[fund.fund_id];
            const fundApplications = fundTransactions ? parseFloat(fundTransactions.applications || 0) : 0;
            const fundRescues = fundTransactions ? parseFloat(fundTransactions.rescues || 0) : 0;
            const provisionalBalanceNow = provisionalBalanceFromQuotas + fundApplications - fundRescues;

            fund.provisionalInfos = {
                initQuotaValue: initValue,
                provisionalQuotaValue: provisionalQuotaValue,
                provisionalRent: provisionalRent,
                provisionalMoneyRent: provisionalMoneyRent,
                provisionalBalanceNow: provisionalBalanceNow,
                isProjected: isProjectableFund,
            }

        });

        const dataToReport = [];
        let totalRentMoney = 0.0;

        const titlesToReport = [];
        //Títulos que não puderam ser projetados: o saldo anterior é carregado adiante para que
        //nenhum título desapareça do total, e o motivo fica visível no retorno do método.
        const unprojectedTitles = [];

        //applyMaskAmount não trata NaN/Infinity (exibiria "R$ NaN" ou "∞%" no PDF)
        const maskMoney = (value) => Number.isFinite(value) ? applyMaskAmount(value, true) : '-';
        const maskPercent = (value) => Number.isFinite(value) ? applyMaskAmount(value) + '%' : '-';
        const maskParticipation = (value, total) => Number.isFinite(value) && Number.isFinite(total) && total !== 0
            ? applyMaskAmount(value / total * 100) + '%'
            : '-';

        let totalBalance = realAssets.reduce((acc, current) => {
            const balance = current.provisionalInfos.provisionalBalanceNow;
            return acc + (Number.isFinite(balance) ? balance : 0);
        }, 0);

        //balance_before pode vir null (sem validação de saldo no mês anterior); 0 é um valor
        //válido e significa que o título foi comprado no período
        const getTitleBalanceBefore = (title) => {
            const parsed = parseFloat(title.balance_before);
            return Number.isFinite(parsed) ? parsed : null;
        };

        const buildTitleReportRow = (title, balanceNow, flow) => {

            const balanceBefore = getTitleBalanceBefore(title);
            const safeBalanceBefore = balanceBefore === null ? 0 : balanceBefore;
            const safeBalanceNow = Number.isFinite(balanceNow) ? balanceNow : safeBalanceBefore;

            return {
                fund_name: getTitleCod(title, true) + (flow ? ' - ' + flow : ' - SEM PROJEÇÃO'),
                title_id: title.title_id,
                title_name: title.title_name,
                label_title_type: title.label_title_type,
                balanceToDisplay: maskMoney(safeBalanceNow),
                provisionalBalanceNow: safeBalanceNow,
                balanceBefore: safeBalanceBefore,
                flow: flow,
                isProjected: flow != null,
                dados_cadastrais: {
                    disponibilization: '-'
                },
                sector: title.sector,
                article_to_show: '-',
                rt1: '-',
                rt2: '-',
            };
        };

        //Todo título entra em titlesToReport por aqui, garantindo que nenhum título de realTitles
        //fique fora do relatório nem do total da carteira - projetado ou não.
        const pushTitleToReport = (title, balanceNow, flow) => {
            const row = buildTitleReportRow(title, balanceNow, flow);
            totalBalance += row.provisionalBalanceNow;
            titlesToReport.push(row);
        };

        const pushUnprojectedTitle = (title, reason) => {
            const titleCod = getTitleCod(title, true);
            unprojectedTitles.push({
                titleCod: titleCod,
                sector: title.sector,
                label_title_type: title.label_title_type,
                reason: reason,
            });
            console.warn(`[RELATÓRIO PROVISÓRIO] Título sem projeção (${reason}): ${titleCod}`);
            pushTitleToReport(title, null, null);
        };

        if (realTitles.length) {

            //Agrupa os títulos pelo fluxo de projeção. A classificação usa os classificadores
            //canônicos (sector + indexer) e não a comparação literal de label_title_type, que é
            //texto livre cadastrado pelo usuário em title_types.description.
            const titlesByFlow = {};
            const titlesWithoutFlow = [];

            realTitles.forEach(title => {
                const flow = getProvisionalTitleFlow(title);
                if (!flow) {
                    titlesWithoutFlow.push(title);
                    return;
                }
                if (!titlesByFlow[flow]) {
                    titlesByFlow[flow] = [];
                }
                titlesByFlow[flow].push(title);
            });

            console.log('titlesByFlow: ', titlesByFlow);

            titlesWithoutFlow.forEach(title =>
                pushUnprojectedTitle(title, 'sem fluxo de projeção para o indexador cadastrado'));

            const flowTitles = (flow) => titlesByFlow[flow] || [];

            //Consignado e ativos genéricos (imóveis) não são projetados por indexador: mantêm o
            //saldo anterior, como no relatório oficial, onde rt1/rt2 aparecem como '-'
            flowTitles(PROVISIONAL_TITLE_FLOWS.CONSIG).forEach(title =>
                pushTitleToReport(title, getTitleBalanceBefore(title), PROVISIONAL_TITLE_FLOWS.CONSIG));
            flowTitles(PROVISIONAL_TITLE_FLOWS.GENERIC).forEach(title =>
                pushTitleToReport(title, getTitleBalanceBefore(title), PROVISIONAL_TITLE_FLOWS.GENERIC));

            //PU médio da ANBIMA x quantidade (públicos marcados a mercado)
            const marketTitles = flowTitles(PROVISIONAL_TITLE_FLOWS.PUBLIC_MARKET);
            if (marketTitles.length) {

                const responsePU_med = await doGetPU_med(marketTitles, startDate, endDate);
                const mapTitleCotas = responsePU_med ? responsePU_med.mapTitleCotas : null;

                marketTitles.forEach(title => {

                    const titleCod = getTitleCod(title, true);
                    const quotaAmountBefore = parseFloat(title.quota_amount_before);
                    const rawSeries = mapTitleCotas ? mapTitleCotas[titleCod] : null;
                    //normaliza a série de PU para o formato { date, value } esperado pelo seletor
                    const series = Array.isArray(rawSeries)
                        ? rawSeries.map(el => ({ date: el.date_quota, value: el.pu_med }))
                        : null;
                    const referencePu = pickIndexValueByReferenceDate(series, referenceQuotaDate, `PU médio ${titleCod}`);

                    //Quando a coluna de PU não vem, parseFloatComdinheiro devolve 0 (não NaN):
                    //tratar como indisponível para não zerar o saldo do título silenciosamente
                    if (!referencePu || !Number.isFinite(referencePu.value) || referencePu.value === 0) {
                        pushUnprojectedTitle(title, 'PU médio indisponível no período');
                        return;
                    }

                    if (!Number.isFinite(quotaAmountBefore)) {
                        pushUnprojectedTitle(title, 'quantidade de títulos do mês anterior indisponível');
                        return;
                    }

                    pushTitleToReport(title, quotaAmountBefore * referencePu.value, PROVISIONAL_TITLE_FLOWS.PUBLIC_MARKET);
                });
            }

            //Taxa pré-fixada
            flowTitles(PROVISIONAL_TITLE_FLOWS.PRE).forEach(title => {

                const balanceBefore = getTitleBalanceBefore(title);
                const preTax = parseFloat(title.pre_tax);

                if (balanceBefore === null) {
                    pushUnprojectedTitle(title, 'saldo do mês anterior indisponível');
                    return;
                }
                if (!Number.isFinite(preTax)) {
                    pushUnprojectedTitle(title, 'taxa pré-fixada não cadastrada');
                    return;
                }

                // Iq = [(1 + It)^q - 1], com q em dias úteis / 252
                const Iq = (Math.pow((1 + (preTax / 100)), countQuotas / 252) - 1);
                pushTitleToReport(title, (Iq * balanceBefore) + balanceBefore, PROVISIONAL_TITLE_FLOWS.PRE);
            });

            //IPCA + taxa pré-fixada
            const ipcaTitles = flowTitles(PROVISIONAL_TITLE_FLOWS.IPCA);
            if (ipcaTitles.length) {

                const responseIPCAdp = await doGetIPCAdp(startDate, endDate);
                const referenceIpca = pickIndexValueByReferenceDate(responseIPCAdp, referenceQuotaDate, 'IPCA dia pro-rata');

                ipcaTitles.forEach(title => {

                    const balanceBefore = getTitleBalanceBefore(title);

                    if (balanceBefore === null) {
                        pushUnprojectedTitle(title, 'saldo do mês anterior indisponível');
                        return;
                    }
                    if (!referenceIpca || !Number.isFinite(referenceIpca.value)) {
                        pushUnprojectedTitle(title, 'IPCA indisponível no período');
                        return;
                    }

                    //Sem taxa cadastrada o título rende apenas o indexador (spread zero)
                    const parsedPreTax = parseFloat(title.pre_tax);
                    const preTax = Number.isFinite(parsedPreTax) ? parsedPreTax : 0;
                    const truncReferenceIpca = truncateDecimals(referenceIpca.value, 8);

                    const IqIPCAdp = (Math.pow((1 + truncReferenceIpca), countQuotas) - 1);
                    const IqPreTax = (Math.pow((1 + (preTax / 100)), countQuotas / 252) - 1);
                    const IqFinal = (((1 + IqIPCAdp) * (1 + IqPreTax)) - 1) * 100;

                    pushTitleToReport(title, (IqFinal * balanceBefore / 100) + balanceBefore, PROVISIONAL_TITLE_FLOWS.IPCA);
                });
            }

            //IGPM + taxa pré-fixada
            const igpmTitles = flowTitles(PROVISIONAL_TITLE_FLOWS.IGPM);
            if (igpmTitles.length) {

                const responseIGPM = await doGetIGPM(startDate, endDate);
                const referenceIgpm = pickIndexValueByReferenceDate(responseIGPM, referenceQuotaDate, 'IGPM dia pro-rata');

                igpmTitles.forEach(title => {

                    const balanceBefore = getTitleBalanceBefore(title);

                    if (balanceBefore === null) {
                        pushUnprojectedTitle(title, 'saldo do mês anterior indisponível');
                        return;
                    }
                    if (!referenceIgpm || !Number.isFinite(referenceIgpm.value)) {
                        pushUnprojectedTitle(title, 'IGPM indisponível no período');
                        return;
                    }

                    const parsedPreTax = parseFloat(title.pre_tax);
                    const preTax = Number.isFinite(parsedPreTax) ? parsedPreTax : 0;
                    const truncReferenceIgpm = truncateDecimals(referenceIgpm.value, 8);

                    const IqIGPM = (Math.pow((1 + truncReferenceIgpm), countQuotas) - 1);
                    const IqPreTax = (Math.pow((1 + (preTax / 100)), countQuotas / 252) - 1);
                    const IqFinal = (((1 + IqIGPM) * (1 + IqPreTax)) - 1) * 100;

                    pushTitleToReport(title, (IqFinal * balanceBefore / 100) + balanceBefore, PROVISIONAL_TITLE_FLOWS.IGPM);
                });
            }

            //SELIC meta (LFT)
            const selicTitles = flowTitles(PROVISIONAL_TITLE_FLOWS.SELIC);
            if (selicTitles.length) {

                const responseSelicMeta = await doSelicMeta(startDate, endDate);
                const referenceSelicMeta = pickIndexValueByReferenceDate(responseSelicMeta, referenceQuotaDate, 'SELIC meta');

                selicTitles.forEach(title => {

                    const balanceBefore = getTitleBalanceBefore(title);

                    if (balanceBefore === null) {
                        pushUnprojectedTitle(title, 'saldo do mês anterior indisponível');
                        return;
                    }
                    if (!referenceSelicMeta || !Number.isFinite(referenceSelicMeta.value)) {
                        pushUnprojectedTitle(title, 'SELIC meta indisponível no período');
                        return;
                    }

                    const truncReferenceSelicMetaValue = truncateDecimals(referenceSelicMeta.value, 8);
                    pushTitleToReport(title, (balanceBefore * truncReferenceSelicMetaValue) + balanceBefore, PROVISIONAL_TITLE_FLOWS.SELIC);
                });
            }

            //Pós-fixado sobre o CDI (acumulado do período)
            const cdiTitles = flowTitles(PROVISIONAL_TITLE_FLOWS.CDI);
            if (cdiTitles.length) {

                const responseCDI = await doGetCDI(startDate, endDate, true, REQ_COMDINHEIRO_TYPE.RELATORIO_PROVISORIO);
                const referenceCDI = pickIndexValueByReferenceDate(responseCDI, referenceQuotaDate, 'CDI acumulado');

                cdiTitles.forEach(title => {

                    const balanceBefore = getTitleBalanceBefore(title);

                    if (balanceBefore === null) {
                        pushUnprojectedTitle(title, 'saldo do mês anterior indisponível');
                        return;
                    }
                    if (!referenceCDI || !Number.isFinite(referenceCDI.value)) {
                        pushUnprojectedTitle(title, 'CDI indisponível no período');
                        return;
                    }

                    //O % do CDI só é capturado no cadastro quando a marcação é CURVA; sem ele,
                    //assume-se 100% do CDI em vez de gerar NaN e contaminar o total da carteira
                    const rawIndexerPercent = parseFloat(title.indexer_percent);
                    const indexerPercent = Number.isFinite(rawIndexerPercent) ? rawIndexerPercent : 100;
                    if (!Number.isFinite(rawIndexerPercent)) {
                        console.warn(`[RELATÓRIO PROVISÓRIO] % do CDI não cadastrado em ${getTitleCod(title, true)}; assumindo 100% do CDI`);
                    }

                    const truncReferenceCDIValue = truncateDecimals(referenceCDI.value / 100, 8);
                    const finalCDIValue = indexerPercent / 100 * truncReferenceCDIValue;

                    pushTitleToReport(title, (balanceBefore * finalCDIValue) + balanceBefore, PROVISIONAL_TITLE_FLOWS.CDI);
                });
            }

        }

        //Movimentações de títulos do período, agregadas pelo backend por bucket
        //(PUBLICO | PRIVADO | EMPRÉSTIMO CONSIGNADO | ATIVO GENÉRICO). Amortizações
        //(cupons) são saída de caixa, como no fluxo oficial (getSimpleRentMoneyTitle2), e o
        //backend as devolve separadas de rescues.
        const titlesMovementsBySectors = (sectors) => {

            const result = { applications: 0, rescues: 0, amortizations: 0, hasMovements: false };
            if (!trasactionsSums || !trasactionsSums.mapTitles) return result;

            sectors.filter(Boolean).forEach(sector => {
                const movements = trasactionsSums.mapTitles[sector];
                if (!movements) return;
                result.hasMovements = true;
                result.applications += parseFloat(movements.applications || 0);
                result.rescues += parseFloat(movements.rescues || 0);
                result.amortizations += parseFloat(movements.amortizations || 0);
            });

            return result;
        };

        const titlesSectorKeys = trasactionsSums && trasactionsSums.mapTitles
            ? Object.keys(trasactionsSums.mapTitles).filter(sector => sector !== 'total')
            : [];

        // Ajustar totalBalance pelas movimentações líquidas de títulos do período
        const allTitlesMovements = titlesMovementsBySectors(titlesSectorKeys);
        totalBalance += allTitlesMovements.applications - allTitlesMovements.rescues - allTitlesMovements.amortizations;

        //Após calcular os saldos rentabilizados dos títulos, considerá-los no total balance e setar as participações
        console.log('totalBalance: ', totalBalance);
        console.log('titlesToReport: ', titlesToReport);
        console.log('unprojectedTitles: ', unprojectedTitles);
        titlesToReport.forEach(el => {
            el.participation = maskParticipation(el.provisionalBalanceNow, totalBalance);

            //Título sem projeção mantém o saldo anterior, logo não gera rentabilidade
            const rent = el.isProjected ? el.provisionalBalanceNow - el.balanceBefore : 0;

            totalRentMoney += Number.isFinite(rent) ? rent : 0;

            el.rt1 = el.isProjected ? maskMoney(rent) : '-';
            el.rt2 = el.isProjected && el.balanceBefore !== 0
                ? maskPercent(((el.provisionalBalanceNow / el.balanceBefore) - 1) * 100)
                : '-';
        })

        realAssets.forEach(asset => {

            const { provisionalInfos } = asset;
            asset.balanceToDisplay = maskMoney(provisionalInfos.provisionalBalanceNow);
            const rentFundMonth = provisionalInfos.provisionalRent;

            const rentMoney = provisionalInfos.provisionalMoneyRent;

            //Fundo sem cota do período não é projetado: mantém o saldo anterior e não exibe rent
            //RENT R$
            asset.rt1 = provisionalInfos.isProjected ? maskMoney(rentMoney) : '-'
            //RENT %
            asset.rt2 = provisionalInfos.isProjected ? maskPercent(rentFundMonth) : '-'

            totalRentMoney += (provisionalInfos.isProjected && Number.isFinite(rentMoney)) ? rentMoney : 0;

            //Caso o fundo seja especial ele não possui dados cadatrais, então inicializa-se a disponibilização com vazio pois é um campo utilizado 
            //no portfolio_report e daria null pointer caso dados_cadastrais não existissem e se tentasse acessar o atributo "disponibilization"

            if (asset.dados_cadastrais && asset.dados_cadastrais.disponibilization) {

                asset.dados_cadastrais.disponibilization = disponibilizationDicionary(asset.dados_cadastrais.disponibilization).label;

            } else {
                asset.dados_cadastrais = {
                    disponibilization: "-",
                }
            }

            asset.resolutionName = resolutionName;
            asset.article_to_show = asset.device_abbreviation ? asset.device_abbreviation : '-';
            asset.lack_liquidity_to_show = !asset.lack_liquidity_date ? '-' : moment.utc(asset.lack_liquidity_date).format("DD/MM/YY");
            asset.participation = maskParticipation(provisionalInfos.provisionalBalanceNow, totalBalance);


            if (trasactionsSums && trasactionsSums.mapFunds && trasactionsSums.mapFunds[asset.fund_id]) {
                const { applications, rescues } = trasactionsSums.mapFunds[asset.fund_id];
                asset.totalApplications = applyMaskAmount(applications, true);
                asset.totalApplicationsNumeric = applications;
                asset.totalRescues = applyMaskAmount(rescues, true);
                asset.totalRescuesNumeric = rescues;
            } else {
                asset.totalApplications = '-';
                asset.totalApplicationsNumeric = 0;
                asset.totalRescues = '-';
                asset.totalRescuesNumeric = 0;
            }

            // if (asset.fund_name) {
            //     asset.fund_name = formatStringToDisplay(asset.fund_name, 6, '...');
            // }

            dataToReport.push(asset);
        });

        //Agrupamento das linhas de títulos exibidas no relatório. A ordem repete a de
        //groupAssetTitles (TitleController): consignado e ativos genéricos são identificados antes
        //do sector, e qualquer sector inesperado cai num grupo residual em vez de desaparecer.
        const publicTitles = [];
        const privateTitles = [];
        const genericTitles = [];
        const consigTitles = [];
        const residualTitles = [];

        titlesToReport.forEach(ass => {

            if (ass.flow === PROVISIONAL_TITLE_FLOWS.CONSIG) {
                consigTitles.push(ass);
            } else if (ass.flow === PROVISIONAL_TITLE_FLOWS.GENERIC) {
                genericTitles.push(ass);
            } else if (ass.sector == 'PUBLICO') {
                publicTitles.push(ass);
            } else if (ass.sector == 'PRIVADO') {
                privateTitles.push(ass);
            } else {
                residualTitles.push(ass);
            }

        });

        //Buckets já cobertos por uma linha própria: o que sobrar cai em OUTROS TÍTULOS para o total
        //continuar fechando
        const groupedSectorKeys = ['PUBLICO', 'PRIVADO', GENERIC_ASSET_CONSIG, GENERIC_ASSET_TITLES_TYPE];
        const residualSectorKeys = titlesSectorKeys.filter(sector => !groupedSectorKeys.includes(sector));

        /**
         * Emite a linha agregada de um grupo de títulos.
         *
         * rt1/rt2 usam as mesmas funções do relatório oficial (getSimpleRentMoneyTitle2 e
         * getSimpleRentTitle2), o que alinha o denominador em (saldo anterior + aplicações) e
         * trata amortizações como saída de caixa que já rendeu no período.
         *
         * @param {string} groupName rótulo da linha
         * @param {Array} groupRows linhas de título do grupo
         * @param {string} sectorLabel valor de sector gravado na linha
         * @param {Array} movementsSectors sectors cujas movimentações pertencem a este grupo
         * @param {boolean} isProjectable false para grupos que não são projetados por indexador
         */
        const pushTitlesGroupLine = (groupName, groupRows, sectorLabel, movementsSectors, isProjectable) => {

            const { applications, rescues, amortizations, hasMovements } = titlesMovementsBySectors(movementsSectors);

            //A linha também é emitida quando só existem movimentações (ex.: título totalmente
            //resgatado no período, que já não aparece na lista de ativos): sem ela essas
            //movimentações entrariam no total sem aparecer em nenhuma linha do relatório
            if (!groupRows.length && !hasMovements) return;

            const balanceBefore = groupRows.reduce((acc, current) => acc + current.balanceBefore, 0);
            const balanceFromRent = groupRows.reduce((acc, current) => acc + current.provisionalBalanceNow, 0);

            //Saída de caixa do período = resgates + amortizações (cupons)
            const cashOut = rescues + amortizations;
            const balanceNow = balanceFromRent + applications - cashOut;

            dataToReport.push({
                fund_name: groupName,
                balanceToDisplay: maskMoney(balanceNow),
                participation: maskParticipation(balanceNow, totalBalance),
                provisionalBalanceNow: balanceNow,
                balanceBefore: balanceBefore,
                dados_cadastrais: {
                    disponibilization: '-'
                },
                sector: sectorLabel,
                article_to_show: '-',
                rt1: isProjectable
                    ? maskMoney(getSimpleRentMoneyTitle2(balanceNow, applications, rescues, amortizations, balanceBefore))
                    : '-',
                rt2: isProjectable
                    ? maskPercent(getSimpleRentTitle2(balanceNow, applications, rescues, amortizations, balanceBefore))
                    : '-',
                totalApplications: hasMovements ? maskMoney(applications) : '-',
                totalApplicationsNumeric: applications,
                totalRescues: hasMovements ? maskMoney(cashOut) : '-',
                totalRescuesNumeric: cashOut,
            })
        };

        pushTitlesGroupLine(PUBLIC_TITLES, publicTitles, 'PUBLICO', ['PUBLICO'], true);
        pushTitlesGroupLine(PRIVATE_TITLES, privateTitles, 'PRIVADO', ['PRIVADO'], true);
        //Consignado e genéricos não são projetados por indexador, logo não exibem rentabilidade,
        //mas exibem as próprias movimentações (buckets dedicados no backend)
        pushTitlesGroupLine(GENERIC_ASSET_CONSIG, consigTitles, GENERIC_ASSET_CONSIG, [GENERIC_ASSET_CONSIG], false);
        pushTitlesGroupLine(GENERIC_ASSETS, genericTitles, GENERIC_ASSETS, [GENERIC_ASSET_TITLES_TYPE], false);
        //Títulos cujo sector não é PUBLICO nem PRIVADO ganham uma linha própria para que o total
        //continue fechando com a soma das linhas exibidas
        pushTitlesGroupLine('OUTROS TÍTULOS', residualTitles, 'OUTROS', residualSectorKeys, true);

        //Adicionando linhas de títulos
        // titlesToReport.forEach(element => {
        //     dataToReport.push(element);
        // });
        //A cota nova só existe se houver quantidade de cotas do fechamento anterior
        const newQuotaValue = Number.isFinite(beforeTotalQtdQuotas) && beforeTotalQtdQuotas !== 0
            ? totalBalance / beforeTotalQtdQuotas
            : null;

        const totalPortfolioPeriodRent = (newQuotaValue !== null && Number.isFinite(lastQuotaValue) && lastQuotaValue !== 0)
            ? maskPercent(((newQuotaValue / lastQuotaValue) - 1) * 100)
            : '-';

        //A saída de caixa total inclui as amortizações de títulos, que o backend devolve separadas
        const totalApplicationsSum = trasactionsSums && trasactionsSums.total ? parseFloat(trasactionsSums.total.applications || 0) : 0;
        const totalCashOutSum = trasactionsSums && trasactionsSums.total
            ? parseFloat(trasactionsSums.total.rescues || 0) + parseFloat(trasactionsSums.total.amortizations || 0)
            : 0;

        dataToReport.push({
            fund_name: 'Total investimentos',
            balanceBeforeToDisplay: applyMaskAmount(0, true),
            balanceBeforeNumeric: 0,
            balanceToDisplay: maskMoney(totalBalance),
            balanceNowNumeric: totalBalance,
            participation: '100.00%',
            rt1: maskMoney(totalRentMoney),
            rt2: totalPortfolioPeriodRent,
            dados_cadastrais: {
                disponibilization: "",
            },
            totalApplications: trasactionsSums && trasactionsSums.total ? maskMoney(totalApplicationsSum) : '-',
            totalApplicationsNumeric: totalApplicationsSum,
            totalRescues: trasactionsSums && trasactionsSums.total ? maskMoney(totalCashOutSum) : '-',
            totalRescuesNumeric: totalCashOutSum,
        });

        dataToReport.push({
            fund_name: 'Disponibilidade',
            balanceToDisplay: maskMoney(disponibilityBefore),
            participation: '-',
            rt1: '-',
            rt2: '-',
            dados_cadastrais: {
                disponibilization: "",
            }
        });

        dataToReport.push({
            fund_name: 'Total patrimônio',
            balanceToDisplay: maskMoney(totalBalance + disponibilityBefore),
            balanceNowNumeric: totalBalance + disponibilityBefore,
            participation: '100.00%',
            rt1: '-',
            rt2: '-',
            dados_cadastrais: {
                disponibilization: "",
            }
        });

        //clean object to stream, retirando subassets e subAssetTitles
        dataToReport.forEach(element => {
            if (element.subAssetsTitles) {
                delete element.subAssetsTitles
            }

            if (element.subAssets) {
                delete element.subAssets
            }

        });

        //O template do relatório lê data[0].resolutionName no cabeçalho da coluna de artigo, e a
        //primeira linha pode ser um grupo de títulos quando o cliente não possui fundos
        if (dataToReport.length && !dataToReport[0].resolutionName) {
            dataToReport[0].resolutionName = resolutionName;
        }

        console.log("dataToReport: ", dataToReport);

        return {
            success: true,
            dataToReport: dataToReport,
            referenceQuotaDate: referenceQuotaDate,
            unprojectedTitles: unprojectedTitles,
            unprojectedFunds: unprojectedFunds,
        }

    }

    console.warn("[RELATÓRIO PROVISÓRIO] Cliente sem fundos e sem títulos no período");
    return {
        success: false,
        message: 'Cliente sem fundos e sem títulos no período informado',
    }

}

//Mantido como reexport para não mexer nos importadores (IPC14, SegregationTab): a definição dos
//regimes vive em components/utils/accountRegimes.js
export const regimeMap = REGIME_UPPER_LABELS;

//Formatos de célula da planilha de Carteira. O xlsx 0.16.7 (build comunitário) só suporta
//formato numérico, então é o único recurso de apresentação disponível aqui.
const PORTFOLIO_EXCEL_BRL_FORMAT = '_-R$ * #,##0.00_-;_-R$ * -#,##0.00_-;_-R$ * "-"??_-;_-@_-';
const PORTFOLIO_EXCEL_PERCENT_FORMAT = '0.00"%"';

//Índices (base 0) das colunas numéricas na planilha de Carteira
const PORTFOLIO_EXCEL_BRL_COLUMNS = [2, 7];
const PORTFOLIO_EXCEL_PERCENT_COLUMNS = [3, 8, 9];

//As linhas chegam do builder do PDF já mascaradas ("R$ 1.234,56", "12,34%"). Para a planilha
//permitir soma e ordenação desfazemos a máscara; sem dado ('-') mantém-se o texto original,
//e campos ausentes (linhas de total) viram célula vazia, como no PDF.
function portfolioExcelNumberCell(maskedValue, parser) {

    if (typeof maskedValue === 'number') return Number.isFinite(maskedValue) ? maskedValue : '';
    if (typeof maskedValue !== 'string') return '';

    const parsed = parser(maskedValue);
    return Number.isFinite(parsed) ? parsed : maskedValue;
}

/**
 * Exporta em xlsx exatamente as linhas que o PDF de Carteira renderiza no período, reaproveitando
 * getDataToPortfolioReport para não duplicar a regra de cálculo. As colunas espelham
 * src/templates_reports/portfolio_report.ejs, com o CNPJ promovido a coluna própria (em planilha
 * ele não caberia como segunda linha da célula do ativo).
 * @returns {Promise<boolean>} false quando não foi possível obter os dados
 */
export async function doPortfolioExcelReport(clientId, clientLabelName, startDate, endDate, periodReport) {

    //DEBUG: zera o dump anterior para que window.__rentDebug reflita só esta geração. Sem
    //window.__RENT_DEBUG definido isso é no-op. (No PDF, rodar window.__rentDebug = null à mão.)
    rentDebugReset();

    const response = await getDataToPortfolioReport(clientId, startDate, endDate, null, periodReport, {
        isAssetAndAccountsReport: false,
        isAccumulatedTrasactionsReport: false,
        includeCnpj: true,
    });

    if (!response || !response.success) return false;

    const rows = response.dataToPortfolioReport || [];
    if (!rows.length) return false;

    //Mesma origem do cabeçalho dinâmico do ejs (<%= data[0].resolutionName %>); as linhas de
    //total não carregam o campo, por isso a busca na lista toda
    const resolutionName = rows.find(el => el.resolutionName)?.resolutionName || 'ENQUADRAMENTO';

    const { month: startMonth } = getDayMonthYearByStringDate(startDate);
    const { month, year } = getDayMonthYearByStringDate(endDate);

    //Mesmo rótulo de período que o PDF exibe no cabeçalho
    const periodLabel = startMonth == month
        ? getMonthName(month) + '/' + year
        : getMonthName(startMonth) + ' a ' + getMonthName(month) + ' de ' + year;

    const fileName = 'Carteira [' + clientLabelName + '] ' + periodLabel;

    const wb = XLSX.utils.book_new();
    wb.Props = {
        Title: fileName,
        Author: "UNO",
    }

    //Excel limita o nome da aba a 31 caracteres
    const sheetName = 'Carteira ' + year;
    wb.SheetNames.push(sheetName);

    const ws_data = [];

    ws_data.push(['ATIVO', 'CNPJ', 'SALDO', 'CARTEIRA(%)', 'RESG.', 'CARÊN.', resolutionName,
        'RETORNO (R$)', '(%)', 'TX ADM'])

    //Ordem preservada: as linhas de Total investimentos / Disponibilidade / Total patrimônio já
    //vêm no fim do array montado por getDataToPortfolioReport
    rows.forEach(row => {

        ws_data.push([
            row.fund_name,
            row.cnpj || '',
            portfolioExcelNumberCell(row.balanceToDisplay, parseBrlCurrencyToFloat),
            portfolioExcelNumberCell(row.participation, parsePercentage),
            row.dados_cadastrais?.disponibilization ?? '',
            row.lack_liquidity_to_show ?? '',
            row.article_to_show ?? '',
            portfolioExcelNumberCell(row.rt1, parseBrlCurrencyToFloat),
            portfolioExcelNumberCell(row.rt2, parsePercentage),
            portfolioExcelNumberCell(row.administration_tax, parsePercentage),
        ])

    });

    const ws = XLSX.utils.aoa_to_sheet(ws_data);

    //Formato só nas células que efetivamente viraram número; '-' e vazios seguem como texto
    const range = XLSX.utils.decode_range(ws['!ref']);
    for (let R = 1; R <= range.e.r; ++R) {
        PORTFOLIO_EXCEL_BRL_COLUMNS.concat(PORTFOLIO_EXCEL_PERCENT_COLUMNS).forEach(C => {

            const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
            if (!ws[cellAddress] || typeof ws[cellAddress].v !== 'number') return;

            ws[cellAddress].t = 'n';
            ws[cellAddress].z = PORTFOLIO_EXCEL_BRL_COLUMNS.includes(C)
                ? PORTFOLIO_EXCEL_BRL_FORMAT
                : PORTFOLIO_EXCEL_PERCENT_FORMAT;

        });
    }

    wb.Sheets[sheetName] = ws;
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' })

    downloadBlob(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName + '.xlsx');

    return true;
}

export async function doClientDataBaseByYear(clientId, clientLabelName, year) {

    //Obtendo movimentações
    const firstDayYear = getFirstDayYear(year);
    const lastDayYear = getLastPtDayOfYear(year);
    console.log("firstDayYear: ", firstDayYear);
    console.log("lastDayYear: ", lastDayYear);

    ///////////////////////
    //BASE DE MOVIMENTAÇÕES
    ///////////////////////
    const transactionsResponse = await TransactionAPI.getClientAllTransactionByDateRangeAndRegime(clientId, firstDayYear, lastDayYear, null, true);
    //console.log("transactionsResponse: ", transactionsResponse);

    const operationMap = {
        1: 'APLICAÇÃO',
        2: 'RESGATE',
        3: 'AMORTIZAÇÃO'
    }

    const fundsIds = [];
    const titlesIds = [];
    const transactions = transactionsResponse.body.rows;
    transactions.forEach(el => {
        if (el.title_id && !titlesIds.includes(el.title_id)) titlesIds.push(el.title_id);
        if (el.fund_id && !fundsIds.includes(el.fund_id)) fundsIds.push(el.fund_id);
    });


    const mapFundsQuotas = {};
    if (fundsIds.length) {
        const fundsQuotasResponse = await FundLocalQuotasAPI.getLocalQuotasByFundsIdsAndYear(fundsIds, year);
        console.log("fundsQuotasResponse: ", fundsQuotasResponse);
        const fundsQuotas = fundsQuotasResponse.body.rows;
        fundsQuotas.forEach(element => {
            const { fund_id, json_quotas, month, year } = element;
            const quotas = JSON.parse(json_quotas);
            if (!mapFundsQuotas[fund_id]) {
                mapFundsQuotas[fund_id] = {}
            }
            const period = month + "/" + year;
            mapFundsQuotas[fund_id][period] = quotas;
        });
    }

    const mapTitles = {};
    if (titlesIds.length) {
        const titlesResponse = await TitleAPI.getTitlesByIds(titlesIds);
        const titles = titlesResponse.body.rows;
        console.log("titles: ", titles)

        titles.forEach(element => {
            mapTitles[element.id] = element;
        });
    }

    const getFundQuotasValue = (transaction, allQuotasFunds) => {
        if (transaction.title_id) {
            return "";
        } else if (transaction.operation_id == 3) {
            return 0;
        }

        const transactionDate = moment.utc(transaction.transaction_date).format("DD/MM/YYYY");
        const anbimaDate = formatPtStringDateToAnbimaDate(transactionDate);
        const spliitedDate = anbimaDate.split('-');
        const periodTransation = parseInt(spliitedDate[1]) + "/" + spliitedDate[0]

        const foundQuota = allQuotasFunds[periodTransation] ? allQuotasFunds[periodTransation].find(el => el.data_referencia == anbimaDate) : "";

        if (foundQuota) {
            return parseFloat(transaction.amount) / foundQuota.valor_cota;
        }

        return "";

    }

    const formattedTransactions = transactions.map(t => ({
        numberApr: t.number_apr,
        segregation: regimeMap[t.account_regime_id],
        cnpj: t.title_id ? mapTitles[t.title_id].label_title_type + " " + moment.utc(mapTitles[t.title_id].dua_date).format("DD/MM/YYYY") : t.fund_cnpj,
        fundName: t.title_id ? getTitleCod(mapTitles[t.title_id]) : t.fund_name,
        cc: applyMaskAccount(t.account),
        transactionDate: moment.utc(t.transaction_date).format("DD/MM/YYYY"),
        operation: operationMap[t.operation_id],
        quotas: t.title_id ? "" : getFundQuotasValue(t, mapFundsQuotas[t.fund_id]),
        amount: applyMaskAmount(t.amount, true),
        description: t.apr_description,
    }))

    console.log("formattedTransactions: ", formattedTransactions);

    ///////////////////////
    //BASE DE SALDOS FUNDOS
    ///////////////////////

    const responseAssets = await FundAPI.getAllClientAssetsByRegime(clientId, null);
    const responseBv = await ClientAPI.getClientInvestmentsBalancesValidationsByYearAndRegime(year, clientId, null);

    const formattedFundsBalancesInYear = formatBalancesAssetsValidationToShow(year,
        responseAssets.body.rows,
        responseBv.body.rows);

    console.log("formattedFundsBalancesInYear: ", formattedFundsBalancesInYear);

    ///////////////////////
    //BASE DE SALDOS CONTAS
    ///////////////////////

    const responseAccs = await AccountAPI.getClientAccountsByRegimeAndDate(clientId, null);
    const responseBvAccounts = await ClientAPI.getClientAccountsBalancesValidationsByYear(year, clientId);
    const formattedAccountsBalancesInYear = formatBalancesAccountsValidationToShow(year,
        responseAccs.body.rows,
        responseBvAccounts.body.rows)

    console.log("formattedAccountsBalancesInYear: ", formattedAccountsBalancesInYear);

    ///////////////////////
    //BASE DE TITULOS
    ///////////////////////

    const responseTitleAssets = await TitleAPI.getClientAssetsTitles(year, clientId, null);
    console.log("RESPONSE TITLES: ", responseTitleAssets);
    const responseBvTitles = await ClientAPI.getClientTitlesBalancesValidationsByYearAndRegime(year, clientId, null);
    const formattedTitlesBalancesInYear = formatInfosToShow(year,
        responseTitleAssets.body.rows,
        responseBvTitles.body.rows)

    console.log("formattedTitlesBalancesInYear: ", formattedTitlesBalancesInYear);

    /////////////////////////////
    //GERANDO EXCEL MOVIMENTAÇÕES
    /////////////////////////////
    const wbMovs = XLSX.utils.book_new();
    const fileNameMovs = "Movimentações " + year;
    wbMovs.Props = {
        Title: fileNameMovs,
        Author: "UNO",
    }

    const sheetNameMovs = fileNameMovs;
    wbMovs.SheetNames.push(sheetNameMovs);

    const ws_data_movs = [];

    ws_data_movs.push(['NÚM. APR', 'SEGREGAÇÃO', 'CNPJ', 'FUNDO', 'CC', 'DATA', 'OPERAÇÃO', 'QUANTIDADE DE COTAS', 'VALOR', 'DESCRIÇÃO'])

    formattedTransactions.forEach(transaction => {

        ws_data_movs.push([
            transaction.numberApr,
            transaction.segregation,
            transaction.cnpj,
            transaction.fundName,
            transaction.cc,
            transaction.transactionDate,
            transaction.operation,
            transaction.quotas,
            transaction.amount,
            transaction.description,
        ])

    });

    const ws_movs = XLSX.utils.aoa_to_sheet(ws_data_movs);

    wbMovs.Sheets[sheetNameMovs] = ws_movs;
    const wbout_movs = XLSX.write(wbMovs, { bookType: 'xlsx', type: 'binary' })

    //downloadBlob(new Blob([s2ab(wbout_movs)], { type: "application/octet-stream" }), fileNameMovs + '.xlsx');
    const movsBlob = new Blob([s2ab(wbout_movs)], { type: "application/octet-stream" });

    /////////////////////////////
    //GERANDO EXCEL SALDOS
    /////////////////////////////
    const wbBalances = XLSX.utils.book_new();
    const fileNameBalances = "Ativos e Contas " + year;
    wbBalances.Props = {
        Title: fileNameBalances,
        Author: "UNO",
    }

    wbBalances.SheetNames.push("Ativos");
    wbBalances.SheetNames.push("Contas");

    const ws_data_balances_assets = [];

    ws_data_balances_assets.push(['SEGREGAÇÃO', 'CC', 'CNPJ DO FUNDO', 'NOME DO FUNDO',
        'QUANTIDADE DE COTAS JAN',
        'VALOR JAN',
        'QUANTIDADE DE COTAS FEV',
        'VALOR FEV',
        'QUANTIDADE DE COTAS MAR',
        'VALOR MAR',
        'QUANTIDADE DE COTAS ABR',
        'VALOR ABR',
        'QUANTIDADE DE COTAS MAI',
        'VALOR MAI',
        'QUANTIDADE DE COTAS JUN',
        'VALOR JUN',
        'QUANTIDADE DE COTAS JUL',
        'VALOR JUL',
        'QUANTIDADE DE COTAS AGO',
        'VALOR AGO',
        'QUANTIDADE DE COTAS SET',
        'VALOR SET',
        'QUANTIDADE DE COTAS OUT',
        'VALOR OUT',
        'QUANTIDADE DE COTAS NOV',
        'VALOR NOV',
        'QUANTIDADE DE COTAS DEZ',
        'VALOR DEZ',
    ])

    const { assets } = formattedFundsBalancesInYear;

    Object.entries(assets).map(([key, asset]) => {

        const quotaAmount1 = asset[1].quota_amount != null ? parseFloat(asset[1].quota_amount) : "";
        const quotaAmount2 = asset[2].quota_amount != null ? parseFloat(asset[2].quota_amount) : "";
        const quotaAmount3 = asset[3].quota_amount != null ? parseFloat(asset[3].quota_amount) : "";
        const quotaAmount4 = asset[4].quota_amount != null ? parseFloat(asset[4].quota_amount) : "";
        const quotaAmount5 = asset[5].quota_amount != null ? parseFloat(asset[5].quota_amount) : "";
        const quotaAmount6 = asset[6].quota_amount != null ? parseFloat(asset[6].quota_amount) : "";
        const quotaAmount7 = asset[7].quota_amount != null ? parseFloat(asset[7].quota_amount) : "";
        const quotaAmount8 = asset[8].quota_amount != null ? parseFloat(asset[8].quota_amount) : "";
        const quotaAmount9 = asset[9].quota_amount != null ? parseFloat(asset[9].quota_amount) : "";
        const quotaAmount10 = asset[10].quota_amount != null ? parseFloat(asset[10].quota_amount) : "";
        const quotaAmount11 = asset[11].quota_amount != null ? parseFloat(asset[11].quota_amount) : "";
        const quotaAmount12 = asset[12].quota_amount != null ? parseFloat(asset[12].quota_amount) : "";


        ws_data_balances_assets.push([
            regimeMap[asset.infosAssets.account_regime_id],
            applyMaskAccount(asset.infosAssets.number_account),
            asset.infosAssets.cnpj,
            asset.infosAssets.fund_name,
            quotaAmount1 < 0 ? 0 : quotaAmount1,
            asset[1].balance ? applyMaskAmount(asset[1].balance, true) : "",
            quotaAmount2 < 0 ? 0 : quotaAmount2,
            asset[2].balance ? applyMaskAmount(asset[2].balance, true) : "",
            quotaAmount3 < 0 ? 0 : quotaAmount3,
            asset[3].balance ? applyMaskAmount(asset[3].balance, true) : "",
            quotaAmount4 < 0 ? 0 : quotaAmount4,
            asset[4].balance ? applyMaskAmount(asset[4].balance, true) : "",
            quotaAmount5 < 0 ? 0 : quotaAmount5,
            asset[5].balance ? applyMaskAmount(asset[5].balance, true) : "",
            quotaAmount6 < 0 ? 0 : quotaAmount6,
            asset[6].balance ? applyMaskAmount(asset[6].balance, true) : "",
            quotaAmount7 < 0 ? 0 : quotaAmount7,
            asset[7].balance ? applyMaskAmount(asset[7].balance, true) : "",
            quotaAmount8 < 0 ? 0 : quotaAmount8,
            asset[8].balance ? applyMaskAmount(asset[8].balance, true) : "",
            quotaAmount9 < 0 ? 0 : quotaAmount9,
            asset[9].balance ? applyMaskAmount(asset[9].balance, true) : "",
            quotaAmount10 < 0 ? 0 : quotaAmount10,
            asset[10].balance ? applyMaskAmount(asset[10].balance, true) : "",
            quotaAmount11 < 0 ? 0 : quotaAmount11,
            asset[11].balance ? applyMaskAmount(asset[11].balance, true) : "",
            quotaAmount12 < 0 ? 0 : quotaAmount12,
            asset[12].balance ? applyMaskAmount(asset[12].balance, true) : "",
        ])
    })

    const ws_data_balances_accounts = [];

    ws_data_balances_accounts.push(['SEGREGAÇÃO', 'CC', 'CÓDIGO - NOME DA INSTITUIÇÃO',
        'SALDO JAN',
        'SALDO FEV',
        'SALDO MAR',
        'SALDO ABR',
        'SALDO MAI',
        'SALDO JUN',
        'SALDO JUL',
        'SALDO AGO',
        'SALDO SET',
        'SALDO OUT',
        'SALDO NOv',
        'SALDO DEZ',
    ])

    const { accounts } = formattedAccountsBalancesInYear;

    console.log("accounts: ", accounts);

    Object.entries(accounts).map(([key, account]) => {

        console.log("account: ", account);

        ws_data_balances_accounts.push([
            regimeMap[account.account_regime_id],
            applyMaskAccount(account.infosAccounts.number_account),
            account.infosAccounts.instituition,
            account[1].balance ? applyMaskAmount(account[1].balance, true) : "",
            account[2].balance ? applyMaskAmount(account[2].balance, true) : "",
            account[3].balance ? applyMaskAmount(account[3].balance, true) : "",
            account[4].balance ? applyMaskAmount(account[4].balance, true) : "",
            account[5].balance ? applyMaskAmount(account[5].balance, true) : "",
            account[6].balance ? applyMaskAmount(account[6].balance, true) : "",
            account[7].balance ? applyMaskAmount(account[7].balance, true) : "",
            account[8].balance ? applyMaskAmount(account[8].balance, true) : "",
            account[9].balance ? applyMaskAmount(account[9].balance, true) : "",
            account[10].balance ? applyMaskAmount(account[10].balance, true) : "",
            account[11].balance ? applyMaskAmount(account[11].balance, true) : "",
            account[12].balance ? applyMaskAmount(account[12].balance, true) : "",
        ])
    })

    const ws_balances_assets = XLSX.utils.aoa_to_sheet(ws_data_balances_assets);
    const ws_balances_accounts = XLSX.utils.aoa_to_sheet(ws_data_balances_accounts);

    wbBalances.Sheets["Ativos"] = ws_balances_assets;
    wbBalances.Sheets["Contas"] = ws_balances_accounts;
    const wbout_balances = XLSX.write(wbBalances, { bookType: 'xlsx', type: 'binary' })

    //downloadBlob(new Blob([s2ab(wbout_balances)], { type: "application/octet-stream" }), fileNameBalances + '.xlsx');
    const fundsAndAccountsBalancesBlob = new Blob([s2ab(wbout_balances)], { type: "application/octet-stream" });

    /////////////////////////////
    //GERANDO EXCEL DE TITULOS
    /////////////////////////////
    const wbTitles = XLSX.utils.book_new();
    const fileNameTitles = "Títulos " + year;
    wbTitles.Props = {
        Title: fileNameTitles,
        Author: "UNO",
    }

    wbTitles.SheetNames.push("Dados");
    wbTitles.SheetNames.push("Saldos");

    const ws_data_data_titles = [];

    ws_data_data_titles.push(['TÍTULO', 'COMPRA', 'VENCIMENTO', 'QUANTIDADE',
        'TAXA',
        'MARCAÇÃO',
    ])


    formattedTitlesBalancesInYear.forEach(title => {
        ws_data_data_titles.push([
            title.title_name,
            moment.utc(title.purchase_date).format("DD/MM/YYYY"),
            moment.utc(title.due_date).format("DD/MM/YYYY"),
            title.quantity_purchased,
            title.pre_tax && title.marking != MARKING_MARKET ? applyMaskAmount(title.pre_tax) + "%" : '',
            title.marking ?? "",
        ])

    });

    const ws_data_balances_titles = [];


    ws_data_balances_titles.push(['SEGREGAÇÃO', 'CC', 'TÍTULO', 'VENCIMENTO',
        'QUANTIDADE JAN',
        'VALOR JAN',
        'QUANTIDADE FEV',
        'VALOR FEV',
        'QUANTIDADE MAR',
        'VALOR MAR',
        'QUANTIDADE ABR',
        'VALOR ABR',
        'QUANTIDADE MAI',
        'VALOR MAI',
        'QUANTIDADE JUN',
        'VALOR JUN',
        'QUANTIDADE JUL',
        'VALOR JUL',
        'QUANTIDADE AGO',
        'VALOR AGO',
        'QUANTIDADE SET',
        'VALOR SET',
        'QUANTIDADE OUT',
        'VALOR OUT',
        'QUANTIDADE NOV',
        'VALOR NOV',
        'QUANTIDADE DEZ',
        'VALOR DEZ',
    ])

    formattedTitlesBalancesInYear.forEach(title => {

        const quotaAmount1 = title.yearValidation?.months[1]?.quota_amount != null ? parseFloat(title.yearValidation.months[1].quota_amount) : "";
        const quotaAmount2 = title.yearValidation?.months[2]?.quota_amount != null ? parseFloat(title.yearValidation.months[2].quota_amount) : "";
        const quotaAmount3 = title.yearValidation?.months[3]?.quota_amount != null ? parseFloat(title.yearValidation.months[3].quota_amount) : "";
        const quotaAmount4 = title.yearValidation?.months[4]?.quota_amount != null ? parseFloat(title.yearValidation.months[4].quota_amount) : "";
        const quotaAmount5 = title.yearValidation?.months[5]?.quota_amount != null ? parseFloat(title.yearValidation.months[5].quota_amount) : "";
        const quotaAmount6 = title.yearValidation?.months[6]?.quota_amount != null ? parseFloat(title.yearValidation.months[6].quota_amount) : "";
        const quotaAmount7 = title.yearValidation?.months[7]?.quota_amount != null ? parseFloat(title.yearValidation.months[7].quota_amount) : "";
        const quotaAmount8 = title.yearValidation?.months[8]?.quota_amount != null ? parseFloat(title.yearValidation.months[8].quota_amount) : "";
        const quotaAmount9 = title.yearValidation?.months[9]?.quota_amount != null ? parseFloat(title.yearValidation.months[9].quota_amount) : "";
        const quotaAmount10 = title.yearValidation?.months[10]?.quota_amount != null ? parseFloat(title.yearValidation.months[10].quota_amount) : "";
        const quotaAmount11 = title.yearValidation?.months[11]?.quota_amount != null ? parseFloat(title.yearValidation.months[11].quota_amount) : "";
        const quotaAmount12 = title.yearValidation?.months[12]?.quota_amount != null ? parseFloat(title.yearValidation.months[12].quota_amount) : "";


        ws_data_balances_titles.push([
            regimeMap[title.account_regime_id],
            applyMaskAccount(title.number_account),
            title.title_name,
            moment.utc(title.due_date).format("DD/MM/YYYY"),
            quotaAmount1 < 0 ? 0 : quotaAmount1,
            title.yearValidation?.months[1]?.balance ? applyMaskAmount(title.yearValidation.months[1].balance, true) : "",
            quotaAmount2 < 0 ? 0 : quotaAmount2,
            title.yearValidation?.months[2]?.balance ? applyMaskAmount(title.yearValidation.months[2].balance, true) : "",
            quotaAmount3 < 0 ? 0 : quotaAmount3,
            title.yearValidation?.months[3]?.balance ? applyMaskAmount(title.yearValidation.months[3].balance, true) : "",
            quotaAmount5 < 0 ? 0 : quotaAmount4,
            title.yearValidation?.months[4]?.balance ? applyMaskAmount(title.yearValidation.months[4].balance, true) : "",
            quotaAmount5 < 0 ? 0 : quotaAmount5,
            title.yearValidation?.months[5]?.balance ? applyMaskAmount(title.yearValidation.months[5].balance, true) : "",
            quotaAmount6 < 0 ? 0 : quotaAmount6,
            title.yearValidation?.months[6]?.balance ? applyMaskAmount(title.yearValidation.months[6].balance, true) : "",
            quotaAmount7 < 0 ? 0 : quotaAmount7,
            title.yearValidation?.months[7]?.balance ? applyMaskAmount(title.yearValidation.months[7].balance, true) : "",
            quotaAmount8 < 0 ? 0 : quotaAmount8,
            title.yearValidation?.months[8]?.balance ? applyMaskAmount(title.yearValidation.months[8].balance, true) : "",
            quotaAmount9 < 0 ? 0 : quotaAmount9,
            title.yearValidation?.months[9]?.balance ? applyMaskAmount(title.yearValidation.months[9].balance, true) : "",
            quotaAmount10 < 0 ? 0 : quotaAmount10,
            title.yearValidation?.months[10]?.balance ? applyMaskAmount(title.yearValidation.months[10].balance, true) : "",
            quotaAmount11 < 0 ? 0 : quotaAmount11,
            title.yearValidation?.months[11]?.balance ? applyMaskAmount(title.yearValidation.months[11].balance, true) : "",
            quotaAmount12 < 0 ? 0 : quotaAmount12,
            title.yearValidation?.months[12]?.balance ? applyMaskAmount(title.yearValidation.months[12].balance, true) : "",
        ])
    });

    const ws_data_titles = XLSX.utils.aoa_to_sheet(ws_data_data_titles);
    const ws_balances_titles = XLSX.utils.aoa_to_sheet(ws_data_balances_titles);

    wbTitles.Sheets["Dados"] = ws_data_titles;
    wbTitles.Sheets["Saldos"] = ws_balances_titles;
    const wbout_titles = XLSX.write(wbTitles, { bookType: 'xlsx', type: 'binary' })

    //downloadBlob(new Blob([s2ab(wbout_titles)], { type: "application/octet-stream" }), fileNameTitles + '.xlsx');
    const titlesBlob = new Blob([s2ab(wbout_titles)], { type: "application/octet-stream" });


    // Nome dos arquivos dentro do ZIP
    const fileName1 = fileNameMovs + '.xlsx';
    const fileName2 = fileNameBalances + '.xlsx';
    const fileName3 = fileNameTitles + '.xlsx';

    // Crie uma nova instância de JSZip
    const zip = new JSZip();

    // Adicione os blobs ao ZIP
    zip.file(fileName1, movsBlob);
    zip.file(fileName2, fundsAndAccountsBalancesBlob);
    zip.file(fileName3, titlesBlob);

    // Gera o arquivo ZIP como um blob
    zip.generateAsync({ type: "blob" })
        .then(function (content) {
            // Crie um link para download do ZIP
            const link = document.createElement("a");
            link.href = URL.createObjectURL(content);
            link.download = `Base_de_dados_[${clientLabelName}]_` + year + ".zip";
            link.click();
        })
        .catch(function (err) {
            console.error("Erro ao gerar o arquivo ZIP:", err);
        });

}

export async function getDataSuitabilityReport() {

    const responseActiveQuestionary = await SuitabilitiesAPI.getActiveSuitabilitieQuestionary();
    if (responseActiveQuestionary.success && responseActiveQuestionary.body.rows.length == 1) {
        return {
            success: true,
            data: responseActiveQuestionary.body.rows[0]
        }
    }

    return {
        success: false,

    }
}